(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3560],{

/***/ 5813:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6944), __webpack_require__(54402), __webpack_require__(54950), __webpack_require__(97218), __webpack_require__(89293), __webpack_require__(58064), __webpack_require__(93120), __webpack_require__(41545), __webpack_require__(92426), __webpack_require__(53416)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _asyncToGenerator2, _defineProperty2, _axios, _request, _users, _inapp, _constants, _utils, _config) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.initialize = initialize;
  _exports.initializeWithConfig = initializeWithConfig;
  _regenerator = _interopRequireDefault(_regenerator);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _axios = _interopRequireDefault(_axios);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable */
  var MAX_TIMEOUT = _utils.ONE_DAY;
  var doesRequestUrlContain = function doesRequestUrlContain(routeConfig) {
    return Object.entries(_constants.ENDPOINTS).some(function (entry) {
      return routeConfig.route === entry[1].route && routeConfig.body === entry[1].body && routeConfig.current === entry[1].current && routeConfig.nestedUser === entry[1].nestedUser;
    });
  };
  function initialize(authToken, generateJWT) {
    var logLevel = _config.config.getConfig('logLevel');
    if (!generateJWT && _constants.IS_PRODUCTION) {
      /* only let people use non-JWT mode if running the app locally */
      if (logLevel === 'verbose') {
        return console.error('Please provide a Promise method for generating a JWT token.');
      }
      return;
    }

    /*
      only set token interceptor if we're using a non-JWT key.
      Otherwise, we'll set it later once we generate the JWT
    */
    var authInterceptor = generateJWT ? null : _request.baseAxiosRequest.interceptors.request.use(function (config) {
      config.headers.set('Api-Key', authToken);
      return config;
    });
    var userInterceptor = null;
    var responseInterceptor = null;
    /*
      AKA did the user auth with their email (setEmail) or user ID (setUserID)
       we're going to use this variable for one circumstance - when calling _updateUserEmail_.
      Essentially, when we call the Iterable API to update a user's email address and we get a
      successful 200 request, we're going to request a new JWT token, since it might need to
      be re-signed with the new email address; however, if the customer code never authorized the
      user with an email and instead a user ID, we'll just continue to sign the JWT with the user ID.
       This is mainly just a quality-of-life feature, so that the customer's JWT generation code
      doesn't _need_ to support email-signed JWTs if they don't want and purely want to issue the
      tokens by user ID.
    */
    var typeOfAuth = null;
    /* this will be the literal user ID or email they choose to auth with */
    var authIdentifier = null;

    /**
      method that sets a timer one minute before JWT expiration
       @param { string } jwt - JWT token to decode
      @param { (...args: any ) => Promise<any> } callback - promise to invoke before expiry
    */
    var createTokenExpirationTimer = function createTokenExpirationTimer() {
      var timer;
      return function (jwt, callback) {
        if (timer) {
          /* clear existing timeout on JWT refresh */
          clearTimeout(timer);
          timer = null;
        }
        if (callback) {
          var expTime = (0, _utils.getEpochExpiryTimeInMS)(jwt);
          var millisecondsToExpired = (0, _utils.getEpochDifferenceInMS)(Date.now(), expTime);
          if ((0, _utils.validateTokenTime)(millisecondsToExpired)) {
            return console.warn('Could not refresh JWT. Try generating the token again.');
          }
          if (millisecondsToExpired < MAX_TIMEOUT) {
            timer = setTimeout(function () {
              return /* get new token */(
                callback()["catch"](function (e) {
                  console.warn(e);
                  console.warn('Could not refresh JWT. Try identifying the user again.');
                })
              );
            }, /* try to refresh one minute until expiry */
            millisecondsToExpired - _utils.ONE_MINUTE);
          }
        }
      };
    };
    var handleTokenExpiration = createTokenExpirationTimer();
    var addEmailToRequest = function addEmailToRequest(email) {
      userInterceptor = _request.baseAxiosRequest.interceptors.request.use(function (config) {
        var _config$url, _config$url2, _config$url3, _config$url4;
        /*
          endpoints that use _currentEmail_ payload prop in POST/PUT requests
        */
        if (doesRequestUrlContain({
          route: (_config$url = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url !== void 0 ? _config$url : '',
          body: true,
          current: true,
          nestedUser: true
        })) {
          return _objectSpread(_objectSpread({}, config), {}, {
            data: _objectSpread(_objectSpread({}, config.data || {}), {}, {
              currentEmail: email
            })
          });
        }

        /*
          endpoints that use _email_ payload prop in POST/PUT requests
        */
        if (doesRequestUrlContain({
          route: (_config$url2 = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url2 !== void 0 ? _config$url2 : '',
          body: true,
          current: false,
          nestedUser: false
        })) {
          return _objectSpread(_objectSpread({}, config), {}, {
            data: _objectSpread(_objectSpread({}, config.data || {}), {}, {
              email: email
            })
          });
        }

        /*
          endpoints that use _userId_ payload prop in POST/PUT requests nested in { user: {} }
        */
        if (doesRequestUrlContain({
          route: (_config$url3 = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url3 !== void 0 ? _config$url3 : '',
          body: true,
          current: false,
          nestedUser: true
        })) {
          return _objectSpread(_objectSpread({}, config), {}, {
            data: _objectSpread(_objectSpread({}, config.data || {}), {}, {
              user: _objectSpread(_objectSpread({}, config.data.user || {}), {}, {
                email: email
              })
            })
          });
        }

        /*
          endpoints that use _email_ query param in GET requests
        */

        if (doesRequestUrlContain({
          route: (_config$url4 = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url4 !== void 0 ? _config$url4 : '',
          body: false,
          current: false,
          nestedUser: false
        })) {
          return _objectSpread(_objectSpread({}, config), {}, {
            params: _objectSpread(_objectSpread({}, config.params || {}), {}, {
              email: email
            })
          });
        }
        return config;
      });
    };
    if (!generateJWT) {
      /* we want to set a normal non-JWT enabled API key */
      return {
        setNewAuthToken: function setNewAuthToken(newToken) {
          if (typeof authInterceptor === 'number') {
            /* clear previously cached interceptor function */
            _request.baseAxiosRequest.interceptors.request.eject(authInterceptor);
          }
          authInterceptor = _request.baseAxiosRequest.interceptors.request.use(function (config) {
            config.headers.set('Api-Key', newToken);
            return config;
          });
        },
        clearAuthToken: function clearAuthToken() {
          /* might be 0 which is a falsy value */
          if (typeof authInterceptor === 'number') {
            /* clear previously cached interceptor function */
            _request.baseAxiosRequest.interceptors.request.eject(authInterceptor);
          }
        },
        setEmail: function setEmail(email) {
          typeOfAuth = 'email';
          authIdentifier = email;
          localStorage.setItem(_constants.SHARED_PREF_EMAIL, email);
          (0, _inapp.clearMessages)();
          if (typeof userInterceptor === 'number') {
            _request.baseAxiosRequest.interceptors.request.eject(userInterceptor);
          }

          /*
            endpoints that use _currentEmail_ payload prop in POST/PUT requests
          */
          addEmailToRequest(email);
        },
        setUserID: function () {
          var _setUserID = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(userId) {
            var tryUser;
            return _regenerator["default"].wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  typeOfAuth = 'userID';
                  authIdentifier = userId;
                  localStorage.setItem(_constants.SHARED_PREF_USER_ID, userId);
                  (0, _inapp.clearMessages)();
                  if (typeof userInterceptor === 'number') {
                    _request.baseAxiosRequest.interceptors.request.eject(userInterceptor);
                  }

                  /*
                    endpoints that use _currentUserId payload prop in POST/PUT requests nested in { user: {} }
                  */
                  userInterceptor = _request.baseAxiosRequest.interceptors.request.use(function (config) {
                    var _config$url5, _config$url6, _config$url7, _config$url8;
                    if (doesRequestUrlContain({
                      route: (_config$url5 = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url5 !== void 0 ? _config$url5 : '',
                      body: true,
                      current: true,
                      nestedUser: true
                    })) {
                      return _objectSpread(_objectSpread({}, config), {}, {
                        data: _objectSpread(_objectSpread({}, config.data || {}), {}, {
                          currentUserId: userId
                        })
                      });
                    }

                    /*
                      endpoints that use _userId_ payload prop in POST/PUT requests
                    */
                    if (doesRequestUrlContain({
                      route: (_config$url6 = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url6 !== void 0 ? _config$url6 : '',
                      body: true,
                      current: false,
                      nestedUser: false
                    })) {
                      return _objectSpread(_objectSpread({}, config), {}, {
                        data: _objectSpread(_objectSpread({}, config.data || {}), {}, {
                          userId: userId
                        })
                      });
                    }

                    /*
                      endpoints that use _userId_ payload prop in POST/PUT requests nested in { user: {} }
                    */
                    if (doesRequestUrlContain({
                      route: (_config$url7 = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url7 !== void 0 ? _config$url7 : '',
                      body: true,
                      current: false,
                      nestedUser: true
                    })) {
                      return _objectSpread(_objectSpread({}, config), {}, {
                        data: _objectSpread(_objectSpread({}, config.data || {}), {}, {
                          user: _objectSpread(_objectSpread({}, config.data.user || {}), {}, {
                            userId: userId
                          })
                        })
                      });
                    }

                    /*
                      endpoints that use _userId_ query param in GET requests
                    */
                    if (doesRequestUrlContain({
                      route: (_config$url8 = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url8 !== void 0 ? _config$url8 : '',
                      body: false,
                      current: false,
                      nestedUser: false
                    })) {
                      return _objectSpread(_objectSpread({}, config), {}, {
                        params: _objectSpread(_objectSpread({}, config.params || {}), {}, {
                          userId: userId
                        })
                      });
                    }
                    return config;
                  });
                  tryUser = function tryUser() {
                    var createUserAttempts = 0;
                    return /*#__PURE__*/function () {
                      var _tryUserNTimes = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
                        return _regenerator["default"].wrap(function _callee$(_context) {
                          while (1) switch (_context.prev = _context.next) {
                            case 0:
                              _context.prev = 0;
                              _context.next = 3;
                              return (0, _users.updateUser)({});
                            case 3:
                              return _context.abrupt("return", _context.sent);
                            case 6:
                              _context.prev = 6;
                              _context.t0 = _context["catch"](0);
                              if (!(createUserAttempts < _constants.RETRY_USER_ATTEMPTS)) {
                                _context.next = 11;
                                break;
                              }
                              createUserAttempts += 1;
                              return _context.abrupt("return", tryUserNTimes());
                            case 11:
                              return _context.abrupt("return", Promise.reject("could not create user after ".concat(createUserAttempts, " tries")));
                            case 12:
                            case "end":
                              return _context.stop();
                          }
                        }, _callee, null, [[0, 6]]);
                      }));
                      function tryUserNTimes() {
                        return _tryUserNTimes.apply(this, arguments);
                      }
                      return tryUserNTimes;
                    }();
                  };
                  _context2.prev = 7;
                  _context2.next = 10;
                  return tryUser()();
                case 10:
                  return _context2.abrupt("return", _context2.sent);
                case 13:
                  _context2.prev = 13;
                  _context2.t0 = _context2["catch"](7);
                  return _context2.abrupt("return", Promise.resolve());
                case 16:
                case "end":
                  return _context2.stop();
              }
            }, _callee2, null, [[7, 13]]);
          }));
          function setUserID(_x) {
            return _setUserID.apply(this, arguments);
          }
          return setUserID;
        }(),
        logout: function logout() {
          typeOfAuth = null;
          authIdentifier = null;
          /* clear fetched in-app messages */
          (0, _inapp.clearMessages)();
          if (typeof authInterceptor === 'number') {
            /* stop adding auth token to requests */
            _request.baseAxiosRequest.interceptors.request.eject(authInterceptor);
          }
          if (typeof userInterceptor === 'number') {
            /* stop adding JWT to requests */
            _request.baseAxiosRequest.interceptors.request.eject(userInterceptor);
          }
        }
      };
    }

    /*
      We're using a JWT enabled API key
      callback is assumed to be some sort of GET /api/generate-jwt
    */
    var doRequest = function doRequest(payload) {
      /* clear any token interceptor if any exists */
      if (typeof authInterceptor === 'number') {
        _request.baseAxiosRequest.interceptors.request.eject(authInterceptor);
      }
      if (typeof responseInterceptor === 'number') {
        _request.baseAxiosRequest.interceptors.response.eject(responseInterceptor);
      }
      return generateJWT(payload).then(function (token) {
        /* set JWT token and auth token headers */
        authInterceptor = _request.baseAxiosRequest.interceptors.request.use(function (config) {
          if (config !== null && config !== void 0 && config.sendBeacon) {
            /*
              send fetch request instead solely so we can use the "keepalive" flag.
              This is used purely for one use-case only - when the user clicks a link
              that is going to navigate the browser tab to a new page/site and we need
              to still call POST /trackInAppClick.
               Normally, since the page is going somewhere new, the browser would just navigate away
              and cancel any in-flight requests and not fulfill them, but with the fetch API's
              "keepalive" flag, it will continue the request without blocking the main thread.
               We can't do this with Axios because it's built upon XHR and that doesn't support
              "keepalive" so we fall back to the fetch API
            */
            var cancelConfig = (0, _utils.cancelAxiosRequestAndMakeFetch)(config, {
              email: payload.email,
              userID: payload.userID
            }, token, authToken);
            return cancelConfig;
          }
          config.headers.set('Api-Key', authToken);
          config.headers.set('Authorization', "Bearer ".concat(token));
          return config;
        });
        responseInterceptor = _request.baseAxiosRequest.interceptors.response.use(function (config) {
          var _config$config$url, _config$config;
          if (doesRequestUrlContain({
            route: (_config$config$url = config === null || config === void 0 ? void 0 : (_config$config = config.config) === null || _config$config === void 0 ? void 0 : _config$config.url) !== null && _config$config$url !== void 0 ? _config$config$url : '',
            body: true,
            current: true,
            nestedUser: true
          })) {
            try {
              var _JSON$parse;
              /*
                if the customer just called the POST /users/updateEmail
                that means their JWT needs to be updated to include this new
                email as well, so we run their JWT generation method and
                set a new token on the axios interceptor
              */
              var newEmail = (_JSON$parse = JSON.parse(config.config.data)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.newEmail;
              var payloadToPass = typeOfAuth === 'email' ? {
                email: newEmail
              } : {
                userID: authIdentifier
              };
              return generateJWT(payloadToPass).then(function (newToken) {
                /*
                  clear any existing interceptors that are adding user info
                  or API keys
                */
                if (typeof authInterceptor === 'number') {
                  /* stop adding auth token to requests */
                  _request.baseAxiosRequest.interceptors.request.eject(authInterceptor);
                }
                if (typeof userInterceptor === 'number') {
                  /* stop adding JWT to requests */
                  _request.baseAxiosRequest.interceptors.request.eject(userInterceptor);
                }

                /* add the new JWT to all outgoing requests */
                authInterceptor = _request.baseAxiosRequest.interceptors.request.use(function (config) {
                  if (config !== null && config !== void 0 && config.sendBeacon) {
                    /*
                      send fetch request instead solely so we can use the "keepalive" flag.
                      This is used purely for one use-case only - when the user clicks a link
                      that is going to navigate the browser tab to a new page/site and we need
                      to still call POST /trackInAppClick.
                       Normally, since the page is going somewhere new, the browser would just
                      navigate away and cancel any in-flight requests and not fulfill them,
                      but with the fetch API's "keepalive" flag, it will continue the request
                      without blocking the main thread.
                       We can't do this with Axios because it's built upon XHR and that
                      doesn't support "keepalive" so we fall back to the fetch API
                    */
                    return (0, _utils.cancelAxiosRequestAndMakeFetch)(config, {
                      email: newEmail
                    }, newToken, authToken);
                  }
                  config.headers.set('Api-Key', authToken);
                  config.headers.set('Authorization', "Bearer ".concat(newToken));
                  return config;
                });

                /* add the new email to all outgoing requests  */
                addEmailToRequest(newEmail);

                /*
                  set up a new timer for when the JWT expires to regenerate
                  a new one encoded with the new email address.
                */

                /*
                  important here to clear the timer first since there was one set up
                  previously the first time the JWT was generated.
                   handleTokenExpiration will clear the timeout for us.
                */
                handleTokenExpiration(newToken, function () {
                  return /* re-run the JWT generation */(
                    doRequest(payloadToPass)["catch"](function (e) {
                      console.warn(e);
                      console.warn('Could not refresh JWT. Try identifying the user again.');
                    })
                  );
                });
                return config;
              });
            } catch (_unused) {
              return config;
            }
          }
          return config;
        }, function (error) {
          var _error$response;
          /*
            adds a status code 401 callback to try and get a new JWT
            key if the Iterable API told us the JWT is invalid.
          */
          if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401) {
            return generateJWT(payload).then(function (newToken) {
              if (authInterceptor) {
                _request.baseAxiosRequest.interceptors.request.eject(authInterceptor);
              }
              authInterceptor = _request.baseAxiosRequest.interceptors.request.use(function (config) {
                if (config !== null && config !== void 0 && config.sendBeacon) {
                  /*
                    send fetch request instead solely so we can use the "keepalive" flag.
                    This is used purely for one use-case only - when the user clicks a link
                    that is going to navigate the browser tab to a new page/site and we need
                    to still call POST /trackInAppClick.
                     Normally, since the page is going somewhere new, the browser would just
                    navigate away and cancel any in-flight requests and not fulfill
                    them, but with the fetch API's "keepalive" flag, it will continue
                    the request without blocking the main thread.
                     We can't do this with Axios because it's built upon XHR and that
                    doesn't support "keepalive" so we fall back to the fetch API
                  */
                  return (0, _utils.cancelAxiosRequestAndMakeFetch)(config, {
                    email: payload.email,
                    userID: payload.userID
                  }, newToken, authToken);
                }
                config.headers.set('Api-Key', authToken);
                config.headers.set('Authorization', "Bearer ".concat(newToken));
                return config;
              });

              /*
                finally, after the new JWT is generated, try the original
                request that failed again.
              */
              return (0, _axios["default"])(_objectSpread(_objectSpread({}, error.config), {}, {
                headers: _objectSpread(_objectSpread(_objectSpread({}, error.config.headers), _constants.STATIC_HEADERS), {}, {
                  'Api-Key': authToken,
                  Authorization: "Bearer ".concat(newToken)
                })
              }));
            })["catch"](function (e) {
              return (
                /*
                  if the JWT generation failed,
                  just abort with a Promise rejection.
                */
                Promise.reject(e)
              );
            });
          }
          return Promise.reject(error);
        });
        handleTokenExpiration(token, function () {
          return /* re-run the JWT generation */(
            doRequest(payload)["catch"](function (e) {
              if (logLevel === 'verbose') {
                console.warn(e);
                console.warn('Could not refresh JWT. Try identifying the user again.');
              }
            })
          );
        });
        return token;
      })["catch"](function (error) {
        /* clear interceptor */
        if (typeof authInterceptor === 'number') {
          _request.baseAxiosRequest.interceptors.request.eject(authInterceptor);
        }
        return Promise.reject(error);
      });
    };
    return {
      clearRefresh: function clearRefresh() {
        /* this will just clear the existing timeout */
        handleTokenExpiration('');
      },
      setEmail: function setEmail(email) {
        typeOfAuth = 'email';
        authIdentifier = email;
        localStorage.setItem(_constants.SHARED_PREF_EMAIL, email);
        /* clear previous user */
        (0, _inapp.clearMessages)();
        if (typeof userInterceptor === 'number') {
          _request.baseAxiosRequest.interceptors.request.eject(userInterceptor);
        }
        addEmailToRequest(email);
        return doRequest({
          email: email
        })["catch"](function (e) {
          if (logLevel === 'verbose') {
            console.warn('Could not generate JWT after calling setEmail. Please try calling setEmail again.');
          }
          return Promise.reject(e);
        });
      },
      setUserID: function () {
        var _setUserID2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(userId) {
          var tryUser;
          return _regenerator["default"].wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                typeOfAuth = 'userID';
                authIdentifier = userId;
                localStorage.setItem(_constants.SHARED_PREF_USER_ID, userId);
                (0, _inapp.clearMessages)();
                if (typeof userInterceptor === 'number') {
                  _request.baseAxiosRequest.interceptors.request.eject(userInterceptor);
                }

                /*
                  endpoints that use _currentUserId_ payload prop in POST/PUT requests nested in user object
                */
                userInterceptor = _request.baseAxiosRequest.interceptors.request.use(function (config) {
                  var _config$url9, _config$url10, _config$url11, _config$url12;
                  if (doesRequestUrlContain({
                    route: (_config$url9 = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url9 !== void 0 ? _config$url9 : '',
                    body: true,
                    current: true,
                    nestedUser: true
                  })) {
                    return _objectSpread(_objectSpread({}, config), {}, {
                      data: _objectSpread(_objectSpread({}, config.data || {}), {}, {
                        currentUserId: userId
                      })
                    });
                  }

                  /*
                    endpoints that use _serId_ payload prop in POST/PUT requests
                  */
                  if (doesRequestUrlContain({
                    route: (_config$url10 = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url10 !== void 0 ? _config$url10 : '',
                    body: true,
                    current: false,
                    nestedUser: false
                  })) {
                    return _objectSpread(_objectSpread({}, config), {}, {
                      data: _objectSpread(_objectSpread({}, config.data || {}), {}, {
                        userId: userId
                      })
                    });
                  }

                  /*
                    endpoints that use _userId_ payload prop in POST/PUT requests nested in { user: {} }
                  */
                  if (doesRequestUrlContain({
                    route: (_config$url11 = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url11 !== void 0 ? _config$url11 : '',
                    body: true,
                    current: false,
                    nestedUser: true
                  })) {
                    return _objectSpread(_objectSpread({}, config), {}, {
                      data: _objectSpread(_objectSpread({}, config.data || {}), {}, {
                        user: _objectSpread(_objectSpread({}, config.data.user || {}), {}, {
                          userId: userId
                        })
                      })
                    });
                  }

                  /*
                    endpoints that use _userId_ query param in GET requests
                  */
                  if (doesRequestUrlContain({
                    route: (_config$url12 = config === null || config === void 0 ? void 0 : config.url) !== null && _config$url12 !== void 0 ? _config$url12 : '',
                    body: false,
                    current: false,
                    nestedUser: false
                  })) {
                    return _objectSpread(_objectSpread({}, config), {}, {
                      params: _objectSpread(_objectSpread({}, config.params || {}), {}, {
                        userId: userId
                      })
                    });
                  }
                  return config;
                });
                tryUser = function tryUser() {
                  var createUserAttempts = 0;
                  return /*#__PURE__*/function () {
                    var _tryUserNTimes2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
                      return _regenerator["default"].wrap(function _callee3$(_context3) {
                        while (1) switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return (0, _users.updateUser)({});
                          case 3:
                            return _context3.abrupt("return", _context3.sent);
                          case 6:
                            _context3.prev = 6;
                            _context3.t0 = _context3["catch"](0);
                            if (!(createUserAttempts < _constants.RETRY_USER_ATTEMPTS)) {
                              _context3.next = 11;
                              break;
                            }
                            createUserAttempts += 1;
                            return _context3.abrupt("return", tryUserNTimes());
                          case 11:
                            return _context3.abrupt("return", Promise.reject("could not create user after ".concat(createUserAttempts, " tries")));
                          case 12:
                          case "end":
                            return _context3.stop();
                        }
                      }, _callee3, null, [[0, 6]]);
                    }));
                    function tryUserNTimes() {
                      return _tryUserNTimes2.apply(this, arguments);
                    }
                    return tryUserNTimes;
                  }();
                };
                return _context5.abrupt("return", doRequest({
                  userID: userId
                }).then( /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(token) {
                    return _regenerator["default"].wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return tryUser()();
                        case 2:
                          return _context4.abrupt("return", token);
                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4);
                  }));
                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }())["catch"](function (e) {
                  if (logLevel === 'verbose') {
                    console.warn('Could not generate JWT after calling setUserID. Please try calling setUserID again.');
                  }
                  return Promise.reject(e);
                }));
              case 8:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function setUserID(_x2) {
          return _setUserID2.apply(this, arguments);
        }
        return setUserID;
      }(),
      logout: function logout() {
        typeOfAuth = null;
        authIdentifier = null;
        /* clear fetched in-app messages */
        (0, _inapp.clearMessages)();

        /* this will just clear the existing timeout */
        handleTokenExpiration('');
        if (typeof authInterceptor === 'number') {
          /* stop adding auth token to requests */
          _request.baseAxiosRequest.interceptors.request.eject(authInterceptor);
        }
        if (typeof userInterceptor === 'number') {
          /* stop adding JWT to requests */
          _request.baseAxiosRequest.interceptors.request.eject(userInterceptor);
        }
      },
      refreshJwtToken: function () {
        var _refreshJwtToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(user) {
          var payloadToPass;
          return _regenerator["default"].wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                /* this will just clear the existing timeout */
                handleTokenExpiration('');
                payloadToPass = (0, _defineProperty2["default"])({}, (0, _utils.isEmail)(user) ? 'email' : 'userID', user);
                return _context6.abrupt("return", doRequest(payloadToPass)["catch"](function (e) {
                  if (logLevel === 'verbose') {
                    console.warn(e);
                    console.warn('Could not refresh JWT. Try Refresh the JWT again.');
                  }
                }));
              case 3:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        function refreshJwtToken(_x4) {
          return _refreshJwtToken.apply(this, arguments);
        }
        return refreshJwtToken;
      }()
    };
  }
  function initializeWithConfig(initializeParams) {
    var authToken = initializeParams.authToken,
      configOptions = initializeParams.configOptions,
      generateJWT = initializeParams.generateJWT;
    _config.config.setConfig(configOptions !== null && configOptions !== void 0 ? configOptions : {});
    return generateJWT ? initialize(authToken, generateJWT) : initialize(authToken);
  }
});

/***/ }),

/***/ 92426:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(54950), __webpack_require__(48764), __webpack_require__(97218)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _buffer, _axios) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.validateTokenTime = _exports.isEmail = _exports.getEpochExpiryTimeInMS = _exports.getEpochDifferenceInMS = _exports.cancelAxiosRequestAndMakeFetch = _exports.ONE_YEAR = _exports.ONE_SECOND = _exports.ONE_MINUTE = _exports.ONE_HOUR = _exports.ONE_DAY = _exports.EMAIL_REGEX = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _axios = _interopRequireDefault(_axios);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var ONE_SECOND = _exports.ONE_SECOND = 1000;
  var ONE_MINUTE = _exports.ONE_MINUTE = 60 * ONE_SECOND;
  var ONE_HOUR = _exports.ONE_HOUR = 60 * ONE_MINUTE;
  var ONE_DAY = _exports.ONE_DAY = 24 * ONE_HOUR;
  var ONE_YEAR = _exports.ONE_YEAR = 365 * ONE_DAY;
  var EMAIL_REGEX = _exports.EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var MS_EPOCH_THRESHOLD = ONE_YEAR;
  var getEpochExpiryTimeInMS = _exports.getEpochExpiryTimeInMS = function getEpochExpiryTimeInMS(jwt) {
    /** @thanks https://stackoverflow.com/a/38552302/7455960  */
    try {
      var _jwt$split, _JSON$parse;
      var base64Url = (_jwt$split = jwt.split('.')) === null || _jwt$split === void 0 ? void 0 : _jwt$split[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(_buffer.Buffer.from(base64, 'base64').toString().split('').map(function (character) {
        return "%".concat("00".concat(character.charCodeAt(0).toString(16)).slice(-2));
      }).join(''));
      var expTime = (_JSON$parse = JSON.parse(jsonPayload)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.exp;
      return expTime < MS_EPOCH_THRESHOLD ? expTime * ONE_SECOND : expTime;
    } catch (_unused) {
      return 0;
    }
  };

  /*
    take two epoch timestamps and diff them and return them in MS.
    Also tries to convert seconds to MS if needed (since some server languages like
    python deal with time in seconds).
  */
  var getEpochDifferenceInMS = _exports.getEpochDifferenceInMS = function getEpochDifferenceInMS(epochNow, epochFuture) {
    var parsedNow = epochNow;
    var parsedFuture = epochFuture;
    if (epochNow < MS_EPOCH_THRESHOLD) {
      /* convert to MS if in seconds */
      parsedNow = epochNow * ONE_SECOND;
    }
    if (epochFuture < MS_EPOCH_THRESHOLD) {
      /* convert to MS if in seconds */
      parsedFuture = epochFuture * ONE_SECOND;
    }
    return parsedFuture - parsedNow;
  };
  var cancelAxiosRequestAndMakeFetch = _exports.cancelAxiosRequestAndMakeFetch = function cancelAxiosRequestAndMakeFetch(config, _ref, jwtToken, authToken) {
    var email = _ref.email,
      userID = _ref.userID;
    /*
      send fetch request instead solely so we can use the "keepalive" flag.
      This is used purely for one use-case only - when the user clicks a link
      that is going to navigate the browser tab to a new page/site and we need
      to still call POST /trackInAppClick.
       Normally, since the page is going somewhere new, the browser would just
      navigate away and cancel any in-flight requests and not fulfill them,
      but with the fetch API's "keepalive" flag, it will continue the request
      without blocking the main thread.
       We can't do this with Axios because it's built upon XHR and that
      doesn't support "keepalive" so we fall back to the fetch API
    */
    var additionalData = email ? {
      email: email
    } : {
      userId: userID
    };
    fetch("".concat(config.baseURL).concat(config.url), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Api-Key': authToken,
        Authorization: "Bearer ".concat(jwtToken)
      },
      body: JSON.stringify(_objectSpread(_objectSpread({}, config === null || config === void 0 ? void 0 : config.data), additionalData) || {}),
      keepalive: true
    })["catch"]();

    /* cancel the axios request */
    // eslint-disable-next-line no-param-reassign
    config.cancelToken = new _axios["default"].CancelToken(function (cancel) {
      cancel('Cancel repeated request');
    });
    return config;
  };
  var validateTokenTime = _exports.validateTokenTime = function validateTokenTime(expTime) {
    var isValid = expTime < ONE_MINUTE;
    return isValid;
  };
  var isEmail = _exports.isEmail = function isEmail(email) {
    return EMAIL_REGEX.test(email);
  };
});

/***/ }),

/***/ 41545:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.dangerouslyAllowJsPopupExecution = _exports.WEB_PLATFORM = _exports.URL_SCHEME_OPEN = _exports.URL_SCHEME_ITBL = _exports.URL_SCHEME_ACTION = _exports.STATIC_HEADERS = _exports.SHARED_PREF_USER_ID = _exports.SHARED_PREF_EMAIL = _exports.SDK_VERSION = _exports.RETRY_USER_ATTEMPTS = _exports.IS_PRODUCTION = _exports.GETMESSAGES_PATH = _exports.EU_ITERABLE_API = _exports.ENDPOINTS = _exports.ENABLE_INAPP_CONSUME = _exports.DISPLAY_INTERVAL_DEFAULT = _exports.DEFAULT_CLOSE_BUTTON_OFFSET_PERCENTAGE = _exports.CLOSE_X_BUTTON_ID = _exports.BASE_URL = _exports.ANIMATION_STYLESHEET = _exports.ANIMATION_DURATION = _exports.ABSOLUTE_DISMISS_BUTTON_ID = void 0;
  /* number of MS to wait between in-app messages to show the next one */
  var DISPLAY_INTERVAL_DEFAULT = _exports.DISPLAY_INTERVAL_DEFAULT = 30000;

  /* how many times we try to create a new user when _setUserID_ is invoked */
  var RETRY_USER_ATTEMPTS = _exports.RETRY_USER_ATTEMPTS = 0;
  var IS_EU_ITERABLE_SERVICE = process.env.IS_EU_ITERABLE_SERVICE === 'true';
  var dangerouslyAllowJsPopupExecution = _exports.dangerouslyAllowJsPopupExecution = process.env.DANGEROUSLY_ALLOW_JS_POPUP_EXECUTION === 'true';
  var US_ITERABLE_DOMAIN = 'api.iterable.com';
  var EU_ITERABLE_DOMAIN = 'api.eu.iterable.com';
  var ITERABLE_API_URL = "https://".concat(IS_EU_ITERABLE_SERVICE ? EU_ITERABLE_DOMAIN : US_ITERABLE_DOMAIN, "/api");
  var EU_ITERABLE_API = _exports.EU_ITERABLE_API = "https://".concat(EU_ITERABLE_DOMAIN, "/api");

  // Do not set `process.env.BASE_URL` if intending on using the prod or EU APIs.
  var BASE_URL = _exports.BASE_URL = process.env.BASE_URL || ITERABLE_API_URL;
  var GETMESSAGES_PATH = _exports.GETMESSAGES_PATH = '/inApp/web/getMessages';
  var GET_ENABLE_INAPP_CONSUME = function GET_ENABLE_INAPP_CONSUME() {
    try {
      return JSON.parse(process.env.ENABLE_INAPP_CONSUME);
    } catch (_unused) {
      return true;
    }
  };
  var ENABLE_INAPP_CONSUME = _exports.ENABLE_INAPP_CONSUME = GET_ENABLE_INAPP_CONSUME();
  var IS_PRODUCTION = _exports.IS_PRODUCTION = "production" === 'production';
  var SDK_VERSION = _exports.SDK_VERSION = process.env.VERSION;

  /*
    API payload _platform_ param which is send up automatically
    with tracking and getMessage requests
  */
  var WEB_PLATFORM = _exports.WEB_PLATFORM = 'Web';

  /** @todo uncomment when these headers don't give CORS errors */
  var STATIC_HEADERS = _exports.STATIC_HEADERS = {
    // 'SDK-Version': SDK_VERSION,
    // 'SDK-Platform': WEB_PLATFORM
  };

  /* how long animations fade/side in for. */
  var ANIMATION_DURATION = _exports.ANIMATION_DURATION = 400;
  var DEFAULT_CLOSE_BUTTON_OFFSET_PERCENTAGE = _exports.DEFAULT_CLOSE_BUTTON_OFFSET_PERCENTAGE = 4;
  var CLOSE_X_BUTTON_ID = _exports.CLOSE_X_BUTTON_ID = 'close-x-button';
  var ABSOLUTE_DISMISS_BUTTON_ID = _exports.ABSOLUTE_DISMISS_BUTTON_ID = 'absolute-dismiss-button';
  var URL_SCHEME_ITBL = _exports.URL_SCHEME_ITBL = 'itbl://';
  var URL_SCHEME_ACTION = _exports.URL_SCHEME_ACTION = 'action://';
  var URL_SCHEME_OPEN = _exports.URL_SCHEME_OPEN = 'openUrl';
  var SHARED_PREF_USER_ID = _exports.SHARED_PREF_USER_ID = 'userId';
  var SHARED_PREF_EMAIL = _exports.SHARED_PREF_EMAIL = 'email';
  var ENDPOINTS = _exports.ENDPOINTS = {
    commerce_update_cart: {
      route: '/commerce/updateCart',
      body: true,
      current: false,
      nestedUser: true
    },
    commerce_track_purchase: {
      route: '/commerce/trackPurchase',
      body: true,
      current: false,
      nestedUser: true
    },
    update_email: {
      route: '/users/updateEmail',
      body: true,
      current: true,
      nestedUser: true
    },
    users_update: {
      route: '/users/update',
      body: true,
      current: false,
      nestedUser: false
    },
    users_update_subscriptions: {
      route: '/users/updateSubscriptions',
      body: true,
      current: false,
      nestedUser: false
    },
    get_in_app_messages: {
      route: '/inApp/web/getMessages',
      body: false,
      current: false,
      nestedUser: false
    },
    get_embedded_messages: {
      route: '/embedded-messaging/messages',
      body: false,
      current: false,
      nestedUser: false
    },
    event_track: {
      route: '/events/track',
      body: true,
      current: false,
      nestedUser: false
    },
    msg_received_event_track: {
      route: '/embedded-messaging/events/received',
      body: true,
      current: false,
      nestedUser: false
    },
    msg_click_event_track: {
      route: '/embedded-messaging/events/click',
      body: true,
      current: false,
      nestedUser: false
    },
    track_app_close: {
      route: '/events/trackInAppClose',
      body: true,
      current: false,
      nestedUser: false
    },
    track_app_open: {
      route: '/events/trackInAppOpen',
      body: true,
      current: false,
      nestedUser: false
    },
    track_app_click: {
      route: '/events/trackInAppClick',
      body: true,
      current: false,
      nestedUser: false
    },
    track_app_delivery: {
      route: '/events/trackInAppDelivery',
      body: true,
      current: false,
      nestedUser: false
    },
    track_app_consume: {
      route: '/events/inAppConsume',
      body: true,
      current: false,
      nestedUser: false
    },
    msg_dismiss: {
      route: '/embedded-messaging/events/dismiss',
      body: true,
      current: false,
      nestedUser: false
    },
    msg_session_event_track: {
      route: '/embedded-messaging/events/session',
      body: true,
      current: false,
      nestedUser: false
    }
  };
  var ANIMATION_STYLESHEET = _exports.ANIMATION_STYLESHEET = function ANIMATION_STYLESHEET() {
    var animationDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ANIMATION_DURATION;
    return "\n  @keyframes fadein {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n\n  @-moz-keyframes fadein {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n\n  @-webkit-keyframes fadein {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n\n  @-ms-keyframes fadein {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n\n  @keyframes slidein {\n    100% { transform: translateX(0%) }\n  }\n\n  @-moz-keyframes slidein {\n    100% { -moz-transform: translateX(0%) }\n  }\n\n  @-webkit-keyframes slidein {\n    100% { -webkit-transform: translateX(0%) }\n  }\n\n  @-ms-keyframes slidein {\n    100% { -ms-transform: translateX(0%) }\n  }\n\n  @keyframes slideout {\n    0% { transform: translateX(0%) }\n    100% { transform: translateX(150%) }\n  }\n\n  @-moz-keyframes slideout {\n    0% { transform: translateX(0%) }\n    100% { -moz-transform: translateX(150%) }\n  }\n\n  @-webkit-keyframes slideout {\n    0% { transform: translateX(0%) }\n    100% { -webkit-transform: translateX(150%) }\n  }\n\n  @-ms-keyframes slideout {\n    0% { transform: translateX(0%) }\n    100% { -ms-transform: translateX(150%) }\n  }\n\n  .slide-in {\n    -webkit-animation: slidein ".concat(animationDuration, "ms forwards;\n    -moz-animation: slidein ").concat(animationDuration, "ms forwards;\n    -ms-animation: slidein ").concat(animationDuration, "ms forwards;\n    -o-animation: slidein ").concat(animationDuration, "ms forwards;\n    animation: slidein ").concat(animationDuration, "ms forwards;\n  }\n\n  .slide-out {\n    -webkit-animation: slideout ").concat(animationDuration, "ms forwards;\n    -moz-animation: slideout ").concat(animationDuration, "ms forwards;\n    -ms-animation: slideout ").concat(animationDuration, "ms forwards;\n    -o-animation: slideout ").concat(animationDuration, "ms forwards;\n    animation: slideout ").concat(animationDuration, "ms forwards;\n  }\n\n  .fade-in {\n    -webkit-animation: fadein ").concat(animationDuration, "ms;\n    -moz-animation: fadein ").concat(animationDuration, "ms;\n    -ms-animation: fadein ").concat(animationDuration, "ms;\n    -o-animation: fadein ").concat(animationDuration, "ms;\n    animation: fadein ").concat(animationDuration, "ms;\n  }\n\n  .fade-out {\n    visibility: hidden;\n    opacity: 0;\n    -webkit-transition: visibility 0s ").concat(animationDuration, "ms, opacity ").concat(animationDuration, "ms linear;\n    -moz-transition: visibility 0s ").concat(animationDuration, "ms, opacity ").concat(animationDuration, "ms linear;\n    -ms-transition: visibility 0s ").concat(animationDuration, "ms, opacity ").concat(animationDuration, "ms linear;\n    -o-transition: visibility 0s ").concat(animationDuration, "ms, opacity ").concat(animationDuration, "ms linear;\n    transition: visibility 0s ").concat(animationDuration, "ms, opacity ").concat(animationDuration, "ms linear;\n  }\n");
  };
});

/***/ }),

/***/ 42885:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ErrorMessage = void 0;
  // Error Msgs
  var ErrorMessage = _exports.ErrorMessage = {
    invalid_api_key: 'Invalid API Key',
    subscription_inactive: 'SUBSCRIPTION_INACTIVE'
  };
});

/***/ }),

/***/ 93953:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6944), __webpack_require__(37289), __webpack_require__(54402), __webpack_require__(92667), __webpack_require__(17723), __webpack_require__(54950), __webpack_require__(89293), __webpack_require__(97909), __webpack_require__(42885), __webpack_require__(41545), __webpack_require__(85316), __webpack_require__(30895)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _toConsumableArray2, _asyncToGenerator2, _classCallCheck2, _createClass2, _defineProperty2, _request, _embeddedMessageProcessor, _consts, _constants, _events, _utils) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.IterableEmbeddedManager = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  /* eslint-disable class-methods-use-this */
  var IterableEmbeddedManager = _exports.IterableEmbeddedManager = /*#__PURE__*/function () {
    function IterableEmbeddedManager(appPackageName) {
      (0, _classCallCheck2["default"])(this, IterableEmbeddedManager);
      (0, _defineProperty2["default"])(this, "appPackageName", void 0);
      (0, _defineProperty2["default"])(this, "messages", []);
      (0, _defineProperty2["default"])(this, "updateListeners", []);
      this.appPackageName = appPackageName;
    }
    (0, _createClass2["default"])(IterableEmbeddedManager, [{
      key: "syncMessages",
      value: function () {
        var _syncMessages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(packageName, callback, placementIds) {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.retrieveEmbeddedMessages(packageName, placementIds || []);
              case 2:
                callback();
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function syncMessages(_x, _x2, _x3) {
          return _syncMessages.apply(this, arguments);
        }
        return syncMessages;
      }()
    }, {
      key: "retrieveEmbeddedMessages",
      value: function () {
        var _retrieveEmbeddedMessages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(packageName, placementIds) {
          var _iterableResult$data, iterableResult, embeddedMessages, _iterableResult$data2, _iterableResult$data3, processor, _error$response, msg;
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return (0, _request.baseIterableRequest)({
                  method: 'GET',
                  url: _constants.ENDPOINTS.get_embedded_messages.route,
                  params: {
                    placementIds: placementIds,
                    platform: _constants.WEB_PLATFORM,
                    sdkVersion: _constants.SDK_VERSION,
                    packageName: packageName
                  }
                });
              case 3:
                iterableResult = _context2.sent;
                embeddedMessages = this.getEmbeddedMessages((iterableResult === null || iterableResult === void 0 ? void 0 : (_iterableResult$data = iterableResult.data) === null || _iterableResult$data === void 0 ? void 0 : _iterableResult$data.placements) || []);
                if (!embeddedMessages.length) {
                  _context2.next = 11;
                  break;
                }
                processor = new _embeddedMessageProcessor.EmbeddedMessagingProcessor((0, _toConsumableArray2["default"])(this.messages), this.getEmbeddedMessages(iterableResult === null || iterableResult === void 0 ? void 0 : (_iterableResult$data2 = iterableResult.data) === null || _iterableResult$data2 === void 0 ? void 0 : _iterableResult$data2.placements));
                this.setMessages(processor);
                _context2.next = 10;
                return this.trackNewlyRetrieved(processor);
              case 10:
                this.messages = (0, _toConsumableArray2["default"])(this.getEmbeddedMessages(iterableResult === null || iterableResult === void 0 ? void 0 : (_iterableResult$data3 = iterableResult.data) === null || _iterableResult$data3 === void 0 ? void 0 : _iterableResult$data3.placements));
              case 11:
                _context2.next = 16;
                break;
              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                if (_context2.t0 !== null && _context2.t0 !== void 0 && (_error$response = _context2.t0.response) !== null && _error$response !== void 0 && _error$response.data) {
                  msg = _context2.t0.response.data.msg;
                  if (msg.toLowerCase() === _consts.ErrorMessage.invalid_api_key.toLowerCase() || msg.toLowerCase() === _consts.ErrorMessage.subscription_inactive.toLowerCase()) {
                    this.notifyDelegatesOfInvalidApiKeyOrSyncStop();
                  }
                }
              case 16:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this, [[0, 13]]);
        }));
        function retrieveEmbeddedMessages(_x4, _x5) {
          return _retrieveEmbeddedMessages.apply(this, arguments);
        }
        return retrieveEmbeddedMessages;
      }()
    }, {
      key: "getEmbeddedMessages",
      value: function getEmbeddedMessages(placements) {
        var messages = [];
        placements.forEach(function (placement) {
          messages = [].concat((0, _toConsumableArray2["default"])(messages), (0, _toConsumableArray2["default"])(placement.embeddedMessages));
        });
        return messages;
      }
    }, {
      key: "setMessages",
      value: function setMessages(_processor) {
        this.messages = _processor.processedMessagesList();
      }
    }, {
      key: "getMessages",
      value: function getMessages() {
        return this.messages;
      }
    }, {
      key: "getMessagesForPlacement",
      value: function getMessagesForPlacement(placementId) {
        return this.messages.filter(function (message) {
          return message.metadata.placementId === placementId;
        });
      }
    }, {
      key: "trackNewlyRetrieved",
      value: function () {
        var _trackNewlyRetrieved = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_processor) {
          var _this = this;
          var msgsList;
          return _regenerator["default"].wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                msgsList = _processor.newlyRetrievedMessages();
                this.notifyUpdateDelegates();
                msgsList.forEach( /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(msg) {
                    return _regenerator["default"].wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          return _context3.abrupt("return", (0, _events.trackEmbeddedReceived)(msg.metadata.messageId, _this.appPackageName));
                        case 1:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  return function (_x7) {
                    return _ref.apply(this, arguments);
                  };
                }());
              case 3:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function trackNewlyRetrieved(_x6) {
          return _trackNewlyRetrieved.apply(this, arguments);
        }
        return trackNewlyRetrieved;
      }()
    }, {
      key: "addUpdateListener",
      value: function addUpdateListener(updateListener) {
        this.updateListeners.push(updateListener);
      }
    }, {
      key: "notifyUpdateDelegates",
      value: function notifyUpdateDelegates() {
        this.updateListeners.forEach(function (updateListener) {
          updateListener.onMessagesUpdated();
        });
      }
    }, {
      key: "notifyDelegatesOfInvalidApiKeyOrSyncStop",
      value: function notifyDelegatesOfInvalidApiKeyOrSyncStop() {
        this.updateListeners.forEach(function (updateListener) {
          updateListener.onEmbeddedMessagingDisabled();
        });
      }

      // Get the list of updateHandlers
    }, {
      key: "getUpdateHandlers",
      value: function getUpdateHandlers() {
        return this.updateListeners;
      }
    }, {
      key: "click",
      value: function click(clickedUrl) {
        (0, _utils.handleEmbeddedClick)(clickedUrl);
      }
    }]);
    return IterableEmbeddedManager;
  }();
});

/***/ }),

/***/ 97909:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(92667), __webpack_require__(17723), __webpack_require__(54950)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _classCallCheck2, _createClass2, _defineProperty2) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.EmbeddedMessagingProcessor = void 0;
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  var EmbeddedMessagingProcessor = _exports.EmbeddedMessagingProcessor = /*#__PURE__*/function () {
    function EmbeddedMessagingProcessor(currentMessages, fetchedMessages) {
      (0, _classCallCheck2["default"])(this, EmbeddedMessagingProcessor);
      (0, _defineProperty2["default"])(this, "currentMessages", void 0);
      (0, _defineProperty2["default"])(this, "fetchedMessages", void 0);
      this.currentMessages = currentMessages; // old messages
      this.fetchedMessages = fetchedMessages; // all messages
    }
    (0, _createClass2["default"])(EmbeddedMessagingProcessor, [{
      key: "processedMessagesList",
      value: function processedMessagesList() {
        return this.fetchedMessages;
      }
    }, {
      key: "newlyRetrievedMessages",
      value: function newlyRetrievedMessages() {
        return this.getNewMessages();
      }
    }, {
      key: "getNewMessages",
      value: function getNewMessages() {
        var _this = this;
        return this.fetchedMessages.filter(function (messageInfo) {
          return !_this.getCurrentMessageIds().includes(messageInfo.metadata.messageId);
        });
      }
    }, {
      key: "getCurrentMessageIds",
      value: function getCurrentMessageIds() {
        return this.currentMessages.map(function (messageInfo) {
          return messageInfo.metadata.messageId;
        });
      }
    }, {
      key: "getFetchedMessageIds",
      value: function getFetchedMessageIds() {
        return this.fetchedMessages.map(function (messageInfo) {
          return messageInfo.metadata.messageId;
        });
      }
    }]);
    return EmbeddedMessagingProcessor;
  }();
});

/***/ }),

/***/ 48445:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.IterableActionSource = void 0;
  /* eslint-disable no-use-before-define */
  var IterableActionSource = _exports.IterableActionSource = /*#__PURE__*/function (IterableActionSource) {
    IterableActionSource["EMBEDDED"] = "EMBEDDED";
    return IterableActionSource;
  }({});
});

/***/ }),

/***/ 30895:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(54950), __webpack_require__(41545), __webpack_require__(85316), __webpack_require__(48445), __webpack_require__(90422)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _constants, _events, _types, _IterableActionRunner) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.addButtonClickEvent = void 0;
  _exports.getTrimmedText = getTrimmedText;
  _exports.handleEmbeddedClick = _exports.handleElementClick = _exports.handleButtonClick = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable no-use-before-define */
  function getTargetUrl(action) {
    if (!action) return '';
    if (action.type === _constants.URL_SCHEME_OPEN) {
      return (action === null || action === void 0 ? void 0 : action.data) || '';
    }
    return action.type;
  }
  var handleElementClick = _exports.handleElementClick = function handleElementClick(message, appPackageName, errorCallback) {
    var _message$elements;
    var targetUrl = getTargetUrl(message === null || message === void 0 ? void 0 : (_message$elements = message.elements) === null || _message$elements === void 0 ? void 0 : _message$elements.defaultAction);
    handleEmbeddedClick(targetUrl);
    (0, _events.trackEmbeddedClick)({
      messageId: message.metadata.messageId,
      buttonIdentifier: '',
      targetUrl: targetUrl,
      appPackageName: appPackageName
    })["catch"](function (error) {
      if (errorCallback) {
        var _error$response, _error$response2;
        errorCallback(_objectSpread(_objectSpread({}, error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data), {}, {
          statusCode: error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status
        }));
      }
    });
  };
  var handleButtonClick = _exports.handleButtonClick = function handleButtonClick(button, message, appPackageName, errorCallback) {
    var targetUrl = getTargetUrl(button === null || button === void 0 ? void 0 : button.action);
    handleEmbeddedClick(targetUrl);
    (0, _events.trackEmbeddedClick)({
      messageId: message.metadata.messageId,
      buttonIdentifier: (button === null || button === void 0 ? void 0 : button.id) || '',
      targetUrl: targetUrl,
      appPackageName: appPackageName
    })["catch"](function (error) {
      if (errorCallback) {
        var _error$response3, _error$response4;
        errorCallback(_objectSpread(_objectSpread({}, error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data), {}, {
          statusCode: error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.status
        }));
      }
    });
  };
  var addButtonClickEvent = _exports.addButtonClickEvent = function addButtonClickEvent(button, index, message, appPackageName, errorCallback) {
    button.addEventListener('click', function (event) {
      var _message$elements2;
      // Prevent the click event from bubbling up to the div
      event.stopPropagation();
      if (message !== null && message !== void 0 && (_message$elements2 = message.elements) !== null && _message$elements2 !== void 0 && _message$elements2.buttons) {
        var _message$elements3;
        handleButtonClick(message === null || message === void 0 ? void 0 : (_message$elements3 = message.elements) === null || _message$elements3 === void 0 ? void 0 : _message$elements3.buttons[index], message, appPackageName, errorCallback);
      }
    });
  };
  var handleEmbeddedClick = _exports.handleEmbeddedClick = function handleEmbeddedClick(clickedUrl) {
    if (clickedUrl && clickedUrl.trim() !== '') {
      var actionType;
      var actionName;
      if (clickedUrl.startsWith(_constants.URL_SCHEME_ACTION)) {
        actionName = '';
        actionType = clickedUrl;
      } else if (clickedUrl.startsWith(_constants.URL_SCHEME_ITBL)) {
        actionName = '';
        actionType = clickedUrl.replace(_constants.URL_SCHEME_ITBL, '');
      } else {
        actionType = _constants.URL_SCHEME_OPEN;
        actionName = clickedUrl;
      }
      var iterableAction = {
        type: actionType,
        data: actionName
      };
      _IterableActionRunner.IterableActionRunner.executeAction(null, iterableAction, _types.IterableActionSource.EMBEDDED);
    }
  };
  function getTrimmedText(text) {
    var unsafeText = text && typeof text === 'string' ? text.trim() : '';
    return escapeHtml(unsafeText);
  }
  function escapeHtml(unsafe) {
    return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }
});

/***/ }),

/***/ 85316:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(54950), __webpack_require__(20316), __webpack_require__(41545), __webpack_require__(89293), __webpack_require__(17897)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _objectWithoutProperties2, _constants, _request, _events) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.trackEmbeddedSession = _exports.trackEmbeddedReceived = _exports.trackEmbeddedDismiss = _exports.trackEmbeddedClick = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  var _excluded = ["appPackageName"],
    _excluded2 = ["appPackageName"],
    _excluded3 = ["appPackageName"];
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var trackEmbeddedReceived = _exports.trackEmbeddedReceived = function trackEmbeddedReceived(messageId, appPackageName) {
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.msg_received_event_track.route,
      data: {
        messageId: messageId,
        deviceInfo: {
          platform: _constants.WEB_PLATFORM,
          deviceId: __webpack_require__.g.navigator.userAgent || '',
          appPackageName: appPackageName
        }
      },
      validation: {
        data: _events.trackEmbeddedSchema
      }
    });
  };
  var trackEmbeddedClick = _exports.trackEmbeddedClick = function trackEmbeddedClick(payload) {
    var appPackageName = payload.appPackageName,
      rest = (0, _objectWithoutProperties2["default"])(payload, _excluded);
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.msg_click_event_track.route,
      data: _objectSpread(_objectSpread({}, rest), {}, {
        deviceInfo: {
          platform: _constants.WEB_PLATFORM,
          deviceId: __webpack_require__.g.navigator.userAgent || '',
          appPackageName: appPackageName
        },
        createdAt: Date.now()
      }),
      validation: {
        data: _events.trackEmbeddedClickSchema
      }
    });
  };
  var trackEmbeddedDismiss = _exports.trackEmbeddedDismiss = function trackEmbeddedDismiss(payload) {
    var appPackageName = payload.appPackageName,
      rest = (0, _objectWithoutProperties2["default"])(payload, _excluded2);
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.msg_dismiss.route,
      data: _objectSpread(_objectSpread({}, rest), {}, {
        deviceInfo: {
          platform: _constants.WEB_PLATFORM,
          deviceId: __webpack_require__.g.navigator.userAgent || '',
          appPackageName: appPackageName
        },
        createdAt: Date.now()
      }),
      validation: {
        data: _events.embeddedDismissSchema
      }
    });
  };
  var trackEmbeddedSession = _exports.trackEmbeddedSession = function trackEmbeddedSession(payload) {
    var appPackageName = payload.appPackageName,
      rest = (0, _objectWithoutProperties2["default"])(payload, _excluded3);
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.msg_session_event_track.route,
      data: _objectSpread(_objectSpread({}, rest), {}, {
        deviceInfo: {
          platform: _constants.WEB_PLATFORM,
          deviceId: __webpack_require__.g.navigator.userAgent || '',
          appPackageName: appPackageName
        },
        createdAt: Date.now()
      }),
      validation: {
        data: _events.embeddedSessionSchema
      }
    });
  };
});

/***/ }),

/***/ 17897:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(50255)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _yup) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.trackEmbeddedSchema = _exports.trackEmbeddedClickSchema = _exports.embeddedSessionSchema = _exports.embeddedDismissSchema = void 0;
  var trackEmbeddedSchema = _exports.trackEmbeddedSchema = (0, _yup.object)().shape({
    metadata: (0, _yup.object)().shape({
      messageId: (0, _yup.string)(),
      campaignId: (0, _yup.number)(),
      isProof: (0, _yup["boolean"])(),
      placementId: (0, _yup.number)()
    }),
    elements: (0, _yup.object)().shape({
      title: (0, _yup.string)(),
      body: (0, _yup.string)(),
      mediaUrl: (0, _yup.string)(),
      buttons: (0, _yup.array)().of((0, _yup.object)().shape({
        id: (0, _yup.string)(),
        title: (0, _yup.string)(),
        action: (0, _yup.object)().shape({
          type: (0, _yup.string)(),
          data: (0, _yup.string)()
        })
      })),
      text: (0, _yup.array)().of((0, _yup.object)().shape({
        id: (0, _yup.string)(),
        text: (0, _yup.string)()
      })),
      defaultAction: (0, _yup.array)().of((0, _yup.object)().shape({
        type: (0, _yup.string)(),
        data: (0, _yup.string)()
      }))
    }),
    payload: (0, _yup.array)().of((0, _yup.mixed)())
  });
  var trackEmbeddedClickSchema = _exports.trackEmbeddedClickSchema = (0, _yup.object)().shape({
    messageId: (0, _yup.string)(),
    buttonIdentifier: (0, _yup.string)(),
    targetUrl: (0, _yup.string)(),
    deviceInfo: (0, _yup.object)().shape({
      appPackageName: (0, _yup.string)()
    })
  });
  var embeddedDismissSchema = _exports.embeddedDismissSchema = (0, _yup.object)().shape({
    messageId: (0, _yup.string)().required(),
    buttonIdentifier: (0, _yup.string)(),
    deviceInfo: (0, _yup.object)().shape({
      deviceId: (0, _yup.string)().required(),
      platform: (0, _yup.string)().required(),
      appPackageName: (0, _yup.string)().required()
    }),
    createdAt: (0, _yup.number)()
  });
  var embeddedSessionSchema = _exports.embeddedSessionSchema = (0, _yup.object)().shape({
    session: (0, _yup.object)().shape({
      id: (0, _yup.string)().required(),
      start: (0, _yup.number)().required(),
      end: (0, _yup.number)().required()
    }).required(),
    impressions: (0, _yup.array)().of((0, _yup.object)().shape({
      messageId: (0, _yup.string)().required(),
      displayCount: (0, _yup.number)().required(),
      displayDuration: (0, _yup.number)().required(),
      placementId: (0, _yup.string)()
    })),
    deviceInfo: (0, _yup.object)().shape({
      deviceId: (0, _yup.string)().required(),
      platform: (0, _yup.string)().required(),
      appPackageName: (0, _yup.string)().required()
    }),
    createdAt: (0, _yup.number)()
  });
});

/***/ }),

/***/ 35555:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";
});

/***/ }),

/***/ 28451:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(41545), __webpack_require__(89293), __webpack_require__(92691)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _constants, _request, _events) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.track = void 0;
  /* eslint-disable no-param-reassign */

  var track = _exports.track = function track(payload) {
    /* a customer could potentially send these up if they're not using TypeScript */
    delete payload.userId;
    delete payload.email;
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.event_track.route,
      data: payload,
      validation: {
        data: _events.trackSchema
      }
    });
  };
});

/***/ }),

/***/ 92691:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(50255)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _yup) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.trackSchema = _exports.eventRequestSchema = void 0;
  var trackSchema = _exports.trackSchema = (0, _yup.object)().shape({
    eventName: (0, _yup.string)().required(),
    id: (0, _yup.string)(),
    createdAt: (0, _yup.number)(),
    dataFields: (0, _yup.object)(),
    campaignId: (0, _yup.number)(),
    templateId: (0, _yup.number)()
  });
  var eventRequestSchema = _exports.eventRequestSchema = (0, _yup.object)().shape({
    messageId: (0, _yup.string)().required(),
    clickedUrl: (0, _yup.string)(),
    messageContext: (0, _yup.object)().shape({
      saveToInbox: (0, _yup["boolean"])(),
      silentInbox: (0, _yup["boolean"])(),
      location: (0, _yup.string)()
    }),
    closeAction: (0, _yup.string)(),
    deviceInfo: (0, _yup.object)().shape({
      deviceId: (0, _yup.string)().required(),
      platform: (0, _yup.string)().required(),
      appPackageName: (0, _yup.string)().required()
    }).required(),
    inboxSessionId: (0, _yup.string)(),
    createdAt: (0, _yup.number)()
  });
});

/***/ }),

/***/ 88133:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(54950), __webpack_require__(89293), __webpack_require__(41545), __webpack_require__(94507)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _request, _constants, _events) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.trackInAppOpen = _exports.trackInAppDelivery = _exports.trackInAppConsume = _exports.trackInAppClose = _exports.trackInAppClick = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable no-param-reassign */
  var trackInAppClose = _exports.trackInAppClose = function trackInAppClose(payload) {
    /* a customer could potentially send these up if they're not using TypeScript */
    delete payload.userId;
    delete payload.email;
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.track_app_close.route,
      data: _objectSpread(_objectSpread({}, payload), {}, {
        deviceInfo: _objectSpread(_objectSpread({}, payload.deviceInfo), {}, {
          platform: _constants.WEB_PLATFORM,
          deviceId: __webpack_require__.g.navigator.userAgent || ''
        })
      }),
      validation: {
        data: _events.eventRequestSchema
      }
    });
  };
  var trackInAppOpen = _exports.trackInAppOpen = function trackInAppOpen(payload) {
    /* a customer could potentially send these up if they're not using TypeScript */
    delete payload.userId;
    delete payload.email;
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.track_app_open.route,
      data: _objectSpread(_objectSpread({}, payload), {}, {
        deviceInfo: _objectSpread(_objectSpread({}, payload.deviceInfo), {}, {
          platform: _constants.WEB_PLATFORM,
          deviceId: __webpack_require__.g.navigator.userAgent || ''
        })
      }),
      validation: {
        data: _events.eventRequestSchema.omit(['clickedUrl', 'inboxSessionId', 'closeAction'])
      }
    });
  };
  var trackInAppClick = _exports.trackInAppClick = function trackInAppClick(payload) {
    var sendBeacon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    /* a customer could potentially send these up if they're not using TypeScript */
    delete payload.userId;
    delete payload.email;
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.track_app_click.route,
      sendBeacon: sendBeacon,
      data: _objectSpread(_objectSpread({}, payload), {}, {
        deviceInfo: _objectSpread(_objectSpread({}, payload.deviceInfo), {}, {
          platform: _constants.WEB_PLATFORM,
          deviceId: __webpack_require__.g.navigator.userAgent || ''
        })
      }),
      validation: {
        data: _events.eventRequestSchema.omit(['inboxSessionId', 'closeAction'])
      }
    });
  };
  var trackInAppDelivery = _exports.trackInAppDelivery = function trackInAppDelivery(payload) {
    /* a customer could potentially send these up if they're not using TypeScript */
    delete payload.userId;
    delete payload.email;
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.track_app_delivery.route,
      data: _objectSpread(_objectSpread({}, payload), {}, {
        deviceInfo: _objectSpread(_objectSpread({}, payload.deviceInfo), {}, {
          platform: _constants.WEB_PLATFORM,
          deviceId: __webpack_require__.g.navigator.userAgent || ''
        })
      }),
      validation: {
        data: _events.eventRequestSchema.omit(['clickedUrl', 'inboxSessionId', 'closeAction'])
      }
    });
  };
  var trackInAppConsume = _exports.trackInAppConsume = function trackInAppConsume(payload) {
    /* a customer could potentially send these up if they're not using TypeScript */
    delete payload.userId;
    delete payload.email;
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.track_app_consume.route,
      data: _objectSpread(_objectSpread({}, payload), {}, {
        deviceInfo: _objectSpread(_objectSpread({}, payload.deviceInfo), {}, {
          platform: _constants.WEB_PLATFORM,
          deviceId: __webpack_require__.g.navigator.userAgent || ''
        })
      }),
      validation: {
        data: _events.eventRequestSchema.omit(['clickedUrl', 'inboxSessionId', 'closeAction'])
      }
    });
  };
});

/***/ }),

/***/ 94507:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(50255)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _yup) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.eventRequestSchema = void 0;
  var eventRequestSchema = _exports.eventRequestSchema = (0, _yup.object)().shape({
    messageId: (0, _yup.string)().required(),
    clickedUrl: (0, _yup.string)(),
    messageContext: (0, _yup.object)().shape({
      saveToInbox: (0, _yup["boolean"])(),
      silentInbox: (0, _yup["boolean"])(),
      location: (0, _yup.string)()
    }),
    closeAction: (0, _yup.string)(),
    deviceInfo: (0, _yup.object)().shape({
      deviceId: (0, _yup.string)().required(),
      platform: (0, _yup.string)().required(),
      appPackageName: (0, _yup.string)().required()
    }).required(),
    inboxSessionId: (0, _yup.string)(),
    createdAt: (0, _yup.number)()
  });
});

/***/ }),

/***/ 28588:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";
});

/***/ }),

/***/ 2219:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(28451), __webpack_require__(88133), __webpack_require__(28588), __webpack_require__(35555), __webpack_require__(85316)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _events, _events2, _types, _types2, _events3) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_events).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _events[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _events[key];
      }
    });
  });
  Object.keys(_events2).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _events2[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _events2[key];
      }
    });
  });
  Object.keys(_types).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _types[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _types[key];
      }
    });
  });
  Object.keys(_types2).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _types2[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _types2[key];
      }
    });
  });
  Object.keys(_events3).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _events3[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _events3[key];
      }
    });
  });
});

/***/ }),

/***/ 9262:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6944), __webpack_require__(17024), __webpack_require__(54402), __webpack_require__(24678)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _slicedToArray2, _asyncToGenerator2, _idbKeyval) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getCachedMessagesToDelete = _exports.determineRemainingStorageQuota = _exports.addNewMessagesToCache = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _slicedToArray2 = _interopRequireDefault(_slicedToArray2);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  /**
   * Detect amount of local storage remaining (quota) and used (usage).
   * If usageDetails exist (not supported in Safari), use this instead of usage.
   */
  var determineRemainingStorageQuota = _exports.determineRemainingStorageQuota = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _ref2, _storage$usageDetails, _storage$usageDetails2, storage, mobileBrowserQuota, estimatedBrowserQuota, messageQuota, usage, remainingQuota, _err$response$data$cl, _err$response, _err$response$data;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if ('indexedDB' in window) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", 0);
          case 3:
            if (!('storage' in navigator && 'estimate' in navigator.storage)) {
              _context.next = 9;
              break;
            }
            _context.next = 6;
            return navigator.storage.estimate();
          case 6:
            _context.t0 = _context.sent;
            _context.next = 10;
            break;
          case 9:
            _context.t0 = undefined;
          case 10:
            storage = _context.t0;
            /** 50 MB is the lower common denominator on modern mobile browser caches. */
            mobileBrowserQuota = 52428800;
            /** Max quota of browser storage that in-apps will potentially fill */
            estimatedBrowserQuota = storage === null || storage === void 0 ? void 0 : storage.quota;
            /**
             * Determine lower max quota that can be used for message cache, set to
             * 60% of quota to leave space for other caching needs on that domain.
             */
            messageQuota = ((_ref2 = estimatedBrowserQuota && Math.min(estimatedBrowserQuota, mobileBrowserQuota)) !== null && _ref2 !== void 0 ? _ref2 : mobileBrowserQuota) * 0.6;
            /** How much local storage is being used. */
            usage = (_storage$usageDetails = storage === null || storage === void 0 ? void 0 : (_storage$usageDetails2 = storage.usageDetails) === null || _storage$usageDetails2 === void 0 ? void 0 : _storage$usageDetails2.indexedDB) !== null && _storage$usageDetails !== void 0 ? _storage$usageDetails : storage === null || storage === void 0 ? void 0 : storage.usage;
            remainingQuota = usage && messageQuota - usage;
            return _context.abrupt("return", remainingQuota || 0);
          case 19:
            _context.prev = 19;
            _context.t1 = _context["catch"](0);
            // eslint-disable-next-line no-console
            console.warn('Error determining remaining storage quota', (_err$response$data$cl = _context.t1 === null || _context.t1 === void 0 ? void 0 : (_err$response = _context.t1.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.clientErrors) !== null && _err$response$data$cl !== void 0 ? _err$response$data$cl : _context.t1);
          case 22:
            return _context.abrupt("return", 0);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 19]]);
    }));
    return function determineRemainingStorageQuota() {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * Deletes cached messages not present in latest getMessages fetch.
   * @param cachedMessages
   * @param fetchedMessages
   */
  var getCachedMessagesToDelete = _exports.getCachedMessagesToDelete = function getCachedMessagesToDelete(cachedMessages, fetchedMessages) {
    return cachedMessages.reduce(function (deleteQueue, _ref3) {
      var _ref4 = (0, _slicedToArray2["default"])(_ref3, 1),
        cachedMessageId = _ref4[0];
      var isCachedMessageInFetch = fetchedMessages.reduce(function (isFound, _ref5) {
        var messageId = _ref5.messageId;
        // eslint-disable-next-line no-param-reassign
        if (messageId === cachedMessageId) isFound = true;
        return isFound;
      }, false);
      if (!isCachedMessageInFetch) deleteQueue.push(cachedMessageId);
      return deleteQueue;
    }, []);
  };

  /**
   * Adds messages to cache only if they fit within the quota, starting with
   * oldest messages since newer messages can still be easily retrieved via
   * new requests while passing in latestCachedMessageId param.
   * @param messages
   * @param quota
   */
  var addNewMessagesToCache = _exports.addNewMessagesToCache = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(messages) {
      var quota, messagesWithSizes, remainingQuota, messagesToAddToCache, _err$response$data$cl2, _err$response2, _err$response2$data;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return determineRemainingStorageQuota();
          case 2:
            quota = _context2.sent;
            if (!(quota > 0)) {
              _context2.next = 16;
              break;
            }
            /**
             * Determine total size (in bytes) of new messages to be added to cache
             * sorted oldest to newest (ascending createdAt property).
             */
            messagesWithSizes = messages.map(function (_ref7) {
              var messageId = _ref7.messageId,
                message = _ref7.message;
              var sizeInBytes = new Blob([JSON.stringify(message).replace(/\[\[\],"\]/g, '')]).size;
              return {
                messageId: messageId,
                message: message,
                createdAt: message.createdAt,
                size: sizeInBytes
              };
            }).sort(function (a, b) {
              return a.createdAt - b.createdAt;
            });
            /** Only add messages that fit in cache, starting from oldest messages. */
            remainingQuota = quota;
            messagesToAddToCache = [];
            messagesWithSizes.every(function (_ref8) {
              var messageId = _ref8.messageId,
                message = _ref8.message,
                size = _ref8.size;
              if (remainingQuota - size < 0) return false;
              remainingQuota -= size;
              messagesToAddToCache.push([messageId, message]);
              return true;
            });
            _context2.prev = 8;
            _context2.next = 11;
            return (0, _idbKeyval.setMany)(messagesToAddToCache);
          case 11:
            _context2.next = 16;
            break;
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](8);
            // eslint-disable-next-line no-console
            console.warn('Error adding new messages to the browser cache', (_err$response$data$cl2 = _context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.clientErrors) !== null && _err$response$data$cl2 !== void 0 ? _err$response$data$cl2 : _context2.t0);
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[8, 13]]);
    }));
    return function addNewMessagesToCache(_x) {
      return _ref6.apply(this, arguments);
    };
  }();
});

/***/ }),

/***/ 59845:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(37289), __webpack_require__(54950), __webpack_require__(36968), __webpack_require__(42189), __webpack_require__(41545), __webpack_require__(2219), __webpack_require__(286), __webpack_require__(7665), __webpack_require__(47033)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _toConsumableArray2, _defineProperty2, _set, _throttleDebounce, _constants, _events, _request, _types, _utils) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.clearMessages = void 0;
  _exports.getInAppMessages = getInAppMessages;
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _set = _interopRequireDefault(_set);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable consistent-return */ /* eslint-disable no-param-reassign */ /* eslint-disable no-redeclare */
  var parsedMessages = [];
  var timer = null;
  var messageIndex = 0;
  var isPaused = false;
  var clearMessages = _exports.clearMessages = function clearMessages() {
    parsedMessages = [];
    messageIndex = 0;
    isPaused = false;
    if (timer) {
      clearTimeout(timer);
    }
  };
  function getInAppMessages(payload, options) {
    clearMessages();
    var dupedPayload = _objectSpread({}, payload);

    /* delete SDK-defined payload props and email and userId */
    delete dupedPayload.userId;
    delete dupedPayload.email;
    delete dupedPayload.displayInterval;
    delete dupedPayload.onOpenScreenReaderMessage;
    delete dupedPayload.onOpenNodeToTakeFocus;
    delete dupedPayload.topOffset;
    delete dupedPayload.bottomOffset;
    delete dupedPayload.rightOffset;
    delete dupedPayload.animationDuration;
    delete dupedPayload.handleLinks;
    delete dupedPayload.closeButton;
    if (options !== null && options !== void 0 && options.display) {
      (0, _utils.addStyleSheet)(document, (0, _constants.ANIMATION_STYLESHEET)(payload.animationDuration));
      var paintMessageToDOM = function paintMessageToDOM() {
        var _parsedMessages;
        if ((_parsedMessages = parsedMessages) !== null && _parsedMessages !== void 0 && _parsedMessages[messageIndex]) {
          var _activeMessage$conten, _activeMessage$conten2, _activeMessage$conten3, _activeMessage$conten4, _activeMessage$conten5, _activeMessage$conten6, _activeMessage$conten7, _activeMessage$conten8, _activeMessage$conten9, _activeMessage$conten10;
          var activeMessage = parsedMessages[messageIndex];
          var shouldAnimate = activeMessage === null || activeMessage === void 0 ? void 0 : (_activeMessage$conten = activeMessage.content) === null || _activeMessage$conten === void 0 ? void 0 : (_activeMessage$conten2 = _activeMessage$conten.inAppDisplaySettings) === null || _activeMessage$conten2 === void 0 ? void 0 : _activeMessage$conten2.shouldAnimate;
          var messagePosition = (activeMessage === null || activeMessage === void 0 ? void 0 : (_activeMessage$conten3 = activeMessage.content) === null || _activeMessage$conten3 === void 0 ? void 0 : (_activeMessage$conten4 = _activeMessage$conten3.webInAppDisplaySettings) === null || _activeMessage$conten4 === void 0 ? void 0 : _activeMessage$conten4.position) || 'Center';
          var overlay = (0, _utils.paintOverlay)(activeMessage === null || activeMessage === void 0 ? void 0 : (_activeMessage$conten5 = activeMessage.content) === null || _activeMessage$conten5 === void 0 ? void 0 : (_activeMessage$conten6 = _activeMessage$conten5.inAppDisplaySettings) === null || _activeMessage$conten6 === void 0 ? void 0 : (_activeMessage$conten7 = _activeMessage$conten6.bgColor) === null || _activeMessage$conten7 === void 0 ? void 0 : _activeMessage$conten7.hex, activeMessage === null || activeMessage === void 0 ? void 0 : (_activeMessage$conten8 = activeMessage.content) === null || _activeMessage$conten8 === void 0 ? void 0 : (_activeMessage$conten9 = _activeMessage$conten8.inAppDisplaySettings) === null || _activeMessage$conten9 === void 0 ? void 0 : (_activeMessage$conten10 = _activeMessage$conten9.bgColor) === null || _activeMessage$conten10 === void 0 ? void 0 : _activeMessage$conten10.alpha, shouldAnimate);
          var dismissMessage = function dismissMessage(activeIframe, url) {
            var _activeMessage$conten11, _activeMessage$conten12;
            if (activeMessage !== null && activeMessage !== void 0 && (_activeMessage$conten11 = activeMessage.content) !== null && _activeMessage$conten11 !== void 0 && (_activeMessage$conten12 = _activeMessage$conten11.inAppDisplaySettings) !== null && _activeMessage$conten12 !== void 0 && _activeMessage$conten12.shouldAnimate) {
              activeIframe.className = messagePosition === 'Center' || messagePosition === 'Full' ? 'fade-out' : 'slide-out';
            }
            var trackPayload = {
              messageId: activeMessage.messageId,
              deviceInfo: {
                appPackageName: dupedPayload.packageName
              }
            };
            /* close the message and start a timer to show the next one */
            (0, _events.trackInAppClose)(url ? _objectSpread(_objectSpread({}, trackPayload), {}, {
              clickedUrl: url
            }) : trackPayload)["catch"](function (e) {
              return e;
            });
            if (shouldAnimate) {
              var animationTimer = __webpack_require__.g.setTimeout(function () {
                activeIframe.remove();
                clearTimeout(animationTimer);
              }, _constants.ANIMATION_DURATION);
            } else {
              activeIframe.remove();
            }
            overlay.remove();
            var timeToNextMessage = shouldAnimate ? (payload.displayInterval || _constants.DISPLAY_INTERVAL_DEFAULT) + _constants.ANIMATION_DURATION : payload.displayInterval || _constants.DISPLAY_INTERVAL_DEFAULT;
            messageIndex += 1;
            timer = __webpack_require__.g.setTimeout(function () {
              clearTimeout(timer);
              paintMessageToDOM();
            }, timeToNextMessage);
          };

          /* add the message's html to an iframe and paint it to the DOM */
          return (0, _utils.paintIFrame)(activeMessage.content.html, messagePosition, shouldAnimate, payload.onOpenScreenReaderMessage || 'in-app iframe message opened', payload.topOffset, payload.bottomOffset, payload.rightOffset).then(function (activeIframe) {
            var _payload$closeButton;
            var activeIframeDocument = activeIframe === null || activeIframe === void 0 ? void 0 : activeIframe.contentDocument;
            var throttledResize = messagePosition !== 'Full' ? (0, _throttleDebounce.throttle)(750, function () {
              var _activeIframeDocument;
              activeIframe.style.height = "".concat((activeIframeDocument === null || activeIframeDocument === void 0 ? void 0 : (_activeIframeDocument = activeIframeDocument.body) === null || _activeIframeDocument === void 0 ? void 0 : _activeIframeDocument.scrollHeight) || 0, "px");
            }) : function () {
              return null;
            };
            __webpack_require__.g.addEventListener('resize', throttledResize);
            try {
              var _activeIframeDocument2;
              var elementToFocus = activeIframeDocument === null || activeIframeDocument === void 0 ? void 0 : (_activeIframeDocument2 = activeIframeDocument.body) === null || _activeIframeDocument2 === void 0 ? void 0 : _activeIframeDocument2.querySelector(payload.onOpenNodeToTakeFocus || '');

              /* try to focus on the query selector the customer provided  */
              elementToFocus.focus();
            } catch (e) {
              var _activeIframeDocument3;
              /* otherwise, find the first focusable element and focus on that */
              var firstFocusableElement = activeIframeDocument === null || activeIframeDocument === void 0 ? void 0 : (_activeIframeDocument3 = activeIframeDocument.body) === null || _activeIframeDocument3 === void 0 ? void 0 : _activeIframeDocument3.querySelector('button, a:not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
              if (firstFocusableElement) {
                firstFocusableElement.focus();
              }
            }
            var handleEscKeypress = function handleEscKeypress(event, documentEventHandler, iframeEventHandler) {
              if (event.key === 'Escape') {
                dismissMessage(activeIframe);
                document.removeEventListener('keydown', documentEventHandler);
                if (activeIframeDocument && !!iframeEventHandler) {
                  activeIframeDocument.removeEventListener('keydown', iframeEventHandler);
                }
                __webpack_require__.g.removeEventListener('resize', throttledResize);
              }
            };

            /*
              handleDocumentEscPress and handleIFrameEscPress both are separate
              keydown handlers to dismiss the message when the _esc_ key is pressed.
               The reason these are abstracted into their own methods is because the method
              for adding the event handler also removes itself in its own callback. BUT since
              we have 2 event listeners (one for the document, and one for the iframe), the method
              to add the listener needs to know about both of these _addEventListener_ abstracted
              callbacks so the code can properly remove the same listener that was added.
               In other words, it solves for the issue where you're
              adding an event listener as a lambda
              like so and and you get a unique event listener each time:
               document.addEventListener('keydown', () => // do stuff)
               this example code adds a new event listener each time and never gets cleaned up
              because there's no reference that to "() => // do stuff" that can be re-used in the
              _removeEventListener_ call.
            */
            var handleDocumentEscPress = function handleDocumentEscPress(event) {
              return handleEscKeypress(event, handleDocumentEscPress);
            };
            var handleIFrameEscPress = function handleIFrameEscPress(event) {
              return handleEscKeypress(event, handleDocumentEscPress, handleIFrameEscPress);
            };
            document.addEventListener('keydown', handleDocumentEscPress);
            if (activeIframeDocument) {
              activeIframeDocument.addEventListener('keydown', handleIFrameEscPress);
            }
            var ua = navigator.userAgent;
            var isSafari = !!ua.match(/safari/i) && !ua.match(/chrome|chromium|crios/i);

            /**
             * We allow users to dismiss messages by clicking outside of the
             * message not only when isRequiredToDismissMessage is not true
             * but also when browser is detected to be Safari, regardless of
             * whether isRequiredToDismissMessage is true. Safari blocks
             * all bound event handlers and so we cannot execute Javascript
             * to listen for click events. As such, we should not prevent users
             * from being able to dismiss the message by clicking outside of it.
             */
            if (!((_payload$closeButton = payload.closeButton) !== null && _payload$closeButton !== void 0 && _payload$closeButton.isRequiredToDismissMessage) || isSafari) {
              overlay.addEventListener('click', function () {
                var _document$getElementB;
                dismissMessage(activeIframe);
                (_document$getElementB = document.getElementById(_constants.CLOSE_X_BUTTON_ID)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.remove();
                document.removeEventListener('keydown', handleDocumentEscPress);
                if (activeIframeDocument) {
                  activeIframeDocument.removeEventListener('keydown', handleIFrameEscPress);
                }
                __webpack_require__.g.removeEventListener('resize', throttledResize);
              });
            }

            /*
              create an absolutely positioned button that lies underneath the
              in-app message and takes up full width and height
               The reason for this is if the customer made their in-app take less width
              than the iframe surrounding it, they should still be able to click outside
              their in-app, but within the bounds of the iframe to dismiss it.
               The overlay doesn't handle this because the overlay only surrounds the iframe,
              not the in-app message.
            */
            if (activeIframeDocument) {
              var absoluteDismissButton = (0, _utils.generateAbsoluteDismissButton)({
                id: _constants.ABSOLUTE_DISMISS_BUTTON_ID,
                document: isSafari ? document : activeIframeDocument
              });
              var triggerClose = function triggerClose() {
                dismissMessage(activeIframe);
                document.removeEventListener('keydown', handleDocumentEscPress);
                if (activeIframeDocument) {
                  activeIframeDocument.removeEventListener('keydown', handleIFrameEscPress);
                }
                __webpack_require__.g.removeEventListener('resize', throttledResize);
                var closeXButtonElement = document.getElementById(_constants.CLOSE_X_BUTTON_ID);
                var absoluteDismissButtonElement = document.getElementById(_constants.ABSOLUTE_DISMISS_BUTTON_ID);
                closeXButtonElement === null || closeXButtonElement === void 0 ? void 0 : closeXButtonElement.remove();
                absoluteDismissButtonElement === null || absoluteDismissButtonElement === void 0 ? void 0 : absoluteDismissButtonElement.remove();
              };
              absoluteDismissButton.addEventListener('click', triggerClose);
              document.body.appendChild(absoluteDismissButton);

              /**
               * Here we paint an optional close button if the user provided configuration
               * values. This button is just a quality-of-life feature so that the customer will
               * have an easy way to close the modal outside of the other methods.
               *
               * Do not show close button if browser is detected to be Safari because the close
               * button will not be able to dismiss the message (Safari blocks JS from running
               * on bound event handlers)
               */
              if (payload.closeButton) {
                var _payload$closeButton2 = payload.closeButton,
                  position = _payload$closeButton2.position,
                  color = _payload$closeButton2.color,
                  size = _payload$closeButton2.size,
                  iconPath = _payload$closeButton2.iconPath,
                  topOffset = _payload$closeButton2.topOffset,
                  sideOffset = _payload$closeButton2.sideOffset;
                var closeXButton = (0, _utils.generateCloseButton)(_constants.CLOSE_X_BUTTON_ID, isSafari ? document : activeIframeDocument, position, color, size, iconPath, topOffset, sideOffset);
                closeXButton.addEventListener('click', triggerClose);
                if (isSafari) {
                  var setPosition = function setPosition() {
                    return (0, _utils.setCloseButtonPosition)(activeIframe, closeXButton, position, sideOffset, topOffset);
                  };

                  /**
                   * Due to DOM manipulations made in other timeouts when painting the iframe,
                   * getBoundingClientRect() will not work unless it waits for those manipulations
                   * to complete. Setting a trivial timeout here to account for this.
                   */
                  setTimeout(function () {
                    setPosition();
                    document.body.appendChild(closeXButton);
                  }, 100);
                  var repositionCloseButton = function repositionCloseButton() {
                    return messagePosition !== 'Full' ? setPosition() : null;
                  };
                  __webpack_require__.g.addEventListener('resize', repositionCloseButton);
                } else {
                  activeIframeDocument === null || activeIframeDocument === void 0 ? void 0 : activeIframeDocument.body.appendChild(closeXButton);
                }
              }
            }

            /*
              track in-app consumes only when _saveToInbox_
              is falsy or undefined and always track in-app opens
               Also swallow any 400+ response errors. We don't care about them.
            */
            if (_constants.ENABLE_INAPP_CONSUME || _constants.IS_PRODUCTION) {
              var trackPayload = {
                messageId: activeMessage.messageId,
                deviceInfo: {
                  appPackageName: payload.packageName
                }
              };
              var trackRequests = [(0, _events.trackInAppOpen)(trackPayload)].concat((0, _toConsumableArray2["default"])(!activeMessage.saveToInbox ? [(0, _events.trackInAppConsume)(trackPayload)] : []));
              Promise.all(trackRequests)["catch"](function (e) {
                return e;
              });
            }

            /* now we'll add click tracking to _all_ anchor tags */
            var links = (activeIframeDocument === null || activeIframeDocument === void 0 ? void 0 : activeIframeDocument.querySelectorAll('a')) || [];
            links.forEach(function (link) {
              var clickedUrl = link.getAttribute('href') || '';
              var openInNewTab = link.getAttribute('target') === '_blank';
              var isIterableKeywordLink = !!clickedUrl.match(/iterable:\/\/|action:\/\//gim);
              var isDismissNode = !!clickedUrl.match(/iterable:\/\/dismiss/gim);
              var isActionLink = !!clickedUrl.match(/action:\/\//gim);
              var clickedHostname = (0, _utils.getHostnameFromUrl)(clickedUrl);
              /* !clickedHostname means the link was relative with no hostname */
              var isInternalLink = clickedHostname === __webpack_require__.g.location.host || !clickedHostname;
              var handleLinks = payload.handleLinks;

              /*
                If the _handleLinks_ option is set, we need to open links
                according to that enum and override their target attributes.
                 1. If _open-all-same-tab_, then open every link in the same tab
                2. If _open-all-new-tab_, then open every link in a new tab
                3. If _external-new-tab_, then open internal links in same tab, otherwise new tab.
                 This was a fix to account for the fact that Bee editor templates force
                target="_blank" on all links, so we gave this option as an escape hatch for that.
              */
              var manageHandleLinks = function manageHandleLinks(sameTabAction, newTabAction) {
                if (typeof handleLinks === 'string') {
                  if (handleLinks === _types.HandleLinks.OpenAllSameTab || isInternalLink && handleLinks === _types.HandleLinks.ExternalNewTab) {
                    sameTabAction();
                  } else {
                    newTabAction();
                  }
                }
              };
              if (isDismissNode || isActionLink) {
                /*
                  give the close anchor tag properties that make it
                  behave more like a button with a logical aria label
                */
                (0, _utils.addButtonAttrsToAnchorTag)(link, 'close modal');
              }

              /**
                Safari blocks all bound event handlers (including our click event handlers)
                in iframes, so links will not work in Safari unless we circumvent the
                restriction by appending target to each link tag.
                 @note Because click event handlers cannot be attached to iframe links in
                Safari, we cannot track in-app click metrics for Safari in Iterable analytics.
              */
              if (isSafari) {
                if (!isIterableKeywordLink) {
                  manageHandleLinks(function () {
                    return link.setAttribute('target', '_top');
                  }, function () {
                    link.setAttribute('target', '_blank');
                    link.setAttribute('rel', 'noopener noreferrer');
                  });
                  var targetAttr = link.getAttribute('target');
                  if (!handleLinks && (targetAttr === null || targetAttr === '_self')) {
                    link.setAttribute('target', '_top');
                  }
                }
              } else {
                link.addEventListener('click', function (event) {
                  /*
                    remove default linking behavior because we're in an iframe
                    so we need to link the user programatically
                  */
                  event.preventDefault();
                  if (clickedUrl) {
                    var isOpeningLinkInSameTab = !handleLinks && !openInNewTab || handleLinks === _types.HandleLinks.OpenAllSameTab || isInternalLink && handleLinks === _types.HandleLinks.ExternalNewTab;
                    (0, _events.trackInAppClick)({
                      clickedUrl: clickedUrl,
                      messageId: activeMessage === null || activeMessage === void 0 ? void 0 : activeMessage.messageId,
                      deviceInfo: {
                        appPackageName: dupedPayload.packageName
                      }
                    },
                    /*
                      only call with the fetch API if we're linking in the
                      same tab and it's not a reserved keyword link.
                    */
                    isOpeningLinkInSameTab && !isIterableKeywordLink
                    /* swallow the network error */)["catch"](function (e) {
                      return e;
                    });
                    if (isDismissNode || isActionLink) {
                      dismissMessage(activeIframe, clickedUrl);
                      document.removeEventListener('keydown', handleDocumentEscPress);
                      if (activeIframeDocument) {
                        activeIframeDocument.removeEventListener('keydown', handleIFrameEscPress);
                      }
                      __webpack_require__.g.removeEventListener('resize', throttledResize);
                    }
                    if (isActionLink) {
                      var _ref, _RegExp;
                      // eslint-disable-next-line prefer-regex-literals
                      var filteredMatch = (_ref = ((_RegExp = new RegExp(/^.*action:\/\/(.*)$/, 'gmi')) === null || _RegExp === void 0 ? void 0 : _RegExp.exec(clickedUrl)) || []) === null || _ref === void 0 ? void 0 : _ref[1];
                      /*
                        just post the message to the window when clicking
                        action:// links and early return
                      */
                      return __webpack_require__.g.postMessage({
                        type: 'iterable-action-link',
                        data: filteredMatch
                      }, '*');
                    }

                    /*
                      finally (since we're in an iframe), programatically click the link
                      and send the user to where they need to go, only if it's not one
                      of the reserved iterable keyword links
                    */
                    if (!isIterableKeywordLink) {
                      manageHandleLinks(function () {
                        return __webpack_require__.g.location.assign(clickedUrl);
                      }, function () {
                        __webpack_require__.g.open(clickedUrl, '_blank', 'noopener,noreferrer');
                      });
                      if (!handleLinks) {
                        if (openInNewTab) {
                          /**
                            Using target="_blank" without rel="noreferrer" and rel="noopener"
                            makes the website vulnerable to window.opener API exploitation attacks
                             @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#security_and_privacy
                          */
                          __webpack_require__.g.open(clickedUrl, '_blank', 'noopener,noreferrer');
                        } else __webpack_require__.g.location.assign(clickedUrl);
                      }
                    }
                  }
                });
              }
            });
            return activeIframe;
          });
        }
        return Promise.resolve('');
      };
      var isDeferred = options.display === _types.DisplayOptions.Deferred;
      var triggerDisplayFn = isDeferred ? {
        triggerDisplayMessages: function triggerDisplayMessages(messages) {
          parsedMessages = (0, _utils.filterHiddenInAppMessages)(messages);
          return paintMessageToDOM();
        }
      } : {};
      return _objectSpread({
        request: function request() {
          return (0, _request.requestMessages)({
            payload: dupedPayload
          }).then(function (response) {
            (0, _utils.trackMessagesDelivered)(response.data.inAppMessages || [], dupedPayload.packageName);
            return response;
          }).then(function (response) {
            if (isDeferred) {
              /*
                if the user passed "deferred" for the second argument to _getMessages_
                then they're going to choose to display the in-app messages when they want
                with the returned, _triggerDisplayMessages_ function. So early return here
                with no filtering or sorting.
              */
              return response;
            }
            /* otherwise, they're choosing to show the messages automatically */

            /*
              if the user passed the flag to automatically paint the in-app messages
              to the DOM, start a timer and show each in-app message upon close + timer countdown
               However there are 3 conditions in which to not show a message:
               1. _read_ key is truthy
              2. _trigger.type_ key is "never" (deliver silently is checked)
              3. HTML body is blank
              so first filter out unwanted messages and sort them
            */
            clearMessages();
            parsedMessages = (0, _utils.sortInAppMessages)((0, _utils.filterHiddenInAppMessages)(response.data.inAppMessages));
            return paintMessageToDOM().then(function () {
              return _objectSpread(_objectSpread({}, response), {}, {
                data: {
                  inAppMessages: parsedMessages
                }
              });
            });
          });
        },
        pauseMessageStream: function pauseMessageStream() {
          if (timer) {
            isPaused = true;
            clearTimeout(timer);
          }
        },
        resumeMessageStream: function resumeMessageStream() {
          if (isPaused) {
            isPaused = false;
            return paintMessageToDOM();
          }
        }
      }, triggerDisplayFn);
    }

    /*
      user doesn't want us to paint messages automatically.
      just return the promise like normal
    */
    return (0, _request.requestMessages)({
      payload: dupedPayload
    }).then(function (response) {
      var messages = response.data.inAppMessages;
      (0, _utils.trackMessagesDelivered)(messages || [], dupedPayload.packageName);
      var withIframes = messages === null || messages === void 0 ? void 0 : messages.map(function (message) {
        var _message$content;
        var html = (_message$content = message.content) === null || _message$content === void 0 ? void 0 : _message$content.html;
        return html ? (0, _set["default"])(message, 'content.html', (0, _utils.wrapWithIFrame)(html)) : message;
      });
      return _objectSpread(_objectSpread({}, response), {}, {
        data: _objectSpread(_objectSpread({}, response.data), {}, {
          inAppMessages: withIframes
        })
      });
    });
  }
});

/***/ }),

/***/ 11588:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(50255)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _yup) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.inAppMessagesParamSchema = _exports["default"] = void 0;
  var inAppMessagesParamSchema = _exports.inAppMessagesParamSchema = (0, _yup.object)().shape({
    displayInterval: (0, _yup.number)(),
    onOpenScreenReaderMessage: (0, _yup.string)(),
    onOpenNodeToTakeFocus: (0, _yup.string)(),
    count: (0, _yup.number)().required(),
    packageName: (0, _yup.string)().required(),
    platform: (0, _yup.string)().required()
  });
  var _default = _exports["default"] = inAppMessagesParamSchema;
});

/***/ }),

/***/ 93120:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(59845), __webpack_require__(7665), __webpack_require__(47033)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _inapp, _types, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_inapp).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _inapp[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _inapp[key];
      }
    });
  });
  Object.keys(_types).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _types[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _types[key];
      }
    });
  });
  Object.keys(_utils).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _utils[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _utils[key];
      }
    });
  });
});

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6944), __webpack_require__(17024), __webpack_require__(54402), __webpack_require__(54950), __webpack_require__(24678), __webpack_require__(41545), __webpack_require__(89293), __webpack_require__(9262), __webpack_require__(11588)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _slicedToArray2, _asyncToGenerator2, _defineProperty2, _idbKeyval, _constants, _request, _cache, _inapp) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.requestMessages = _exports.requestInAppMessages = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _slicedToArray2 = _interopRequireDefault(_slicedToArray2);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _inapp = _interopRequireDefault(_inapp);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable no-unreachable */
  var requestInAppMessages = _exports.requestInAppMessages = function requestInAppMessages(_ref) {
    var latestCachedMessageId = _ref.latestCachedMessageId,
      payload = _ref.payload;
    return (0, _request.baseIterableRequest)({
      method: 'GET',
      /** @note TBD: Parameter will be enabled once new endpoint is ready */
      // url: options?.useLocalCache ? CACHE_ENABLED_GETMESSAGES_PATH : GETMESSAGES_PATH,
      url: _constants.GETMESSAGES_PATH,
      validation: {
        params: _inapp["default"]
      },
      params: _objectSpread(_objectSpread({}, payload), {}, {
        platform: _constants.WEB_PLATFORM,
        SDKVersion: _constants.SDK_VERSION,
        latestCachedMessageId: latestCachedMessageId
      })
    });
  };
  var requestMessages = _exports.requestMessages = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref2) {
      var payload, cachedMessages, latestCachedMessageId, latestCreatedAtTimestamp, response, inAppMessages, allMessages, newMessages, cachedMessagesToDelete, _err$response$data$cl, _err$response, _err$response$data, _err$response$data$cl2, _err$response2, _err$response2$data;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            payload = _ref2.payload;
            return _context.abrupt("return", requestInAppMessages({
              payload: payload
            }));
          case 5:
            cachedMessages = _context.sent;
            latestCreatedAtTimestamp = 0;
            cachedMessages.forEach(function (_ref4) {
              var _ref5 = (0, _slicedToArray2["default"])(_ref4, 2),
                cachedMessageId = _ref5[0],
                cachedMessage = _ref5[1];
              if (cachedMessage.createdAt > latestCreatedAtTimestamp) {
                latestCachedMessageId = cachedMessageId;
                latestCreatedAtTimestamp = cachedMessage.createdAt;
              }
            });

            /**
             * Call getMessages with latestCachedMessageId to get the message delta
             * (uncached messages have full detail, rest just have messageId)
             */
            _context.next = 10;
            return requestInAppMessages({
              latestCachedMessageId: latestCachedMessageId,
              payload: payload
            });
          case 10:
            response = _context.sent;
            inAppMessages = response.data.inAppMessages;
            /** Combine cached messages with NEW messages in delta response */
            allMessages = [];
            newMessages = [];
            inAppMessages === null || inAppMessages === void 0 ? void 0 : inAppMessages.forEach(function (inAppMessage) {
              /**
               * If message in response has no content property, then that means it is
               * older than the latest cached message and should be retrieved from the
               * cache using the messageId
               *
               * Expecting messages with no content to look like the last 2 messages...
               * {
               *   inAppMessages: [
               *     { ...messageWithContentHasFullDetails01 },
               *     { ...messageWithContentHasFullDetails02 },
               *     { messageId: 'messageWithoutContentHasNoOtherProperties01' },
               *     { messageId: 'messageWithoutContentHasNoOtherProperties02' }
               *   ]
               * }
               */
              if (!inAppMessage.content) {
                var cachedMessage = cachedMessages.find(function (_ref6) {
                  var _ref7 = (0, _slicedToArray2["default"])(_ref6, 1),
                    messageId = _ref7[0];
                  return inAppMessage.messageId === messageId;
                });
                if (cachedMessage) allMessages.push(cachedMessage[1]);
              } else {
                allMessages.push(inAppMessage);
                if (inAppMessage.messageId) {
                  newMessages.push({
                    messageId: inAppMessage.messageId,
                    message: inAppMessage
                  });
                }
              }
            });

            /** Delete messages not present in fetch from cache */
            cachedMessagesToDelete = (0, _cache.getCachedMessagesToDelete)(cachedMessages, inAppMessages);
            _context.prev = 16;
            _context.next = 19;
            return (0, _idbKeyval.delMany)(cachedMessagesToDelete);
          case 19:
            _context.next = 24;
            break;
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](16);
            // eslint-disable-next-line no-console
            console.warn('Error deleting messages from the browser cache', (_err$response$data$cl = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.clientErrors) !== null && _err$response$data$cl !== void 0 ? _err$response$data$cl : _context.t0);
          case 24:
            _context.next = 26;
            return (0, _cache.addNewMessagesToCache)(newMessages);
          case 26:
            return _context.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
              data: {
                inAppMessages: allMessages
              }
            }));
          case 29:
            _context.prev = 29;
            _context.t1 = _context["catch"](2);
            // eslint-disable-next-line no-console
            console.warn('Error requesting in-app messages', (_err$response$data$cl2 = _context.t1 === null || _context.t1 === void 0 ? void 0 : (_err$response2 = _context.t1.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.clientErrors) !== null && _err$response$data$cl2 !== void 0 ? _err$response$data$cl2 : _context.t1);
          case 32:
            return _context.abrupt("return", requestInAppMessages({
              payload: payload
            }));
          case 33:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 29], [16, 21]]);
    }));
    return function requestMessages(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
});

/***/ }),

/***/ 7665:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.HandleLinks = _exports.DisplayPosition = _exports.DisplayOptions = _exports.CloseButtonPosition = void 0;
  /* eslint-disable no-use-before-define */
  var CloseButtonPosition = _exports.CloseButtonPosition = /*#__PURE__*/function (CloseButtonPosition) {
    CloseButtonPosition["TopLeft"] = "top-left";
    CloseButtonPosition["TopRight"] = "top-right";
    return CloseButtonPosition;
  }({});
  var HandleLinks = _exports.HandleLinks = /*#__PURE__*/function (HandleLinks) {
    HandleLinks["OpenAllNewTab"] = "open-all-new-tab";
    HandleLinks["OpenAllSameTab"] = "open-all-same-tab";
    HandleLinks["ExternalNewTab"] = "external-new-tab";
    return HandleLinks;
  }({});
  var DisplayOptions = _exports.DisplayOptions = /*#__PURE__*/function (DisplayOptions) {
    DisplayOptions["Immediate"] = "immediate";
    DisplayOptions["Deferred"] = "deferred";
    return DisplayOptions;
  }({});
  var DisplayPosition = _exports.DisplayPosition = /*#__PURE__*/function (DisplayPosition) {
    DisplayPosition["Center"] = "Center";
    DisplayPosition["TopRight"] = "TopRight";
    DisplayPosition["BottomRight"] = "BottomRight";
    DisplayPosition["Full"] = "Full";
    return DisplayPosition;
  }({});
});

/***/ }),

/***/ 47033:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(37289), __webpack_require__(44751), __webpack_require__(88133), __webpack_require__(53416), __webpack_require__(41545), __webpack_require__(30695), __webpack_require__(7665)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _toConsumableArray2, _sortby, _events, _config, _constants, _srSpeak, _types) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.wrapWithIFrame = _exports.trackMessagesDelivered = _exports.sortInAppMessages = _exports.setCloseButtonPosition = _exports.preloadImages = _exports.paintOverlay = _exports.paintIFrame = _exports.getHostnameFromUrl = _exports.generateWidth = _exports.generateLayoutCSS = _exports.generateCloseButton = _exports.generateAbsoluteDismissButton = _exports.filterOnlyReadAndNeverTriggerMessages = _exports.filterHiddenInAppMessages = _exports.addStyleSheet = _exports.addButtonAttrsToAnchorTag = void 0;
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  var _global, _global$matchMedia, _global2, _global2$matchMedia, _global3, _global3$matchMedia, _global4, _global4$matchMedia;
  /* eslint-disable no-return-assign */
  /* eslint-disable no-plusplus */
  /* eslint-disable no-loop-func */
  /* eslint-disable no-param-reassign */
  /* eslint-disable no-script-url */
  /* eslint-disable no-promise-executor-return */
  var generateWidth = _exports.generateWidth = function generateWidth(_ref, position) {
    var smMatches = _ref.smMatches,
      mdMatches = _ref.mdMatches,
      lgMatches = _ref.lgMatches,
      xlMatches = _ref.xlMatches;
    /*
      breakpoint widths are as follows:
       1. TopRight, BottomRight (100% at SM; 45% at MD; 33% at LG; 25% at XL)
      2. Center (100% at SM, MD; 50% at LG, XL)
      3. Full (100% all the time)
    */
    if (smMatches) {
      return '100%';
    }
    if (mdMatches) {
      if (position === 'TopRight' || position === 'BottomRight') {
        /*
          in-app messages is being initially painted, but we're on mobile
          breakpoints so remove any offsets the user provided in the config object.
        */
        return '45%';
      }
      return '50%';
    }
    if (lgMatches) {
      if (position === 'TopRight' || position === 'BottomRight') {
        return '33%';
      }
      return '50%';
    }
    if (xlMatches) {
      if (position === 'TopRight' || position === 'BottomRight') {
        return '25%';
      }
      return '50%';
    }

    /*
      this line will never run. One of those breakpoints has to return true
      but this is just to appease typescript.
    */
    return '100%';
  };
  var addStyleSheet = _exports.addStyleSheet = function addStyleSheet(doc, style) {
    var stylesheet = doc.createElement('style');
    stylesheet.textContent = style;
    doc.head.appendChild(stylesheet);
  };
  var preloadImages = _exports.preloadImages = function preloadImages(imageLinks, callback) {
    if (!(imageLinks !== null && imageLinks !== void 0 && imageLinks.length)) {
      callback();
    }
    var images = [];
    var loadedImages = 0;
    for (var i = 0; i < imageLinks.length; i++) {
      images[i] = new Image();
      images[i].src = imageLinks[i];
      images[i].loading = 'eager';
      images[i].onload = function () {
        /*
          track the amount of images we preloaded. If this is the last image
          that's been preloaded, it's time to invoke the callback function we passed.
        */
        if (loadedImages + 1 !== imageLinks.length) {
          return loadedImages += 1;
        }
        return callback();
      };

      /* do the same for onerror - if the images fail, we still need to show the message */
      images[i].onerror = function () {
        if (loadedImages + 1 !== imageLinks.length) {
          return loadedImages += 1;
        }
        return callback();
      };
    }
  };
  var filterHiddenInAppMessages = _exports.filterHiddenInAppMessages = function filterHiddenInAppMessages() {
    var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return messages.filter(function (eachMessage) {
      var _eachMessage$trigger, _eachMessage$content;
      return !eachMessage.read && ((_eachMessage$trigger = eachMessage.trigger) === null || _eachMessage$trigger === void 0 ? void 0 : _eachMessage$trigger.type) !== 'never' && !!((_eachMessage$content = eachMessage.content) !== null && _eachMessage$content !== void 0 && _eachMessage$content.html);
    });
  };
  var filterOnlyReadAndNeverTriggerMessages = _exports.filterOnlyReadAndNeverTriggerMessages = function filterOnlyReadAndNeverTriggerMessages() {
    var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return messages.filter(function (eachMessage) {
      var _eachMessage$trigger2;
      return !eachMessage.read && ((_eachMessage$trigger2 = eachMessage.trigger) === null || _eachMessage$trigger2 === void 0 ? void 0 : _eachMessage$trigger2.type) !== 'never';
    });
  };
  var sortInAppMessages = _exports.sortInAppMessages = function sortInAppMessages() {
    var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return messages.sort((0, _sortby.by)(['priorityLevel', 'asc'], ['createdAt', 'asc']));
  };
  var generateCloseButton = _exports.generateCloseButton = function generateCloseButton(id, doc, position, color, size, iconPath, topOffset, sideOffset) {
    var parsedSize = typeof size === 'number' ? "".concat(size, "px") : size || '24px';
    var sharedStyles = "\n    border: none;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n    overflow: visible;\n    background: transparent;\n    font: inherit;\n    line-height: normal;\n    -webkit-font-smoothing: inherit;\n    -moz-osx-font-smoothing: inherit;\n    -webkit-appearance: none;\n    position: absolute;\n    top: ".concat(topOffset || "".concat(_constants.DEFAULT_CLOSE_BUTTON_OFFSET_PERCENTAGE, "%"), ";\n    width: ").concat(parsedSize, ";\n    height: ").concat(parsedSize, ";\n    font-size: ").concat(parsedSize, ";\n    color: ").concat(color, ";\n    z-index: 1000000;\n  ");
    var button = doc.createElement('button');
    button.style.cssText = position === _types.CloseButtonPosition.TopLeft ? "\n    ".concat(sharedStyles, "\n    left: ").concat(sideOffset || "".concat(_constants.DEFAULT_CLOSE_BUTTON_OFFSET_PERCENTAGE, "%"), ";\n  ") : "\n    ".concat(sharedStyles, "\n    right: ").concat(sideOffset || "".concat(_constants.DEFAULT_CLOSE_BUTTON_OFFSET_PERCENTAGE, "%"), ";\n  ");
    if (iconPath) {
      button.style.backgroundImage = "url(".concat(iconPath, ")");
      button.style.backgroundSize = 'cover';
    } else {
      /* HTMl encoded "X" icon */
      button.innerHTML = '&#x2715';
    }
    button.ariaLabel = 'Close modal button';
    button.setAttribute('data-qa-custom-close-button', 'true');
    button.setAttribute('id', id);
    return button;
  };
  var generateAbsoluteDismissButton = _exports.generateAbsoluteDismissButton = function generateAbsoluteDismissButton(_ref2) {
    var id = _ref2.id,
      document = _ref2.document;
    var button = document.createElement('button');
    button.setAttribute('id', id);
    button.style.cssText = "\n    background: none;\n    color: inherit;\n    border: none;\n    padding: 0;\n    font: inherit;\n    cursor: unset;\n    outline: inherit;\n    height: 100vh;\n    width: 100vw;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: -1;\n  ";

    /* Don't let the user tab to this button. It's not necessary to tab over. */
    button.tabIndex = -1;
    return button;
  };
  var generateLayoutCSS = _exports.generateLayoutCSS = function generateLayoutCSS(baseCSSText, position, isMobileBreakpoint, topOffset, bottomOffset, rightOffset) {
    var styles = '';
    if (position === 'Center') {
      styles = "\n      left: 0%;\n      right: 0%;\n      top: 0%;\n      bottom: 0%;\n      max-height: ".concat(isMobileBreakpoint ? '85vh' : '95vh', ";\n    ");
    }
    if (position === 'TopRight') {
      styles = "\n      right: ".concat(isMobileBreakpoint ? '0%' : rightOffset || '0%', ";\n      top: ").concat(isMobileBreakpoint ? '0%' : topOffset || '0%', ";\n      max-height: ").concat(isMobileBreakpoint ? '85vh' : '95vh', ";\n    ");
    }
    if (position === 'BottomRight') {
      styles = "\n      right: ".concat(isMobileBreakpoint ? '0%' : rightOffset || '0%', ";\n      bottom: ").concat(isMobileBreakpoint ? '0%' : bottomOffset || '0%', ";\n      max-height: ").concat(isMobileBreakpoint ? '85vh' : '95vh', ";\n    ");
    }
    if (position === 'Full') {
      styles = "\n      height: 100%;\n      width: 100%;\n      left: 0%;\n      top: 0%;\n    ";
    }
    return "\n    ".concat(baseCSSText, "\n    ").concat(styles, "\n  ");
  };
  var mediaQuerySm = (_global = __webpack_require__.g) === null || _global === void 0 ? void 0 : (_global$matchMedia = _global.matchMedia) === null || _global$matchMedia === void 0 ? void 0 : _global$matchMedia.call(_global, '(max-width: 850px)');
  var mediaQueryMd = (_global2 = __webpack_require__.g) === null || _global2 === void 0 ? void 0 : (_global2$matchMedia = _global2.matchMedia) === null || _global2$matchMedia === void 0 ? void 0 : _global2$matchMedia.call(_global2, '(min-width: 851px) and (max-width: 975px)');
  var mediaQueryLg = (_global3 = __webpack_require__.g) === null || _global3 === void 0 ? void 0 : (_global3$matchMedia = _global3.matchMedia) === null || _global3$matchMedia === void 0 ? void 0 : _global3$matchMedia.call(_global3, '(min-width: 976px) and (max-width: 1300px)');
  var mediaQueryXl = (_global4 = __webpack_require__.g) === null || _global4 === void 0 ? void 0 : (_global4$matchMedia = _global4.matchMedia) === null || _global4$matchMedia === void 0 ? void 0 : _global4$matchMedia.call(_global4, '(min-width: 1301px)');

  /**
   *
   * @returns { HTMLIFrameElement } iframe with sandbox and hidden
   * styling applied for of an inapp message to render with
   */
  var generateSecuredIFrame = function generateSecuredIFrame() {
    var iframe = document.createElement('iframe');
    iframe.setAttribute('id', 'iterable-iframe');
    // allow-popups and allow-top-navigation is to enable links for Safari since the iframe will block
    // event handlers on elements in it preventing our custom link handling
    iframe.setAttribute('sandbox', "allow-same-origin allow-popups allow-top-navigation ".concat(_config.config.getConfig('dangerouslyAllowJsPopups') ? 'allow-popups-to-escape-sandbox' : ''));
    /*
      _display: none_ would remove the ability to set event handlers on elements
      so instead we choose to hide it visibly with CSS but not actually remove
      its interact-ability
       https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
    */
    iframe.style.cssText = "\n    position: fixed !important;\n    top: 0;\n    left: 0;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n  ";
    return iframe;
  };

  /**
   *
   * @param html
   * @returns { HTMLIFrameElement } iframe with html string of an inapp message wrapped in onload
   */
  var wrapWithIFrame = _exports.wrapWithIFrame = function wrapWithIFrame(html) {
    var iframe = generateSecuredIFrame();
    iframe.onload = function () {
      var _iframe$contentDocume;
      (_iframe$contentDocume = iframe.contentDocument) === null || _iframe$contentDocume === void 0 ? void 0 : _iframe$contentDocume.write(html);
    };
    return iframe;
  };

  /**
   * Default Chrome user agent stylesheet adds 8px margin to body element.
   * This unsets it so that it does not interfere with iframe sizing.
   */
  var unsetIframeBodyMargin = function unsetIframeBodyMargin(iframe) {
    var contentDocument = iframe.contentDocument;
    var margin = contentDocument === null || contentDocument === void 0 ? void 0 : contentDocument.body.style.margin;
    if (contentDocument && !margin) contentDocument.body.style.margin = '0px';
  };

  /**
   *
   * @param html html you want to paint to the DOM inside the iframe
   * @param position screen position the message should appear in
   * @param shouldAnimate if the in-app should animate in/out
   * @param srMessage The message you want the screen reader to read when popping up the message
   * @param topOffset how many px or % buffer between the in-app message and the top of the screen
   * @param bottomOffset how many px or % buffer between the in-app message
   * and the bottom of the screen
   * @param rightOffset how many px or % buffer between the in-app message and the right of the screen
   *
   * @returns { HTMLIFrameElement }
   */
  var paintIFrame = _exports.paintIFrame = function paintIFrame(html, position, shouldAnimate, srMessage, topOffset, bottomOffset, rightOffset) {
    return new Promise(function (resolve) {
      var iframe = generateSecuredIFrame();

      /*
        find all the images in the in-app message, preload them, and
        only then set the height because we need to know how tall the images
        are before we set the height of the iframe.
         This prevents a race condition where if we set the height before the images
        are loaded, we might end up with a scrolling iframe
      */
      var imageUrls = (html === null || html === void 0 ? void 0 : html.match(/\b(https?:\/\/\S+(?:png|jpe?g|gif)\S*)\b/gim)) || [];
      var imageTags = Array.from(new DOMParser().parseFromString(html, 'text/html').getElementsByTagName('img'));
      var imageTagUrls = imageTags.map(function (i) {
        return i.src;
      }).filter(function (src) {
        if (!imageUrls.length) return true;
        var imageUrlSet = new Set(imageUrls);
        return !imageUrlSet.has(src);
      });
      var imageLinks = [].concat((0, _toConsumableArray2["default"])(imageUrls), (0, _toConsumableArray2["default"])(imageTagUrls));
      return preloadImages(imageLinks, function () {
        var _iframe$contentDocume2, _iframe$contentDocume3, _iframe$contentDocume4;
        /*
          set the scroll height to the content inside, but since images
          are going to take some time to load, we opt to preload them, THEN
          set the inner HTML of the iframe
        */
        document.body.appendChild(iframe);
        (_iframe$contentDocume2 = iframe.contentDocument) === null || _iframe$contentDocume2 === void 0 ? void 0 : _iframe$contentDocume2.open();
        (_iframe$contentDocume3 = iframe.contentDocument) === null || _iframe$contentDocume3 === void 0 ? void 0 : _iframe$contentDocume3.write(html);
        (_iframe$contentDocume4 = iframe.contentDocument) === null || _iframe$contentDocume4 === void 0 ? void 0 : _iframe$contentDocume4.close();
        unsetIframeBodyMargin(iframe);
        var timeout = setTimeout(function () {
          /**
            even though we preloaded the images before setting the height, we add an extra 100MS
            here to handle for the case where the user needs to download custom fonts. As
            of 07/27/2021, the preloading fonts API is still in a draft state
             @see https://developer.mozilla.org/en-US/docs/Web/API/CSS_Font_Loading_API
             but even if we did preload the fonts, it would still take a non-trivial amount
            of computational time to apply the font to the text, so this setTimeout is acting more
            as a failsafe just incase the new font causes the line-height to grow and create a
            scrollbar in the iframe.
          */
          var setCSS = function setCSS(width) {
            iframe.style.cssText = generateLayoutCSS(shouldAnimate && (position === 'TopRight' || position === 'BottomRight') ? "\n              position: fixed;\n              border: none;\n              margin: auto;\n              max-width: 100%;\n              z-index: 9999;\n              transform: translateX(150%);\n              -webkit-transform: translateX(150%);\n              width: ".concat(width, ";\n              height: ").concat(iframe.style.height, ";\n            ") : "\n              position: fixed;\n              border: none;\n              margin: auto;\n              max-width: 100%;\n              z-index: 9999;\n              width: ".concat(width, ";\n              height: ").concat(iframe.style.height, ";\n            "), position, mediaQuerySm.matches, topOffset, bottomOffset, rightOffset);
          };
          if (shouldAnimate) {
            iframe.className = position === 'Center' || position === 'Full' ? 'fade-in' : 'slide-in';
          }
          var setNewWidth = function setNewWidth() {
            setCSS(generateWidth({
              smMatches: mediaQuerySm.matches,
              mdMatches: mediaQueryMd.matches,
              lgMatches: mediaQueryLg.matches,
              xlMatches: mediaQueryXl.matches
            }, position));
          };
          if (position === 'Full') {
            setCSS('100%');
          } else {
            var _iframe$contentDocume5, _iframe$contentDocume6;
            setNewWidth();
            mediaQuerySm.onchange = function () {
              setNewWidth();
            };
            mediaQueryMd.onchange = function () {
              setNewWidth();
            };
            mediaQueryLg.onchange = function () {
              setNewWidth();
            };
            mediaQueryXl.onchange = function () {
              setNewWidth();
            };
            var iframeHeight = (_iframe$contentDocume5 = iframe.contentDocument) === null || _iframe$contentDocume5 === void 0 ? void 0 : (_iframe$contentDocume6 = _iframe$contentDocume5.body) === null || _iframe$contentDocume6 === void 0 ? void 0 : _iframe$contentDocume6.scrollHeight;
            if (iframeHeight) iframe.style.height = "".concat(iframeHeight, "px");
          }
          clearTimeout(timeout);
        }, 100);
        resolve(iframe);
      });
    }).then(function (iframe) {
      if (srMessage) {
        (0, _srSpeak.srSpeak)(srMessage, 'assertive');
      }
      iframe.onload = function () {
        if (position !== 'Full') {
          var _iframe$contentDocume7, _iframe$contentDocume8;
          var scrollHeight = (_iframe$contentDocume7 = (_iframe$contentDocume8 = iframe.contentDocument) === null || _iframe$contentDocume8 === void 0 ? void 0 : _iframe$contentDocume8.body.scrollHeight) !== null && _iframe$contentDocume7 !== void 0 ? _iframe$contentDocume7 : 0;
          if (scrollHeight) iframe.style.height = "".concat(scrollHeight, "px");
        }
      };
      return iframe;
    });
  };
  var addButtonAttrsToAnchorTag = _exports.addButtonAttrsToAnchorTag = function addButtonAttrsToAnchorTag(node, ariaLabel) {
    node.setAttribute('aria-label', ariaLabel);
    node.setAttribute('role', 'button');
    node.setAttribute('data-qa-original-link', node.getAttribute('href') || '');
    node.setAttribute('href', 'javascript:undefined');
  };
  var trackMessagesDelivered = _exports.trackMessagesDelivered = function trackMessagesDelivered() {
    var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var packageName = arguments.length > 1 ? arguments[1] : undefined;
    return Promise.all(messages === null || messages === void 0 ? void 0 : messages.map(function (eachMessage) {
      return (0, _events.trackInAppDelivery)({
        messageId: eachMessage.messageId,
        deviceInfo: {
          appPackageName: packageName
        }
        /*
          swallow any network failures.
          If it fails, there's nothing really we can do here.
        */
      });
    }))["catch"](function (e) {
      return e;
    });
  };
  var paintOverlay = _exports.paintOverlay = function paintOverlay() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#fff';
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var overlay = document.createElement('div');
    overlay.setAttribute('data-test-overlay', 'true');
    if (shouldAnimate) {
      addStyleSheet(document, "\n        @keyframes fadeinfast {\n          from { opacity: 0; }\n          to { opacity: ".concat(opacity, "; }\n        }\n      \n        @-moz-keyframes fadeinfast {\n          from { opacity: 0; }\n          to { opacity: ").concat(opacity, "; }\n        }\n      \n        @-webkit-keyframes fadeinfast {\n          from { opacity: 0; }\n          to { opacity: ").concat(opacity, "; }\n        }\n      \n        @-ms-keyframes fadeinfast {\n          from { opacity: 0; }\n          to { opacity: ").concat(opacity, "; }\n        }    \n    "));
    }
    overlay.style.cssText = shouldAnimate ? "\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    background-color: ".concat(color, ";\n    opacity: ").concat(opacity, ";\n    top: 0;\n    left: 0;\n    z-index: 9998;\n    -webkit-animation: fadeinfast ").concat(_constants.ANIMATION_DURATION / 2, "ms;\n    -moz-animation: fadeinfast ").concat(_constants.ANIMATION_DURATION / 2, "ms;\n    -ms-animation: fadeinfast ").concat(_constants.ANIMATION_DURATION / 2, "ms;\n    -o-animation: fadeinfast ").concat(_constants.ANIMATION_DURATION / 2, "ms;\n    animation: fadeinfast ").concat(_constants.ANIMATION_DURATION / 2, "ms;\n  ") : "\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    background-color: ".concat(color, ";\n    opacity: ").concat(opacity, ";\n    top: 0;\n    left: 0;\n    z-index: 9998;\n  ");
    document.body.appendChild(overlay);
    return overlay;
  };
  var getHostnameFromUrl = _exports.getHostnameFromUrl = function getHostnameFromUrl(url) {
    var linkHost = url.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i);
    return linkHost === null || linkHost === void 0 ? void 0 : linkHost[1];
  };
  var setCloseButtonPosition = _exports.setCloseButtonPosition = function setCloseButtonPosition(iframe, closeButton, position, sideOffset, topOffset) {
    var iframeRect = iframe.getBoundingClientRect();
    var defaultOffset = _constants.DEFAULT_CLOSE_BUTTON_OFFSET_PERCENTAGE / 100;
    var defaultTop = defaultOffset * iframeRect.height;
    var defaultSide = defaultOffset * iframeRect.width;
    var buttonWidth = parseInt(closeButton.style.width, 10);
    var iframeRightEdge = iframeRect.right - buttonWidth;
    closeButton.style.top = topOffset ? "calc(".concat(iframeRect.top, "px + ").concat(topOffset, ")") : "".concat(iframeRect.top + defaultTop, "px");
    if (position === _types.CloseButtonPosition.TopLeft) {
      closeButton.style.left = sideOffset ? "calc(".concat(iframeRect.left, "px + ").concat(sideOffset, ")") : "".concat(iframeRect.left + defaultSide, "px");
    } else {
      closeButton.style.left = sideOffset ? "calc(".concat(iframeRightEdge, "px - ").concat(sideOffset, ")") : "".concat(iframeRightEdge - defaultSide, "px");
    }
  };
});

/***/ }),

/***/ 89293:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(54950), __webpack_require__(97218), __webpack_require__(80129), __webpack_require__(41545), __webpack_require__(53416)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _axios, _qs, _constants, _config) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.baseIterableRequest = _exports.baseAxiosRequest = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _axios = _interopRequireDefault(_axios);
  _qs = _interopRequireDefault(_qs);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var baseAxiosRequest = _exports.baseAxiosRequest = _axios["default"].create({
    baseURL: _constants.BASE_URL
  });
  var baseIterableRequest = _exports.baseIterableRequest = function baseIterableRequest(payload) {
    try {
      var _payload$validation, _payload$validation2;
      if ((_payload$validation = payload.validation) !== null && _payload$validation !== void 0 && _payload$validation.data && payload.data) {
        payload.validation.data.validateSync(payload.data, {
          abortEarly: false
        });
      }
      if ((_payload$validation2 = payload.validation) !== null && _payload$validation2 !== void 0 && _payload$validation2.params && payload.params) {
        payload.validation.params.validateSync(payload.params, {
          abortEarly: false
        });
      }
      var baseURL = _config.config.getConfig('isEuIterableService') ? _constants.EU_ITERABLE_API : _config.config.getConfig('baseURL');
      return baseAxiosRequest(_objectSpread(_objectSpread({}, payload), {}, {
        baseURL: baseURL,
        headers: _objectSpread(_objectSpread({}, payload.headers), _constants.STATIC_HEADERS),
        paramsSerializer: function paramsSerializer(params) {
          return _qs["default"].stringify(params, {
            arrayFormat: 'repeat'
          });
        }
      }));
    } catch (error) {
      var _inner;
      /* match Iterable's API error schema and add client errors as a new key */
      var newError = {
        code: 'GenericError',
        msg: 'Client-side error',
        clientErrors: (_inner = error.inner) === null || _inner === void 0 ? void 0 : _inner.map(function (eachError) {
          return {
            error: eachError.message,
            field: eachError.path
          };
        })
      };
      /* match Axios' Error object schema and reject */
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({
        response: {
          data: newError,
          status: 400,
          statusText: '',
          headers: {},
          config: {}
        }
      });
    }
  };
});

/***/ }),

/***/ 58064:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(95357), __webpack_require__(41205)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _types, _users) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_types).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _types[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _types[key];
      }
    });
  });
  Object.keys(_users).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _users[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _users[key];
      }
    });
  });
});

/***/ }),

/***/ 95357:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";
});

/***/ }),

/***/ 41205:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(54950), __webpack_require__(50255), __webpack_require__(41545), __webpack_require__(89293), __webpack_require__(25090)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _yup, _constants, _request, _users) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.updateUserEmail = _exports.updateUser = _exports.updateSubscriptions = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // eslint-disable @typescript-eslint/no-explicit-any
  var updateUserEmail = _exports.updateUserEmail = function updateUserEmail(newEmail) {
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.update_email.route,
      data: {
        newEmail: newEmail
      },
      validation: {
        data: (0, _yup.object)().shape({
          newEmail: (0, _yup.string)().required()
        })
      }
    });
  };
  var updateUser = _exports.updateUser = function updateUser() {
    var payloadParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    /* a customer could potentially send these up if they're not using TypeScript */
    var payload = payloadParam;
    delete payload.userId;
    delete payload.email;
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.users_update.route,
      data: _objectSpread(_objectSpread({}, payload), {}, {
        preferUserId: true
      }),
      validation: {
        data: _users.updateUserSchema
      }
    });
  };
  var updateSubscriptions = _exports.updateSubscriptions = function updateSubscriptions() {
    var payloadParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    /* a customer could potentially send these up if they're not using TypeScript */
    var payload = payloadParam;
    delete payload.userId;
    delete payload.email;
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.users_update_subscriptions.route,
      data: payload,
      validation: {
        data: _users.updateSubscriptionsSchema
      }
    });
  };
});

/***/ }),

/***/ 25090:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(50255)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _yup) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.updateUserSchema = _exports.updateSubscriptionsSchema = void 0;
  var updateUserSchema = _exports.updateUserSchema = (0, _yup.object)().shape({
    dataFields: (0, _yup.object)(),
    preferUserId: (0, _yup["boolean"])(),
    mergeNestedObjects: (0, _yup["boolean"])()
  });
  var updateSubscriptionsSchema = _exports.updateSubscriptionsSchema = (0, _yup.object)().shape({
    emailListIds: (0, _yup.array)((0, _yup.number)()),
    unsubscribedChannelIds: (0, _yup.array)((0, _yup.number)()),
    unsubscribedMessageTypeIds: (0, _yup.array)((0, _yup.number)()),
    subscribedMessageTypeIds: (0, _yup.array)((0, _yup.number)()),
    campaignId: (0, _yup.number)(),
    templateId: (0, _yup.number)()
  });
});

/***/ }),

/***/ 90422:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(11247), __webpack_require__(84665), __webpack_require__(25389), __webpack_require__(92667), __webpack_require__(17723), __webpack_require__(20033), __webpack_require__(41545)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _classCallCheck2, _createClass2, _IterableConfig, _constants) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.IterableActionRunner = void 0;
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
  var IterableActionRunnerImpl = /*#__PURE__*/function () {
    function IterableActionRunnerImpl() {
      (0, _classCallCheck2["default"])(this, IterableActionRunnerImpl);
    }
    (0, _createClass2["default"])(IterableActionRunnerImpl, null, [{
      key: "executeAction",
      value: function executeAction(context, action, source) {
        if (action === null) {
          return false;
        }
        var actionContext = {
          action: action,
          source: source
        };
        if (action.type === _constants.URL_SCHEME_OPEN) {
          return IterableActionRunnerImpl.openUri(action.data, actionContext);
        }
        return IterableActionRunnerImpl.callCustomActionIfSpecified(action, actionContext);
      }
    }, {
      key: "openUri",
      value: function openUri(uri, actionContext) {
        if (_IterableConfig.IterableConfig.urlHandler) {
          if (_IterableConfig.IterableConfig.urlHandler.handleIterableURL(uri, actionContext)) {
            return true;
          }
        }
        window.open(uri, '_blank');
        return true;
      }
    }, {
      key: "callCustomActionIfSpecified",
      value: function callCustomActionIfSpecified(action, actionContext) {
        if (action.type && action.type !== '') {
          if (_IterableConfig.IterableConfig.customActionHandler) {
            return _IterableConfig.IterableConfig.customActionHandler.handleIterableCustomAction(action, actionContext);
          }
        }
        return false;
      }
    }]);
    return IterableActionRunnerImpl;
  }();
  var IterableActionRunner = _exports.IterableActionRunner = /*#__PURE__*/function (_IterableActionRunner) {
    (0, _inherits2["default"])(IterableActionRunner, _IterableActionRunner);
    var _super = _createSuper(IterableActionRunner);
    function IterableActionRunner() {
      (0, _classCallCheck2["default"])(this, IterableActionRunner);
      return _super.apply(this, arguments);
    }
    return (0, _createClass2["default"])(IterableActionRunner);
  }(IterableActionRunnerImpl);
});

/***/ }),

/***/ 20033:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(17723), __webpack_require__(92667), __webpack_require__(54950)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _createClass2, _classCallCheck2, _defineProperty2) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.IterableConfig = void 0;
  _createClass2 = _interopRequireDefault(_createClass2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  var IterableConfig = _exports.IterableConfig = /*#__PURE__*/(0, _createClass2["default"])(function IterableConfig() {
    (0, _classCallCheck2["default"])(this, IterableConfig);
  });
  (0, _defineProperty2["default"])(IterableConfig, "urlHandler", null);
  (0, _defineProperty2["default"])(IterableConfig, "customActionHandler", null);
});

/***/ }),

/***/ 53416:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(54950), __webpack_require__(41545)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _constants) {
  "use strict";

  var _interopRequireDefault = __webpack_require__(81184);
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = _exports.config = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _config = function _config() {
    var options = {
      logLevel: 'none',
      baseURL: _constants.BASE_URL,
      isEuIterableService: false,
      dangerouslyAllowJsPopups: false
    };
    var getConfig = function getConfig(option) {
      return options[option];
    };
    return {
      getConfig: getConfig,
      setConfig: function setConfig(newOptions) {
        options = _objectSpread(_objectSpread({}, options), newOptions);
      }
    };
  };
  var config = _exports.config = _config();
  var _default = _exports["default"] = config;
});

/***/ }),

/***/ 30695:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.srSpeak = _exports["default"] = void 0;
  /**
    sends aria-live messages when new content mounts. Useful for in-app messaging
    to let the user know an iframe message has opened
  
    @thanks https://a11y-guidelines.orange.com/en/web/components-examples/make-a-screen-reader-talk/
  */
  var srSpeak = _exports.srSpeak = function srSpeak(text, priority) {
    var el = document.createElement('div');
    var id = "speak-".concat(Math.random().toString(36).substr(2, 9));
    el.setAttribute('id', id);
    el.setAttribute('data-test-id', 'sr-speak');
    el.setAttribute('aria-live', priority || 'polite');
    /*
      _display: none_ would cause the SR to not read the message so this just
      hides the message visibly, while still appearing in the DOM
       https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
    */
    el.style.cssText = "\n    position: absolute !important;\n    height: 1px;\n    width: 1px;\n    overflow: hidden;\n    clip: rect(1px 1px 1px 1px);\n    clip: rect(1px, 1px, 1px, 1px);\n  ";
    el.classList.add('sr-only');
    document.body.appendChild(el);
    var elementById = document.getElementById(id);
    if (elementById) {
      __webpack_require__.g.setTimeout(function () {
        elementById.innerText = text;
      }, 100);
      __webpack_require__.g.setTimeout(function () {
        document.body.removeChild(elementById);
      }, 1000);
    }
  };
  var _default = _exports["default"] = srSpeak;
});

/***/ }),

/***/ 1699:
/***/ (function(module) {

"use strict";
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */


function Cache(maxSize) {
  this._maxSize = maxSize
  this.clear()
}
Cache.prototype.clear = function () {
  this._size = 0
  this._values = Object.create(null)
}
Cache.prototype.get = function (key) {
  return this._values[key]
}
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear()
  if (!(key in this._values)) this._size++

  return (this._values[key] = value)
}

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE)

var config

module.exports = {
  Cache: Cache,

  split: split,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path)

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0
        var len = parts.length
        var data = obj

        while (index < len - 1) {
          var part = parts[index]
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]]
        }
        data[parts[index]] = value
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path)
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]]
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg)
  },
}

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split(path) {
  return path.match(SPLIT_REGEX) || ['']
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),

/***/ 50255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ArraySchema": function() { return /* reexport */ ArraySchema; },
  "BaseSchema": function() { return /* reexport */ BaseSchema; },
  "BooleanSchema": function() { return /* reexport */ BooleanSchema; },
  "DateSchema": function() { return /* reexport */ DateSchema; },
  "MixedSchema": function() { return /* reexport */ es_mixed; },
  "NumberSchema": function() { return /* reexport */ NumberSchema; },
  "ObjectSchema": function() { return /* reexport */ ObjectSchema; },
  "StringSchema": function() { return /* reexport */ StringSchema; },
  "ValidationError": function() { return /* reexport */ ValidationError; },
  "addMethod": function() { return /* binding */ addMethod; },
  "array": function() { return /* reexport */ array_create; },
  "bool": function() { return /* reexport */ boolean_create; },
  "boolean": function() { return /* reexport */ boolean_create; },
  "date": function() { return /* reexport */ date_create; },
  "isSchema": function() { return /* reexport */ util_isSchema; },
  "lazy": function() { return /* reexport */ Lazy_create; },
  "mixed": function() { return /* reexport */ mixed_create; },
  "number": function() { return /* reexport */ number_create; },
  "object": function() { return /* reexport */ object_create; },
  "reach": function() { return /* reexport */ util_reach; },
  "ref": function() { return /* reexport */ create; },
  "setLocale": function() { return /* reexport */ setLocale; },
  "string": function() { return /* reexport */ string_create; }
});

;// CONCATENATED MODULE: ./node_modules/nanoclone/src/index.js
// ES6 Map
var map
try {
  map = Map
} catch (_) { }
var set

// ES6 Set
try {
  set = Set
} catch (_) { }

function baseClone (src, circulars, clones) {
  // Null/undefined/functions/etc
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src
  }

  // DOM Node
  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true)
  }

  // Date
  if (src instanceof Date) {
    return new Date(src.getTime())
  }

  // RegExp
  if (src instanceof RegExp) {
    return new RegExp(src)
  }

  // Arrays
  if (Array.isArray(src)) {
    return src.map(clone)
  }

  // ES6 Maps
  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()))
  }

  // ES6 Sets
  if (set && src instanceof set) {
    return new Set(Array.from(src.values()))
  }

  // Object
  if (src instanceof Object) {
    circulars.push(src)
    var obj = Object.create(src)
    clones.push(obj)
    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key]
      })
      obj[key] = idx > -1 ? clones[idx] : baseClone(src[key], circulars, clones)
    }
    return obj
  }

  // ???
  return src
}

function clone (src) {
  return baseClone(src, [], [])
}

;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/util/printValue.js
const printValue_toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = printValue_toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/locale.js

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let locale_boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
/* harmony default export */ var locale = (Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean: locale_boolean
}));
// EXTERNAL MODULE: ./node_modules/lodash/has.js
var has = __webpack_require__(18721);
var has_default = /*#__PURE__*/__webpack_require__.n(has);
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/util/isSchema.js
const isSchema = obj => obj && obj.__isYupSchema__;

/* harmony default export */ var util_isSchema = (isSchema);
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/Condition.js



class Condition {
  constructor(refs, options) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!has_default()(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);

    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!util_isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }

}

/* harmony default export */ var es_Condition = (Condition);
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/util/toArray.js
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/ValidationError.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }

  static isError(err) {
    return err && err.name === 'ValidationError';
  }

  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

}
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/util/runTests.js


const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};

function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}
// EXTERNAL MODULE: ./node_modules/lodash/mapValues.js
var mapValues = __webpack_require__(66604);
var mapValues_default = /*#__PURE__*/__webpack_require__.n(mapValues);
// EXTERNAL MODULE: ./node_modules/@iterable/web-sdk/node_modules/property-expr/index.js
var property_expr = __webpack_require__(1699);
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/Reference.js

const prefixes = {
  context: '$',
  value: '.'
};
function create(key, options) {
  return new Reference(key, options);
}
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && (0,property_expr.getter)(this.path, true);
    this.map = options.map;
  }

  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */


  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }

  resolve() {
    return this;
  }

  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }

  toString() {
    return `Ref(${this.key})`;
  }

  static isRef(value) {
    return value && value.__isYupRef;
  }

} // @ts-ignore

Reference.prototype.__isYupRef = true;
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/util/createValidation.js
function createValidation_extends() { createValidation_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return createValidation_extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError(overrides = {}) {
      const nextParams = mapValues_default()(createValidation_extends({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    let ctx = createValidation_extends({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }

      return;
    }

    let result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/util/reach.js


let trim = part => part.substr(0, part.length - 1).substr(1);

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  (0,property_expr.forEach)(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });

    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

const reach = (obj, path, value, context) => getIn(obj, path, value, context).schema;

/* harmony default export */ var util_reach = (reach);
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/util/ReferenceSet.js

class ReferenceSet {
  constructor() {
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }

  get size() {
    return this.list.size + this.refs.size;
  }

  describe() {
    const description = [];

    for (const item of this.list) description.push(item);

    for (const [, ref] of this.refs) description.push(ref.describe());

    return description;
  }

  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }

  resolveAll(resolve) {
    return this.toArray().reduce((acc, e) => acc.concat(Reference.isRef(e) ? resolve(e) : e), []);
  }

  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }

  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }

  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }

  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }

}
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/schema.js
function schema_extends() { schema_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return schema_extends.apply(this, arguments); }

// @ts-ignore










 // const UNSET = 'unset' as const;

class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = schema_extends({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  get _type() {
    return this.type;
  }

  _typeCheck(_value) {
    return true;
  }

  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    } // if the nested value is a schema we can skip cloning, since
    // they are already immutable


    const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = schema_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly

    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(schema_extends({}, this.spec, spec));
    return next;
  }

  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }

  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  } // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }


  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }

  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();

    const mergedSpec = schema_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
    //   mergedSpec.nullable = base.spec.nullable;
    // if (combined.spec.presence === UNSET)
    //   mergedSpec.presence = base.spec.presence;


    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
    // the deduping logic is consistent

    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }

  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }

  resolve(options) {
    let schema = this;

    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }

    return schema;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */


  cast(value, options = {}) {
    let resolvedSchema = this.resolve(schema_extends({
      value
    }, options));

    let result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }

    return result;
  }

  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);

    if (value === undefined) {
      value = this.getDefault();
    }

    return value;
  }

  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;

    if (!strict) {
      // this._validating = true;
      value = this._cast(value, schema_extends({
        assert: false
      }, options)); // this._validating = false;
    } // value is cast, we can check if it meets type requirements


    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    let finalTests = [];
    if (this._whitelistError) finalTests.push(this._whitelistError);
    if (this._blacklistError) finalTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests.concat(finalTests),
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }

  validate(value, options, maybeCb) {
    let schema = this.resolve(schema_extends({}, options, {
      value
    })); // callback case is for nested validations

    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }

  validateSync(value, options) {
    let schema = this.resolve(schema_extends({}, options, {
      value
    }));
    let result;

    schema._validate(value, schema_extends({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });

    return result;
  }

  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }

  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }

  _getDefault() {
    let defaultValue = this.spec.default;

    if (defaultValue == null) {
      return defaultValue;
    }

    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone(defaultValue);
  }

  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }

  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }

    let next = this.clone({
      default: def
    });
    return next;
  }

  strict(isStrict = true) {
    let next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }

  _isPresent(value) {
    return value != null;
  }

  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,

      test(value) {
        return value !== undefined;
      }

    });
  }

  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,

      test(value) {
        return this.schema._isPresent(value);
      }

    }));
  }

  notRequired() {
    let next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }

  nullable(isNullable = true) {
    let next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }

  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */


  test(...args) {
    let opts;

    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }

    if (opts.message === undefined) opts.message = mixed["default"];
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  }

  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }

    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new es_Condition(deps, options));
    return next;
  }

  typeError(message) {
    let next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',

      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }

    });
    return next;
  }

  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',

      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: valids.toArray().join(', '),
            resolved
          }
        });
      }

    });
    return next;
  }

  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',

      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: invalids.toArray().join(', '),
            resolved
          }
        });
        return true;
      }

    });
    return next;
  }

  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars

// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;

for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], schema_extends({}, options, {
    parent,
    path
  }));
};

for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;

for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/mixed.js

const Mixed = BaseSchema;
/* harmony default export */ var es_mixed = (Mixed);
function mixed_create() {
  return new Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class

mixed_create.prototype = Mixed.prototype;
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/util/isAbsent.js
const isAbsent = value => value == null;

/* harmony default export */ var util_isAbsent = (isAbsent);
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/boolean.js



function boolean_create() {
  return new BooleanSchema();
}
class BooleanSchema extends BaseSchema {
  constructor() {
    super({
      type: 'boolean'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }

        return value;
      });
    });
  }

  _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }

  isTrue(message = locale_boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'true'
      },

      test(value) {
        return util_isAbsent(value) || value === true;
      }

    });
  }

  isFalse(message = locale_boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'false'
      },

      test(value) {
        return util_isAbsent(value) || value === false;
      }

    });
  }

}
boolean_create.prototype = BooleanSchema.prototype;
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/string.js


 // eslint-disable-next-line

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

let isTrimmed = value => util_isAbsent(value) || value === value.trim();

let objStringTag = {}.toString();
function string_create() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }

  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }

  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return util_isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;

    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => util_isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }

  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }

  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }

  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  } //-- transforms --


  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }

  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }

  lowercase(message = string.lowercase) {
    return this.transform(value => !util_isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => util_isAbsent(value) || value === value.toLowerCase()
    });
  }

  uppercase(message = string.uppercase) {
    return this.transform(value => !util_isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => util_isAbsent(value) || value === value.toUpperCase()
    });
  }

}
string_create.prototype = StringSchema.prototype; //
// String Interfaces
//
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/number.js




let number_isNaN = value => value != +value;

function number_create() {
  return new NumberSchema();
}
class NumberSchema extends BaseSchema {
  constructor() {
    super({
      type: 'number'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        let parsed = value;

        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

          parsed = +parsed;
        }

        if (this.isType(parsed)) return parsed;
        return parseFloat(parsed);
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !number_isNaN(value);
  }

  min(min, message = number.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value >= this.resolve(min);
      }

    });
  }

  max(max, message = number.max) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value <= this.resolve(max);
      }

    });
  }

  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        less
      },

      test(value) {
        return util_isAbsent(value) || value < this.resolve(less);
      }

    });
  }

  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        more
      },

      test(value) {
        return util_isAbsent(value) || value > this.resolve(more);
      }

    });
  }

  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }

  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }

  integer(message = number.integer) {
    return this.test({
      name: 'integer',
      message,
      test: val => util_isAbsent(val) || Number.isInteger(val)
    });
  }

  truncate() {
    return this.transform(value => !util_isAbsent(value) ? value | 0 : value);
  }

  round(method) {
    var _method;

    let avail = ['ceil', 'floor', 'round', 'trunc'];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(value => !util_isAbsent(value) ? Math[method](value) : value);
  }

}
number_create.prototype = NumberSchema.prototype; //
// Number Interfaces
//
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/util/isodate.js
/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) struct[k] = +struct[k] || 0; // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/date.js
// @ts-ignore





let invalidDate = new Date('');

let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';

function date_create() {
  return new DateSchema();
}
class DateSchema extends BaseSchema {
  constructor() {
    super({
      type: 'date'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        value = parseIsoDate(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
  }

  _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  }

  prepareParam(ref, name) {
    let param;

    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }

    return param;
  }

  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return util_isAbsent(value) || value >= this.resolve(limit);
      }

    });
  }

  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value <= this.resolve(limit);
      }

    });
  }

}
DateSchema.INVALID_DATE = invalidDate;
date_create.prototype = DateSchema.prototype;
date_create.INVALID_DATE = invalidDate;
// EXTERNAL MODULE: ./node_modules/lodash/snakeCase.js
var snakeCase = __webpack_require__(11865);
var snakeCase_default = /*#__PURE__*/__webpack_require__.n(snakeCase);
// EXTERNAL MODULE: ./node_modules/lodash/camelCase.js
var camelCase = __webpack_require__(68929);
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);
// EXTERNAL MODULE: ./node_modules/lodash/mapKeys.js
var mapKeys = __webpack_require__(67523);
var mapKeys_default = /*#__PURE__*/__webpack_require__.n(mapKeys);
// EXTERNAL MODULE: ./node_modules/toposort/index.js
var toposort = __webpack_require__(94633);
var toposort_default = /*#__PURE__*/__webpack_require__.n(toposort);
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/util/sortFields.js
 // @ts-expect-error





function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));

  function addNode(depPath, key) {
    let node = (0,property_expr.split)(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }

  for (const key in fields) if (has_default()(fields, key)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (util_isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }

  return toposort_default().array(Array.from(nodes), edges).reverse();
}
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/util/sortByKeyOrder.js
function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;

    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/object.js
function object_extends() { object_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return object_extends.apply(this, arguments); }














let isObject = obj => Object.prototype.toString.call(obj) === '[object Object]';

function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}

const defaultSort = sortByKeyOrder([]);
class ObjectSchema extends BaseSchema {
  constructor(spec) {
    super({
      type: 'object'
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      this.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }

        if (this.isType(value)) return value;
        return null;
      });

      if (spec) {
        this.shape(spec);
      }
    });
  }

  _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  }

  _cast(_value, options = {}) {
    var _options$stripUnknown;

    let value = super._cast(_value, options); //should ignore nulls here


    if (value === undefined) return this.getDefault();
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;

    let props = this._nodes.concat(Object.keys(value).filter(v => this._nodes.indexOf(v) === -1));

    let intermediateValue = {}; // is filled during the transform below

    let innerOptions = object_extends({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });

    let isChanged = false;

    for (const prop of props) {
      let field = fields[prop];
      let exists = has_default()(value, prop);

      if (field) {
        let fieldValue;
        let inputValue = value[prop]; // safe to mutate since this is fired in sequence

        innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];

        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = 'spec' in field ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;

        if (fieldSpec == null ? void 0 : fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }

        fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];

        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }

      if (intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }

    return isChanged ? intermediateValue : value;
  }

  _validate(_value, opts = {}, callback) {
    let errors = [];
    let {
      sync,
      from = [],
      originalValue = _value,
      abortEarly = this.spec.abortEarly,
      recursive = this.spec.recursive
    } = opts;
    from = [{
      schema: this,
      value: originalValue
    }, ...from]; // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating

    opts.__validating = true;
    opts.originalValue = originalValue;
    opts.from = from;

    super._validate(_value, opts, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || abortEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !isObject(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value;

      let tests = this._nodes.map(key => (_, cb) => {
        let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
        let field = this.fields[key];

        if (field && 'validate' in field) {
          field.validate(value[key], object_extends({}, opts, {
            // @ts-ignore
            path,
            from,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: true,
            parent: value,
            originalValue: originalValue[key]
          }), cb);
          return;
        }

        cb(null);
      });

      runTests({
        sync,
        tests,
        value,
        errors,
        endEarly: abortEarly,
        sort: this._sortErrors,
        path: opts.path
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.fields = object_extends({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;

    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];

      if (target === undefined) {
        nextFields[field] = schemaOrRef;
      } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
        nextFields[field] = schemaOrRef.concat(target);
      }
    }

    return next.withMutation(() => next.shape(nextFields, this._excludedEdges));
  }

  getDefaultFromShape() {
    let dft = {};

    this._nodes.forEach(key => {
      const field = this.fields[key];
      dft[key] = 'default' in field ? field.getDefault() : undefined;
    });

    return dft;
  }

  _getDefault() {
    if ('default' in this.spec) {
      return super._getDefault();
    } // if there is no default set invent one


    if (!this._nodes.length) {
      return undefined;
    }

    return this.getDefaultFromShape();
  }

  shape(additions, excludes = []) {
    let next = this.clone();
    let fields = Object.assign(next.fields, additions);
    next.fields = fields;
    next._sortErrors = sortByKeyOrder(Object.keys(fields));

    if (excludes.length) {
      // this is a convenience for when users only supply a single pair
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      next._excludedEdges = [...next._excludedEdges, ...excludes];
    }

    next._nodes = sortFields(fields, next._excludedEdges);
    return next;
  }

  pick(keys) {
    const picked = {};

    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }

    return this.clone().withMutation(next => {
      next.fields = {};
      return next.shape(picked);
    });
  }

  omit(keys) {
    const next = this.clone();
    const fields = next.fields;
    next.fields = {};

    for (const key of keys) {
      delete fields[key];
    }

    return next.withMutation(() => next.shape(fields));
  }

  from(from, to, alias) {
    let fromGetter = (0,property_expr.getter)(from, true);
    return this.transform(obj => {
      if (obj == null) return obj;
      let newObj = obj;

      if (has_default()(obj, from)) {
        newObj = object_extends({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  }

  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,

      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }

    });
    next.spec.noUnknown = noAllow;
    return next;
  }

  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }

  transformKeys(fn) {
    return this.transform(obj => obj && mapKeys_default()(obj, (_, key) => fn(key)));
  }

  camelCase() {
    return this.transformKeys((camelCase_default()));
  }

  snakeCase() {
    return this.transformKeys((snakeCase_default()));
  }

  constantCase() {
    return this.transformKeys(key => snakeCase_default()(key).toUpperCase());
  }

  describe() {
    let base = super.describe();
    base.fields = mapValues_default()(this.fields, value => value.describe());
    return base;
  }

}
function object_create(spec) {
  return new ObjectSchema(spec);
}
object_create.prototype = ObjectSchema.prototype;
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/array.js
function array_extends() { array_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return array_extends.apply(this, arguments); }








function array_create(type) {
  return new ArraySchema(type);
}
class ArraySchema extends BaseSchema {
  constructor(type) {
    super({
      type: 'array'
    }); // `undefined` specifically means uninitialized, as opposed to
    // "no subtype"

    this.innerType = void 0;
    this.innerType = type;
    this.withMutation(() => {
      this.transform(function (values) {
        if (typeof values === 'string') try {
          values = JSON.parse(values);
        } catch (err) {
          values = null;
        }
        return this.isType(values) ? values : null;
      });
    });
  }

  _typeCheck(v) {
    return Array.isArray(v);
  }

  get _subType() {
    return this.innerType;
  }

  _cast(_value, _opts) {
    const value = super._cast(_value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this.innerType) return value;
    let isChanged = false;
    const castArray = value.map((v, idx) => {
      const castElement = this.innerType.cast(v, array_extends({}, _opts, {
        path: `${_opts.path || ''}[${idx}]`
      }));

      if (castElement !== v) {
        isChanged = true;
      }

      return castElement;
    });
    return isChanged ? castArray : value;
  }

  _validate(_value, options = {}, callback) {
    var _options$abortEarly, _options$recursive;

    let errors = [];
    let sync = options.sync;
    let path = options.path;
    let innerType = this.innerType;
    let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
    let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
    let originalValue = options.originalValue != null ? options.originalValue : _value;

    super._validate(_value, options, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || endEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !innerType || !this._typeCheck(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated

      let tests = new Array(value.length);

      for (let idx = 0; idx < value.length; idx++) {
        let item = value[idx];
        let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation

        let innerOptions = array_extends({}, options, {
          path,
          strict: true,
          parent: value,
          index: idx,
          originalValue: originalValue[idx]
        });

        tests[idx] = (_, cb) => innerType.validate(item, innerOptions, cb);
      }

      runTests({
        sync,
        path,
        value,
        errors,
        endEarly,
        tests
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.innerType = this.innerType;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    next.innerType = this.innerType;
    if (schema.innerType) next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat()
    next.innerType.concat(schema.innerType) : schema.innerType;
    return next;
  }

  of(schema) {
    // FIXME: this should return a new instance of array without the default to be
    let next = this.clone();
    if (!util_isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + printValue(schema)); // FIXME(ts):

    next.innerType = schema;
    return next;
  }

  length(length, message = array.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return util_isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message) {
    message = message || array.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      // FIXME(ts): Array<typeof T>
      test(value) {
        return util_isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message) {
    message = message || array.max;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return util_isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  ensure() {
    return this.default(() => []).transform((val, original) => {
      // We don't want to return `null` for nullable schema
      if (this._typeCheck(val)) return val;
      return original == null ? [] : [].concat(original);
    });
  }

  compact(rejector) {
    let reject = !rejector ? v => !!v : (v, i, a) => !rejector(v, i, a);
    return this.transform(values => values != null ? values.filter(reject) : values);
  }

  describe() {
    let base = super.describe();
    if (this.innerType) base.innerType = this.innerType.describe();
    return base;
  }

  nullable(isNullable = true) {
    return super.nullable(isNullable);
  }

  defined() {
    return super.defined();
  }

  required(msg) {
    return super.required(msg);
  }

}
array_create.prototype = ArraySchema.prototype; //
// Interfaces
//
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/Lazy.js

function Lazy_create(builder) {
  return new Lazy(builder);
}

class Lazy {
  constructor(builder) {
    this.type = 'lazy';
    this.__isYupSchema__ = true;
    this.__inputType = void 0;
    this.__outputType = void 0;

    this._resolve = (value, options = {}) => {
      let schema = this.builder(value, options);
      if (!util_isSchema(schema)) throw new TypeError('lazy() functions must return a valid schema');
      return schema.resolve(options);
    };

    this.builder = builder;
  }

  resolve(options) {
    return this._resolve(options.value, options);
  }

  cast(value, options) {
    return this._resolve(value, options).cast(value, options);
  }

  validate(value, options, maybeCb) {
    // @ts-expect-error missing public callback on type
    return this._resolve(value, options).validate(value, options, maybeCb);
  }

  validateSync(value, options) {
    return this._resolve(value, options).validateSync(value, options);
  }

  validateAt(path, value, options) {
    return this._resolve(value, options).validateAt(path, value, options);
  }

  validateSyncAt(path, value, options) {
    return this._resolve(value, options).validateSyncAt(path, value, options);
  }

  describe() {
    return null;
  }

  isValid(value, options) {
    return this._resolve(value, options).isValid(value, options);
  }

  isValidSync(value, options) {
    return this._resolve(value, options).isValidSync(value, options);
  }

}

/* harmony default export */ var es_Lazy = ((/* unused pure expression or super */ null && (Lazy)));
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/setLocale.js

function setLocale(custom) {
  Object.keys(custom).forEach(type => {
    // @ts-ignore
    Object.keys(custom[type]).forEach(method => {
      // @ts-ignore
      locale[type][method] = custom[type][method];
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/@iterable/web-sdk/node_modules/yup/es/index.js















function addMethod(schemaType, name, fn) {
  if (!schemaType || !util_isSchema(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}




/***/ }),

/***/ 44267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardContent_CardContent; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/cardContentClasses.js


function getCardContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiCardContent', slot);
}
const cardContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardContent', ['root']);
/* harmony default export */ var CardContent_cardContentClasses = ((/* unused pure expression or super */ null && (cardContentClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/CardContent.js
'use client';



const _excluded = ["className", "component"];








const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardContentUtilityClass, classes);
};
const CardContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react.forwardRef(function CardContent(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiCardContent'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardContentRoot, (0,esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = (CardContent);

/***/ }),

/***/ 88078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Skeleton_Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/cssUtils.js
function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
}

// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}

// Emulate the sass function "unitless"
function toUnitless(length) {
  return parseFloat(length);
}

// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
function convertLength(baseFontSize) {
  return (length, toUnit) => {
    const fromUnit = getUnit(length);

    // Optimize for cases where `from` and `to` units are accidentally the same.
    if (fromUnit === toUnit) {
      return length;
    }

    // Convert input length to pixels.
    let pxLength = toUnitless(length);
    if (fromUnit !== 'px') {
      if (fromUnit === 'em') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      } else if (fromUnit === 'rem') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      }
    }

    // Convert length in pixels to the output unit
    let outputLength = pxLength;
    if (toUnit !== 'px') {
      if (toUnit === 'em') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else if (toUnit === 'rem') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else {
        return length;
      }
    }
    return parseFloat(outputLength.toFixed(5)) + toUnit;
  };
}
function alignProperty({
  size,
  grid
}) {
  const sizeBelow = size - size % grid;
  const sizeAbove = sizeBelow + grid;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}

// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
function fontGrid({
  lineHeight,
  pixels,
  htmlFontSize
}) {
  return pixels / (lineHeight * htmlFontSize);
}

/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */
function responsiveProperty({
  cssProperty,
  min,
  max,
  unit = 'rem',
  breakpoints = [600, 900, 1200],
  transform = null
}) {
  const output = {
    [cssProperty]: `${min}${unit}`
  };
  const factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach(breakpoint => {
    let value = min + factor * breakpoint;
    if (transform !== null) {
      value = transform(value);
    }
    output[`@media (min-width:${breakpoint}px)`] = {
      [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
    };
  });
  return output;
}
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Skeleton/skeletonClasses.js


function getSkeletonUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiSkeleton', slot);
}
const skeletonClasses = (0,generateUtilityClasses/* default */.Z)('MuiSkeleton', ['root', 'text', 'rectangular', 'rounded', 'circular', 'pulse', 'wave', 'withChildren', 'fitContent', 'heightAuto']);
/* harmony default export */ var Skeleton_skeletonClasses = ((/* unused pure expression or super */ null && (skeletonClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js
'use client';



const _excluded = ["animation", "className", "component", "height", "style", "variant", "width"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;










const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    animation,
    hasChildren,
    width,
    height
  } = ownerState;
  const slots = {
    root: ['root', variant, animation, hasChildren && 'withChildren', hasChildren && !width && 'fitContent', hasChildren && !height && 'heightAuto']
  };
  return (0,composeClasses/* default */.Z)(slots, getSkeletonUtilityClass, classes);
};
const pulseKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const waveKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const SkeletonRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiSkeleton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.animation !== false && styles[ownerState.animation], ownerState.hasChildren && styles.withChildren, ownerState.hasChildren && !ownerState.width && styles.fitContent, ownerState.hasChildren && !ownerState.height && styles.heightAuto];
  }
})(({
  theme,
  ownerState
}) => {
  const radiusUnit = getUnit(theme.shape.borderRadius) || 'px';
  const radiusValue = toUnitless(theme.shape.borderRadius);
  return (0,esm_extends/* default */.Z)({
    display: 'block',
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0,colorManipulator/* alpha */.Fq)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
    height: '1.2em'
  }, ownerState.variant === 'text' && {
    marginTop: 0,
    marginBottom: 0,
    height: 'auto',
    transformOrigin: '0 55%',
    transform: 'scale(1, 0.60)',
    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
    '&:empty:before': {
      content: '"\\00a0"'
    }
  }, ownerState.variant === 'circular' && {
    borderRadius: '50%'
  }, ownerState.variant === 'rounded' && {
    borderRadius: (theme.vars || theme).shape.borderRadius
  }, ownerState.hasChildren && {
    '& > *': {
      visibility: 'hidden'
    }
  }, ownerState.hasChildren && !ownerState.width && {
    maxWidth: 'fit-content'
  }, ownerState.hasChildren && !ownerState.height && {
    height: 'auto'
  });
}, ({
  ownerState
}) => ownerState.animation === 'pulse' && (0,emotion_react_browser_esm/* css */.iv)(_t3 || (_t3 = _`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), pulseKeyframe), ({
  ownerState,
  theme
}) => ownerState.animation === 'wave' && (0,emotion_react_browser_esm/* css */.iv)(_t4 || (_t4 = _`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), waveKeyframe, (theme.vars || theme).palette.action.hover));
const Skeleton = /*#__PURE__*/react.forwardRef(function Skeleton(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiSkeleton'
  });
  const {
      animation = 'pulse',
      className,
      component = 'span',
      height,
      style,
      variant = 'text',
      width
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    animation,
    component,
    variant,
    hasChildren: Boolean(other.children)
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SkeletonRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ref: ref,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState
  }, other, {
    style: (0,esm_extends/* default */.Z)({
      width,
      height
    }, style)
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Skeleton_Skeleton = (Skeleton);

/***/ }),

/***/ 44751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "by": function() { return /* binding */ by; }
/* harmony export */ });
function isLower(left, right) {
    return left < right;
}
function isGreater(left, right) {
    return left > right;
}
function compareAsc(left, right) {
    return isLower(left, right) ? -1 :
        isGreater(left, right) ? 1 :
            0;
}
function compareDesc(left, right) {
    return isLower(left, right) ? 1 :
        isGreater(left, right) ? -1 :
            0;
}
function by(...keys) {
    const chain = keys.map(entry => {
        const [keyOrExtractor, direction] = Array.isArray(entry)
            ? entry
            : [entry, 'asc'];
        const extractor = typeof keyOrExtractor === 'function'
            ? keyOrExtractor
            : (thing) => thing[keyOrExtractor];
        return [extractor, direction === 'asc' ? compareAsc : compareDesc];
    });
    return (left, right) => {
        for (let i = 0, l = chain.length; i < l; i++) {
            const [extractor, cmp] = chain[i];
            const result = cmp(extractor(left), extractor(right));
            if (result !== 0) {
                return result;
            }
        }
        return 0;
    };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 25730:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);
var $reflectApply = __webpack_require__(59770);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),

/***/ 1768:
/***/ (function(module) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),

/***/ 68928:
/***/ (function(module) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),

/***/ 40319:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(58612);
var $TypeError = __webpack_require__(14453);

var $call = __webpack_require__(68928);
var $actualApply = __webpack_require__(25730);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),

/***/ 59770:
/***/ (function(module) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),

/***/ 17379:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);

var callBindBasic = __webpack_require__(40319);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),

/***/ 96504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(40319);
var gOPD = __webpack_require__(77203);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),

/***/ 68219:
/***/ (function(module) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 77203:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(68219);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 53981:
/***/ (function(module) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 81648:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 24726:
/***/ (function(module) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 26712:
/***/ (function(module) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 33464:
/***/ (function(module) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 14453:
/***/ (function(module) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 43915:
/***/ (function(module) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 68892:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ 17648:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 58612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(17648);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 40210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(45187);

var $Error = __webpack_require__(81648);
var $EvalError = __webpack_require__(53981);
var $RangeError = __webpack_require__(24726);
var $ReferenceError = __webpack_require__(26712);
var $SyntaxError = __webpack_require__(33464);
var $TypeError = __webpack_require__(14453);
var $URIError = __webpack_require__(43915);

var abs = __webpack_require__(59738);
var floor = __webpack_require__(76329);
var max = __webpack_require__(52264);
var min = __webpack_require__(55730);
var pow = __webpack_require__(20707);
var round = __webpack_require__(63862);
var sign = __webpack_require__(29550);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(77871);
var $defineProperty = __webpack_require__(48906);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(83085)();

var getProto = __webpack_require__(81618);
var $ObjectGPO = __webpack_require__(68899);
var $ReflectGPO = __webpack_require__(10443);

var $apply = __webpack_require__(1768);
var $call = __webpack_require__(68928);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(58612);
var hasOwn = __webpack_require__(48824);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 48906:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 45187:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ 97452:
/***/ (function(module) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 77871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(97452);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 83085:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(24429);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 24429:
/***/ (function(module) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 68899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(68892);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),

/***/ 10443:
/***/ (function(module) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),

/***/ 81618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(10443);
var originalGetProto = __webpack_require__(68899);

var getDunderProto = __webpack_require__(96504);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),

/***/ 48824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(58612);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 62663:
/***/ (function(module) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 44286:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 49029:
/***/ (function(module) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),

/***/ 34865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 28483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(25063);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 47816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(28483),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 78565:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),

/***/ 13:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 2958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    baseIsEqual = __webpack_require__(90939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 67206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(91573),
    baseMatchesProperty = __webpack_require__(16432),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469),
    property = __webpack_require__(39601);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 91573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2958),
    getMatchData = __webpack_require__(1499),
    matchesStrictComparable = __webpack_require__(42634);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 16432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939),
    get = __webpack_require__(27361),
    hasIn = __webpack_require__(79095),
    isKey = __webpack_require__(15403),
    isStrictComparable = __webpack_require__(89162),
    matchesStrictComparable = __webpack_require__(42634),
    toKey = __webpack_require__(40327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 40371:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 79152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 18674:
/***/ (function(module) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 10611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    castPath = __webpack_require__(71811),
    isIndex = __webpack_require__(65776),
    isObject = __webpack_require__(13218),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 40180:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(14259);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 25063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 98805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castSlice = __webpack_require__(40180),
    hasUnicode = __webpack_require__(62689),
    stringToArray = __webpack_require__(83140),
    toString = __webpack_require__(79833);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 35393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayReduce = __webpack_require__(62663),
    deburr = __webpack_require__(44600),
    words = __webpack_require__(58748);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),

/***/ 69389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(18674);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(89162),
    keys = __webpack_require__(3674);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isIndex = __webpack_require__(65776),
    isLength = __webpack_require__(41780),
    toKey = __webpack_require__(40327);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 62689:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 93157:
/***/ (function(module) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 89162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 42634:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 83140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(44286),
    hasUnicode = __webpack_require__(62689),
    unicodeToArray = __webpack_require__(676);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 676:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 2757:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),

/***/ 68929:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var capitalize = __webpack_require__(48403),
    createCompounder = __webpack_require__(35393);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),

/***/ 48403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833),
    upperFirst = __webpack_require__(11700);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),

/***/ 44600:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var deburrLetter = __webpack_require__(69389),
    toString = __webpack_require__(79833);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 18721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHas = __webpack_require__(78565),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),

/***/ 79095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(13),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 67523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    baseForOwn = __webpack_require__(47816),
    baseIteratee = __webpack_require__(67206);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),

/***/ 66604:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    baseForOwn = __webpack_require__(47816),
    baseIteratee = __webpack_require__(67206);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 39601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(40371),
    basePropertyDeep = __webpack_require__(79152),
    isKey = __webpack_require__(15403),
    toKey = __webpack_require__(40327);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 36968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSet = __webpack_require__(10611);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ 11865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCompounder = __webpack_require__(35393);

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 11700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(98805);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 58748:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiWords = __webpack_require__(49029),
    hasUnicodeWord = __webpack_require__(93157),
    toString = __webpack_require__(79833),
    unicodeWords = __webpack_require__(2757);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),

/***/ 59738:
/***/ (function(module) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),

/***/ 76329:
/***/ (function(module) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),

/***/ 43678:
/***/ (function(module) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),

/***/ 52264:
/***/ (function(module) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),

/***/ 55730:
/***/ (function(module) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),

/***/ 20707:
/***/ (function(module) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),

/***/ 63862:
/***/ (function(module) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),

/***/ 29550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(43678);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),

/***/ 70631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(24654);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 55798:
/***/ (function(module) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 80129:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(58261);
var parse = __webpack_require__(55235);
var formats = __webpack_require__(55798);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 55235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(12769);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            val = utils.maybeMap(
                parseArrayValue(
                    part.slice(pos + 1),
                    options,
                    isArray(obj[key]) ? obj[key].length : 0
                ),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : utils.combine([], leaf);
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 58261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(37478);
var utils = __webpack_require__(12769);
var formats = __webpack_require__(55798);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 12769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(55798);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 35747:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 23595:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);

var $TypeError = __webpack_require__(14453);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),

/***/ 69034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40210);
var callBound = __webpack_require__(17379);
var inspect = __webpack_require__(70631);
var getSideChannelMap = __webpack_require__(23595);

var $TypeError = __webpack_require__(14453);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),

/***/ 37478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(14453);
var inspect = __webpack_require__(70631);
var getSideChannelList = __webpack_require__(35747);
var getSideChannelMap = __webpack_require__(23595);
var getSideChannelWeakMap = __webpack_require__(69034);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 94633:
/***/ (function(module) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
}

module.exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes)

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  })

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set())
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep
      try {
        nodeRep = ", node was:" + JSON.stringify(node)
      } catch(e) {
        nodeRep = ""
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    var outgoing = outgoingEdges.get(node) || new Set()
    outgoing = Array.from(outgoing)

    if (i = outgoing.length) {
      predecessors.add(node)
      do {
        var child = outgoing[--i]
        visit(child, nodesHash.get(child), predecessors)
      } while (i)
      predecessors.delete(node)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = new Set()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    res.add(edge[0])
    res.add(edge[1])
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (!edges.has(edge[0])) edges.set(edge[0], new Set())
    if (!edges.has(edge[1])) edges.set(edge[1], new Set())
    edges.get(edge[0]).add(edge[1])
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i)
  }
  return res
}


/***/ }),

/***/ 32546:
/***/ (function(module) {

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 33566:
/***/ (function(module) {

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 33735:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(32546);
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 73172:
/***/ (function(module) {

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 54402:
/***/ (function(module) {

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 92667:
/***/ (function(module) {

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 17723:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(96216);
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 54950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(96216);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 25389:
/***/ (function(module) {

function _getPrototypeOf(t) {
  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 11247:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(13011);
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 81184:
/***/ (function(module) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 5886:
/***/ (function(module) {

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 43602:
/***/ (function(module) {

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 29090:
/***/ (function(module) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 24177:
/***/ (function(module) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 20316:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(98132);
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 98132:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 84665:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(16170)["default"]);
var assertThisInitialized = __webpack_require__(73172);
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 65051:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(16170)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return r;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    r = {},
    e = Object.prototype,
    n = e.hasOwnProperty,
    o = "function" == typeof Symbol ? Symbol : {},
    i = o.iterator || "@@iterator",
    a = o.asyncIterator || "@@asyncIterator",
    u = o.toStringTag || "@@toStringTag";
  function c(t, r, e, n) {
    return Object.defineProperty(t, r, {
      value: e,
      enumerable: !n,
      configurable: !n,
      writable: !n
    });
  }
  try {
    c({}, "");
  } catch (t) {
    c = function c(t, r, e) {
      return t[r] = e;
    };
  }
  function h(r, e, n, o) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype);
    return c(a, "_invoke", function (r, e, n) {
      var o = 1;
      return function (i, a) {
        if (3 === o) throw Error("Generator is already running");
        if (4 === o) {
          if ("throw" === i) throw a;
          return {
            value: t,
            done: !0
          };
        }
        for (n.method = i, n.arg = a;;) {
          var u = n.delegate;
          if (u) {
            var c = d(u, n);
            if (c) {
              if (c === f) continue;
              return c;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if (1 === o) throw o = 4, n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          o = 3;
          var h = s(r, e, n);
          if ("normal" === h.type) {
            if (o = n.done ? 4 : 2, h.arg === f) continue;
            return {
              value: h.arg,
              done: n.done
            };
          }
          "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg);
        }
      };
    }(r, n, new Context(o || [])), !0), a;
  }
  function s(t, r, e) {
    try {
      return {
        type: "normal",
        arg: t.call(r, e)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  r.wrap = h;
  var f = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var l = {};
  c(l, i, function () {
    return this;
  });
  var p = Object.getPrototypeOf,
    y = p && p(p(x([])));
  y && y !== e && n.call(y, i) && (l = y);
  var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l);
  function g(t) {
    ["next", "throw", "return"].forEach(function (r) {
      c(t, r, function (t) {
        return this._invoke(r, t);
      });
    });
  }
  function AsyncIterator(t, r) {
    function e(o, i, a, u) {
      var c = s(t[o], t, i);
      if ("throw" !== c.type) {
        var h = c.arg,
          f = h.value;
        return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) {
          e("next", t, a, u);
        }, function (t) {
          e("throw", t, a, u);
        }) : r.resolve(f).then(function (t) {
          h.value = t, a(h);
        }, function (t) {
          return e("throw", t, a, u);
        });
      }
      u(c.arg);
    }
    var o;
    c(this, "_invoke", function (t, n) {
      function i() {
        return new r(function (r, o) {
          e(t, n, r, o);
        });
      }
      return o = o ? o.then(i, i) : i();
    }, !0);
  }
  function d(r, e) {
    var n = e.method,
      o = r.i[n];
    if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f;
    var i = s(o, r.i, e.arg);
    if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f;
    var a = i.arg;
    return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
  }
  function w(t) {
    this.tryEntries.push(t);
  }
  function m(r) {
    var e = r[4] || {};
    e.type = "normal", e.arg = t, r[4] = e;
  }
  function Context(t) {
    this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0);
  }
  function x(r) {
    if (null != r) {
      var e = r[i];
      if (e) return e.call(r);
      if ("function" == typeof r.next) return r;
      if (!isNaN(r.length)) {
        var o = -1,
          a = function e() {
            for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e;
            return e.value = t, e.done = !0, e;
          };
        return a.next = a;
      }
    }
    throw new TypeError(_typeof(r) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) {
    var r = "function" == typeof t && t.constructor;
    return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name));
  }, r.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t;
  }, r.awrap = function (t) {
    return {
      __await: t
    };
  }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () {
    return this;
  }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(h(t, e, n, o), i);
    return r.isGeneratorFunction(e) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, g(v), c(v, u, "Generator"), c(v, i, function () {
    return this;
  }), c(v, "toString", function () {
    return "[object Generator]";
  }), r.keys = function (t) {
    var r = Object(t),
      e = [];
    for (var n in r) e.unshift(n);
    return function t() {
      for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t;
      return t.done = !0, t;
    };
  }, r.values = x, Context.prototype = {
    constructor: Context,
    reset: function reset(r) {
      if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0][4];
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(r) {
      if (this.done) throw r;
      var e = this;
      function n(t) {
        a.type = "throw", a.arg = r, e.next = t;
      }
      for (var o = e.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i[4],
          u = this.prev,
          c = i[1],
          h = i[2];
        if (-1 === i[0]) return n("end"), !1;
        if (!c && !h) throw Error("try statement without catch or finally");
        if (null != i[0] && i[0] <= u) {
          if (u < c) return this.method = "next", this.arg = t, n(c), !0;
          if (u < h) return n(h), !1;
        }
      }
    },
    abrupt: function abrupt(t, r) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var n = this.tryEntries[e];
        if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) {
          var o = n;
          break;
        }
      }
      o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null);
      var i = o ? o[4] : {};
      return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i);
    },
    complete: function complete(t, r) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f;
    },
    finish: function finish(t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var e = this.tryEntries[r];
        if (e[2] === t) return this.complete(e[4], e[3]), m(e), f;
      }
    },
    "catch": function _catch(t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var e = this.tryEntries[r];
        if (e[0] === t) {
          var n = e[4];
          if ("throw" === n.type) {
            var o = n.arg;
            m(e);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(r, e, n) {
      return this.delegate = {
        i: x(r),
        r: e,
        n: n
      }, "next" === this.method && (this.arg = t), f;
    }
  }, r;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 13011:
/***/ (function(module) {

function _setPrototypeOf(t, e) {
  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 17024:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(33566);
var iterableToArrayLimit = __webpack_require__(43602);
var unsupportedIterableToArray = __webpack_require__(93849);
var nonIterableRest = __webpack_require__(29090);
function _slicedToArray(r, e) {
  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 37289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(33735);
var iterableToArray = __webpack_require__(5886);
var unsupportedIterableToArray = __webpack_require__(93849);
var nonIterableSpread = __webpack_require__(24177);
function _toConsumableArray(r) {
  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1027:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(16170)["default"]);
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 96216:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(16170)["default"]);
var toPrimitive = __webpack_require__(1027);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 16170:
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 93849:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(32546);
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 6944:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(65051)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 97218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/*! Axios v1.9.0 Copyright (c) 2025 Matt Zabriskie and contributors */


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;
const {iterator, toStringTag} = Symbol;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
};

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(toStringTag in val) && !(iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : __webpack_require__.g)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[iterator];

  const _iterator = generator.call(obj);

  let result;

  while ((result = _iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop = () => {};

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[toStringTag] === 'FormData' && thing[iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }

  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({source, data}) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);

    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    }
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === 'function',
  isFunction(_global.postMessage)
);

const asap = typeof queueMicrotask !== 'undefined' ?
  queueMicrotask.bind(_global) : ( typeof process !== 'undefined' && process.nextTick || _setImmediate);

// *********************


const isIterable = (thing) => thing != null && isFunction(thing[iterator]);


var utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap,
  isIterable
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}

utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});

const prototype$1 = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils$1.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
var httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils$1.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils$1.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);

  if (!utils$1.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils$1.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils$1.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils$1.isArray(value) && isFlatArray(value)) ||
        ((utils$1.isFileList(value) || utils$1.endsWith(key, '[]')) && (arr = utils$1.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils$1.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils$1.forEach(value, function each(el, key) {
      const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils$1.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils$1.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$1(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?(object|Function)} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  if (utils$1.isFunction(options)) {
    options = {
      serialize: options
    };
  } 

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

var InterceptorManager$1 = InterceptorManager;

var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

var platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

const _navigator = typeof navigator === 'object' && navigator || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = hasBrowserEnv &&
  (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const origin = hasBrowserEnv && window.location.href || 'http://localhost';

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  hasBrowserEnv: hasBrowserEnv,
  hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv,
  hasStandardBrowserEnv: hasStandardBrowserEnv,
  navigator: _navigator,
  origin: origin
});

var platform = {
  ...utils,
  ...platform$1
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};

    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: transitionalDefaults,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils$1.isObject(data);

    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils$1.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data) ||
      utils$1.isReadableStream(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils$1.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
      return data;
    }

    if (data && utils$1.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils$1.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

var defaults$1 = defaults;

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils$1.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils$1.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils$1.isString(value)) return;

  if (utils$1.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils$1.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils$1.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isObject(header) && utils$1.isIterable(header)) {
      let obj = {}, dest, key;
      for (const entry of header) {
        if (!utils$1.isArray(entry)) {
          throw TypeError('Object iterator must return a key-value pair');
        }

        obj[key = entry[0]] = (dest = obj[key]) ?
          (utils$1.isArray(dest) ? [...dest, entry[1]] : [dest, entry[1]]) : entry[1];
      }

      setHeaders(obj, valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils$1.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  getSetCookie() {
    return this.get("set-cookie") || [];
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils$1.freezeMethods(AxiosHeaders);

var AxiosHeaders$1 = AxiosHeaders;

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults$1;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;

  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  };

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if ( passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return throttle(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };

    listener(data);
  }, freq);
};

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};

const asyncDecorator = (fn) => (...args) => utils$1.asap(() => fn(...args));

var isURLSameOrigin = platform.hasStandardBrowserEnv ? ((origin, isMSIE) => (url) => {
  url = new URL(url, platform.origin);

  return (
    origin.protocol === url.protocol &&
    origin.host === url.host &&
    (isMSIE || origin.port === url.port)
  );
})(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => true;

var cookies = platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils$1.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils$1.isString(path) && cookie.push('path=' + path);

      utils$1.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  };

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
  let isRelativeUrl = !isAbsoluteURL(requestedURL);
  if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, prop, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({caseless}, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, prop , caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, prop , caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a, prop , caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b , prop) => mergeDeepProperties(headersToObject(a), headersToObject(b),prop, true)
  };

  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils$1.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

var resolveConfig = (config) => {
  const newConfig = mergeConfig({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = AxiosHeaders$1.from(headers);

  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
};

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

var xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders$1.from(_config.headers).normalize();
    let {responseType, onUploadProgress, onDownloadProgress} = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;

    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders$1.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      ([downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true));
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      ([uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress));

      request.upload.addEventListener('progress', uploadThrottled);

      request.upload.addEventListener('loadend', flushUpload);
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(_config.url);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const composeSignals = (signals, timeout) => {
  const {length} = (signals = signals ? signals.filter(Boolean) : []);

  if (timeout || length) {
    let controller = new AbortController();

    let aborted;

    const onabort = function (reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
      }
    };

    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new AxiosError(`timeout ${timeout} of ms exceeded`, AxiosError.ETIMEDOUT));
    }, timeout);

    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(signal => {
          signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
      }
    };

    signals.forEach((signal) => signal.addEventListener('abort', onabort));

    const {signal} = controller;

    signal.unsubscribe = () => utils$1.asap(unsubscribe);

    return signal;
  }
};

var composeSignals$1 = composeSignals;

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};

const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
};

const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }

  const reader = stream.getReader();
  try {
    for (;;) {
      const {done, value} = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};

const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };

  return new ReadableStream({
    async pull(controller) {
      try {
        const {done, value} = await iterator.next();

        if (done) {
         _onFinish();
          controller.close();
          return;
        }

        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
};

const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false
  }
};

const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;

  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
});

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported &&
  test(() => utils$1.isReadableStream(new Response('').body));


const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new AxiosError(`Response type '${type}' is not supported`, AxiosError.ERR_NOT_SUPPORT, config);
      });
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(utils$1.isBlob(body)) {
    return body.size;
  }

  if(utils$1.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: 'POST',
      body,
    });
    return (await _request.arrayBuffer()).byteLength;
  }

  if(utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }

  if(utils$1.isURLSearchParams(body)) {
    body = body + '';
  }

  if(utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};

const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
};

var fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let composedSignal = composeSignals$1([signal, cancelToken && cancelToken.toAbortSignal()], timeout);

  let request;

  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
      composedSignal.unsubscribe();
  });

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader);
      }

      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );

        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }

    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    // Cloudflare Workers throws when credentials are defined
    // see https://github.com/cloudflare/workerd/issues/902
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : undefined
    });

    let response = await fetch(request);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || (isStreamResponse && unsubscribe))) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = utils$1.toFiniteNumber(response.headers.get('content-length'));

      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];

      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && unsubscribe && unsubscribe();

    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: AxiosHeaders$1.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    })
  } catch (err) {
    unsubscribe && unsubscribe();

    if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw AxiosError.from(err, err && err.code, config, request);
  }
});

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};

utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;

var adapters = {
  getAdapter: (adapters) => {
    adapters = utils$1.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders$1.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders$1.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const VERSION = "1.9.0";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

validators$1.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    // eslint-disable-next-line no-console
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  }
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator = {
  assertOptions,
  validators: validators$1
};

const validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig || {};
    this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};

        Error.captureStackTrace ? Error.captureStackTrace(dummy) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack;
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.allowAbsoluteUrls
    if (config.allowAbsoluteUrls !== undefined) ; else if (this.defaults.allowAbsoluteUrls !== undefined) {
      config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
    } else {
      config.allowAbsoluteUrls = true;
    }

    validator.assertOptions(config, {
      baseUrl: validators.spelling('baseURL'),
      withXsrfToken: validators.spelling('withXSRFToken')
    }, true);

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils$1.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

var Axios$1 = Axios;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (err) => {
      controller.abort(err);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

var CancelToken$1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

var HttpStatusCode$1 = HttpStatusCode;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios$1.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils$1.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults$1);

// Expose Axios class to allow class inheritance
axios.Axios = Axios$1;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;

// Expose AxiosError class
axios.AxiosError = AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = AxiosHeaders$1;

axios.formToJSON = thing => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = HttpStatusCode$1;

axios.default = axios;

module.exports = axios;
//# sourceMappingURL=axios.cjs.map


/***/ }),

/***/ 42189:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */

function debounce (delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}

exports.debounce = debounce;
exports.throttle = throttle;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 50319:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useMutation; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54708);
/* harmony import */ var rehackt__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73914);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14012);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30020);
/* harmony import */ var _parser_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14692);
/* harmony import */ var _errors_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30990);
/* harmony import */ var _useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66252);
/* harmony import */ var _internal_useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(770);








/**
 *
 *
 * > Refer to the [Mutations](https://www.apollographql.com/docs/react/data/mutations/) section for a more in-depth overview of `useMutation`.
 *
 * @example
 * ```jsx
 * import { gql, useMutation } from '@apollo/client';
 *
 * const ADD_TODO = gql`
 *   mutation AddTodo($type: String!) {
 *     addTodo(type: $type) {
 *       id
 *       type
 *     }
 *   }
 * `;
 *
 * function AddTodo() {
 *   let input;
 *   const [addTodo, { data }] = useMutation(ADD_TODO);
 *
 *   return (
 *     <div>
 *       <form
 *         onSubmit={e => {
 *           e.preventDefault();
 *           addTodo({ variables: { type: input.value } });
 *           input.value = '';
 *         }}
 *       >
 *         <input
 *           ref={node => {
 *             input = node;
 *           }}
 *         />
 *         <button type="submit">Add Todo</button>
 *       </form>
 *     </div>
 *   );
 * }
 * ```
 * @since 3.0.0
 * @param mutation - A GraphQL mutation document parsed into an AST by `gql`.
 * @param options - Options to control how the mutation is executed.
 * @returns A tuple in the form of `[mutate, result]`
 */
function useMutation(mutation, options) {
    var client = (0,_useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useApolloClient */ .x)(options === null || options === void 0 ? void 0 : options.client);
    (0,_parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .verifyDocumentType */ .Vp)(mutation, _parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .DocumentType.Mutation */ .n_.Mutation);
    var _a = rehackt__WEBPACK_IMPORTED_MODULE_0__.useState({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = rehackt__WEBPACK_IMPORTED_MODULE_0__.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    (0,_internal_useIsomorphicLayoutEffect_js__WEBPACK_IMPORTED_MODULE_4__/* .useIsomorphicLayoutEffect */ .L)(function () {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    });
    var execute = rehackt__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__assign */ .pi)({}, options), { mutation: mutation });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading &&
            !baseOptions.ignoreResults &&
            ref.current.isMounted) {
            setResult((ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            }));
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_6__/* .mergeOptions */ .J)(baseOptions, executeOptions);
        return client
            .mutate(clientOptions)
            .then(function (response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ?
                new _errors_index_js__WEBPACK_IMPORTED_MODULE_7__/* .ApolloError */ .cA({ graphQLErrors: errors })
                : void 0;
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (error && onError) {
                onError(error, clientOptions);
            }
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_1)) {
                    setResult((ref.current.result = result_1));
                }
            }
            var onCompleted = executeOptions.onCompleted || ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onCompleted);
            if (!error) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(response.data, clientOptions);
            }
            return response;
        }, function (error) {
            var _a;
            if (mutationId === ref.current.mutationId &&
                ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_2)) {
                    setResult((ref.current.result = result_2));
                }
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                // TODO(brian): why are we returning this here???
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = rehackt__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
        if (ref.current.isMounted) {
            var result_3 = {
                called: false,
                loading: false,
                client: ref.current.client,
            };
            Object.assign(ref.current, { mutationId: 0, result: result_3 });
            setResult(result_3);
        }
    }, []);
    rehackt__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
        var current = ref.current;
        // eslint-disable-next-line react-compiler/react-compiler
        current.isMounted = true;
        return function () {
            current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__assign */ .pi)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map

/***/ }),

/***/ 46207:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qQ": function() { return /* reexport */ Embedded_IterableEmbeddedProvider; },
  "uG": function() { return /* reexport */ renderers_namespaceObject; },
  "bD": function() { return /* reexport */ Embedded_IterableEmbeddedSlot; },
  "YC": function() { return /* reexport */ hooks_useOnJwtRequest; }
});

// UNUSED EXPORTS: IterableEmbeddedContext, IterableInAppContext, IterableInAppModalSlot, IterableInAppProvider, IterableInAppSlot, IterableInAppSlotName

// NAMESPACE OBJECT: ./node_modules/@care/iterable-display/dist/Embedded/renderers/index.js
var renderers_namespaceObject = {};
__webpack_require__.r(renderers_namespaceObject);
__webpack_require__.d(renderers_namespaceObject, {
  "o": function() { return renderers_IterableSimpleBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@iterable/web-sdk/dist/embedded/embeddedManager.js
var embeddedManager = __webpack_require__(93953);
var embeddedManager_namespaceObject = /*#__PURE__*/__webpack_require__.t(embeddedManager, 2);
// EXTERNAL MODULE: ./node_modules/@iterable/web-sdk/dist/authorization/authorization.js
var authorization = __webpack_require__(5813);
var authorization_namespaceObject = /*#__PURE__*/__webpack_require__.t(authorization, 2);
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/Embedded/IterableEmbeddedProvider.js



// Work around iterable import issue.
const { IterableEmbeddedManager } = embeddedManager_namespaceObject;
const { initialize } = authorization_namespaceObject;
/** Context for Iterable Embedded slots and messages. */
const IterableEmbeddedContext = (0,react.createContext)({
    /** The messages that will be passed to consuming slots. */
    messages: [],
    /** Context is currently retrieving messages from Iterable. */
    loading: false,
});
/**
 * The Iterable Embedded Provider is a provider component that interfaces with
 * [the Iterable Web SDK.](https://github.com/Iterable/iterable-web-sdk) for
 * [Embedded messages](https://support.iterable.com/hc/en-us/articles/23060529977364-Embedded-Messaging-Overview).
 * It handles querying Iterable for Embedded messages for the current user and saving them to
 * its context provider, where it is used in conjunction with the `IterableEmbeddedSlot` component
 * to render an Embedded message intended for its slot.
 */
const IterableEmbeddedProvider = ({ apiKey, packageName, userId, placementIds, children, disabled = false, onJwtRequest, onError, }) => {
    const [messages, setMessages] = (0,react.useState)([]);
    const [called, setCalled] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const [embeddedManager, setEmbeddedManager] = (0,react.useState)();
    /** Retrieves Embedded messages from Iterable. */
    const getMessages = (0,react.useCallback)(() => {
        if (!embeddedManager)
            return;
        setLoading(true);
        const { setUserID } = initialize(apiKey, onJwtRequest);
        setUserID(userId)
            .then(() => embeddedManager
            .syncMessages(packageName, () => {
            // Handle messages using embeddedMessageUpdateHandler
        }, placementIds)
            .catch((error) => {
            onError === null || onError === void 0 ? void 0 : onError(error);
        })
            .finally(() => {
            setCalled(true);
            setLoading(false);
        }))
            .catch((error) => {
            setCalled(true);
            setLoading(false);
            onError === null || onError === void 0 ? void 0 : onError(error);
        });
    }, [apiKey, onJwtRequest, userId, packageName, placementIds, embeddedManager, onError]);
    (0,react.useEffect)(() => {
        /** Initializing of the IterableEmbeddedManager */
        const embeddedManagerInstance = new IterableEmbeddedManager(packageName);
        /* istanbul ignore next */
        embeddedManagerInstance.addUpdateListener({
            onMessagesUpdated() {
                setMessages(embeddedManagerInstance.getMessages());
            },
            onEmbeddedMessagingDisabled() {
                setMessages([]);
            },
        });
        setEmbeddedManager(embeddedManagerInstance);
    }, [packageName]);
    (0,react.useEffect)(() => {
        if (!disabled && messages.length === 0 && !loading && !called) {
            getMessages();
        }
    }, [getMessages, messages, disabled, loading, called]);
    return (0,react.useMemo)(() => (react.createElement(IterableEmbeddedContext.Provider, { value: { packageName, loading, messages } }, children)), [children, loading, packageName, messages]);
};
/* harmony default export */ var Embedded_IterableEmbeddedProvider = (IterableEmbeddedProvider);
//# sourceMappingURL=data:application/json;base64,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
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton_Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./node_modules/@iterable/web-sdk/dist/events/embedded/events.js
var events = __webpack_require__(85316);
var events_namespaceObject = /*#__PURE__*/__webpack_require__.t(events, 2);
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/styles.js
/** The root styles for the slot. */
const styles_rootSx = {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxvQ0FBb0M7QUFDcEMsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFtQjtJQUNwQyxLQUFLLEVBQUUsTUFBTTtJQUNiLE1BQU0sRUFBRSxNQUFNO0lBQ2QsUUFBUSxFQUFFLFFBQVE7Q0FDbkIsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgU3hQcm9wcywgVGhlbWUgfSBmcm9tICdAbXVpL21hdGVyaWFsJztcblxuLyoqIFRoZSByb290IHN0eWxlcyBmb3IgdGhlIHNsb3QuICovXG5leHBvcnQgY29uc3Qgcm9vdFN4OiBTeFByb3BzPFRoZW1lPiA9IHtcbiAgd2lkdGg6ICcxMDAlJyxcbiAgaGVpZ2h0OiAnMTAwJScsXG4gIG92ZXJmbG93OiAnaGlkZGVuJyxcbn07XG4iXX0=
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/Embedded/IterableEmbeddedSlot.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





// Work around iterable import issue.
const { trackEmbeddedClick } = events_namespaceObject;
/**
 * Renders the html within a div and call onRender when the content is rendered.
 */
const DivOutput = (0,react.forwardRef)((_a, ref) => {
    var { children, onRender } = _a, rest = __rest(_a, ["children", "onRender"]);
    (0,react.useEffect)(() => {
        onRender === null || onRender === void 0 ? void 0 : onRender();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react.createElement(Box_Box/* default */.Z, Object.assign({ ref: ref }, rest), children));
});
/**
 * Renders the Iterable Embedded Slot either within a container or as an iframe, depending on the
 * renderer. If the renderer is one of standard Iterable's renderers (Card, Banner, Notification),
 * this will render as an iframe.
 */
const SlotEmbeddedOutput = ({ packageName, renderer, message, onRender, onCTAClick, onError, }) => {
    const [content, setContent] = (0,react.useState)();
    const messageRef = (0,react.useRef)(null);
    const errorHandler = (0,react.useCallback)(
    /* istanbul ignore next */
    (error) => {
        onError === null || onError === void 0 ? void 0 : onError(error);
    }, [onError]);
    const triggerCTAClick = (0,react.useCallback)((event) => {
        onCTAClick === null || onCTAClick === void 0 ? void 0 : onCTAClick(message, event);
    }, [message, onCTAClick]);
    /** Adds event listeners to buttons and anchors in message. */
    const handleLoad = (0,react.useCallback)(() => {
        if (messageRef.current instanceof HTMLDivElement) {
            messageRef.current.querySelectorAll('a, button').forEach((el) => {
                /** @see https://github.com/Iterable/iterable-web-sdk/blob/50a9ff1f989d7386f8b0f1ff7fa893200ee05e83/src/embedded/utils.ts#L72-L91 */
                el.addEventListener('click', (event) => {
                    var _a, _b;
                    // Prevent the click event from bubbling up to the div
                    triggerCTAClick(event);
                    trackEmbeddedClick({
                        messageId: message.metadata.messageId,
                        buttonIdentifier: (_a = el.getAttribute('id')) !== null && _a !== void 0 ? _a : '',
                        targetUrl: (_b = el.getAttribute('href')) !== null && _b !== void 0 ? _b : '',
                        appPackageName: packageName !== null && packageName !== void 0 ? packageName : '',
                    }).catch(
                    /* istanbul ignore next */ (error) => {
                        var _a, _b;
                        errorHandler(Object.assign(Object.assign({}, (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data), { statusCode: (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status }));
                    });
                });
            });
        }
        onRender === null || onRender === void 0 ? void 0 : onRender(message);
    }, [errorHandler, message, messageRef, onRender, packageName, triggerCTAClick]);
    (0,react.useEffect)(() => {
        const renderResult = renderer({
            appPackageName: packageName !== null && packageName !== void 0 ? packageName : '',
            message,
            errorCallback: errorHandler,
        });
        if (renderResult) {
            setContent(renderResult);
        }
    }, [message, renderer, errorHandler, packageName]);
    if (content) {
        return (react.createElement(DivOutput, { ref: messageRef, sx: styles_rootSx, onRender: handleLoad }, content));
    }
    return null;
};
/**
 * Slot component for displaying Iterable Embedded message.
 * Renders a fallback if no message is found for the slot and the fallback is provided.
 */
const IterableEmbeddedSlot = (_a) => {
    var { placementId, renderer, loader, maxMessagesCount = 1, children, onRender, onCTAClick, onError, sx } = _a, restProps = __rest(_a, ["placementId", "renderer", "loader", "maxMessagesCount", "children", "onRender", "onCTAClick", "onError", "sx"]);
    const { packageName, messages, loading } = (0,react.useContext)(IterableEmbeddedContext);
    const slotMessages = messages
        .filter((item) => item.metadata.placementId === placementId)
        .slice(0, maxMessagesCount);
    const loaderElement = typeof loader !== 'undefined' ? (loader) : (react.createElement(Skeleton_Skeleton/* default */.Z, { variant: "rectangular", width: "100%", height: "100%", animation: "wave" }));
    return (react.createElement(Box_Box/* default */.Z, Object.assign({ sx: [styles_rootSx, ...(Array.isArray(sx) ? sx : [sx])] }, restProps),
        loading && loaderElement,
        !loading &&
            (slotMessages.length > 0
                ? slotMessages.map((message) => (react.createElement(SlotEmbeddedOutput, { key: message.metadata.messageId, renderer: renderer, message: message, packageName: packageName, onCTAClick: onCTAClick, onRender: onRender, onError: onError })))
                : children)));
};
/* harmony default export */ var Embedded_IterableEmbeddedSlot = (IterableEmbeddedSlot);
//# sourceMappingURL=data:application/json;base64,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
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/Embedded/renderers/IterableSimpleBanner.js


const IterableSimpleBanner = ({ message }) => {
    var _a, _b, _c;
    const { payload, elements } = message;
    const target = ['_blank', '_self', '_parent', '_top'].includes(payload === null || payload === void 0 ? void 0 : payload.bannerTarget)
        ? payload === null || payload === void 0 ? void 0 : payload.bannerTarget
        : undefined;
    return (react.createElement(Box_Box/* default */.Z, { component: "a", href: (_b = (_a = elements === null || elements === void 0 ? void 0 : elements.defaultAction) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : '#', target: target, sx: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            flexWrap: 'wrap',
            margin: '0 auto',
            maxWidth: '100%',
            position: 'relative',
            textDecoration: 'none',
            backgroundColor: (theme) => {
                return typeof (payload === null || payload === void 0 ? void 0 : payload.backgroundColor) === 'string' && (payload === null || payload === void 0 ? void 0 : payload.backgroundColor)
                    ? payload.backgroundColor
                    : theme.palette.info.main;
            },
            textAlign: 'center',
            padding: '5px',
        } },
        react.createElement(Typography/* default */.Z, { variant: "h3", sx: {
                display: 'block',
                width: '100%',
                lineHeight: '22px',
                color: (theme) => {
                    return typeof (payload === null || payload === void 0 ? void 0 : payload.fontColor) === 'string' && (payload === null || payload === void 0 ? void 0 : payload.fontColor)
                        ? payload === null || payload === void 0 ? void 0 : payload.fontColor
                        : theme.palette.text.contrast;
                },
            } }, (_c = message === null || message === void 0 ? void 0 : message.elements) === null || _c === void 0 ? void 0 : _c.body)));
};
/* harmony default export */ var renderers_IterableSimpleBanner = (IterableSimpleBanner);
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/Embedded/renderers/index.js

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvRW1iZWRkZWQvcmVuZGVyZXJzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxPQUFPLElBQUksb0JBQW9CLEVBQUUsTUFBTSwyQkFBMkIsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgYXMgSXRlcmFibGVTaW1wbGVCYW5uZXIgfSBmcm9tICcuL0l0ZXJhYmxlU2ltcGxlQmFubmVyLmpzJztcbiJdfQ==
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/Embedded/index.js



//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvRW1iZWRkZWQvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLE9BQU8sSUFBSSx3QkFBd0IsRUFDbkMsdUJBQXVCLEdBR3hCLE1BQU0sK0JBQStCLENBQUM7QUFDdkMsT0FBTyxFQUNMLE9BQU8sSUFBSSxvQkFBb0IsR0FFaEMsTUFBTSwyQkFBMkIsQ0FBQztBQUNuQyxPQUFPLEtBQUsseUJBQXlCLE1BQU0sc0JBQXNCLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQge1xuICBkZWZhdWx0IGFzIEl0ZXJhYmxlRW1iZWRkZWRQcm92aWRlcixcbiAgSXRlcmFibGVFbWJlZGRlZENvbnRleHQsXG4gIHR5cGUgSXRlcmFibGVFbWJlZGRlZE1lc3NhZ2VQcm9wcyxcbiAgdHlwZSBJdGVyYWJsZUVtYmVkZGVkUHJvdmlkZXJQcm9wcyxcbn0gZnJvbSAnLi9JdGVyYWJsZUVtYmVkZGVkUHJvdmlkZXIuanMnO1xuZXhwb3J0IHtcbiAgZGVmYXVsdCBhcyBJdGVyYWJsZUVtYmVkZGVkU2xvdCxcbiAgdHlwZSBJdGVyYWJsZUVtYmVkZGVkU2xvdFByb3BzLFxufSBmcm9tICcuL0l0ZXJhYmxlRW1iZWRkZWRTbG90LmpzJztcbmV4cG9ydCAqIGFzIEl0ZXJhYmxlRW1iZWRkZWRSZW5kZXJlcnMgZnJvbSAnLi9yZW5kZXJlcnMvaW5kZXguanMnO1xuZXhwb3J0IHR5cGUgeyBFbWJlZGRlZE1lc3NhZ2VSZW5kZXJlciwgRW1iZWRkZWRNZXNzYWdlUmVuZGVyZXJQcm9wcyB9IGZyb20gJy4vdHlwZXMuanMnO1xuIl19
// EXTERNAL MODULE: ./node_modules/@iterable/web-sdk/dist/inapp/inapp.js
var inapp = __webpack_require__(59845);
var inapp_namespaceObject = /*#__PURE__*/__webpack_require__.t(inapp, 2);
// EXTERNAL MODULE: ./node_modules/@iterable/web-sdk/dist/inapp/types.js
var types = __webpack_require__(7665);
var types_namespaceObject = /*#__PURE__*/__webpack_require__.t(types, 2);
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/InApp/IterableInAppProvider.js




// Work around iterable import issue.
const { getInAppMessages } = inapp_namespaceObject;
const { initialize: IterableInAppProvider_initialize } = authorization_namespaceObject;
const { DisplayOptions } = types_namespaceObject;
/** Context for Iterable In-App slots and messages. */
const IterableInAppProvider_IterableInAppContext = (0,react.createContext)({
    /** The messages that will be passed to consuming slots. */
    messages: [],
    /** Context is currently retrieving messages from Iterable. */
    loading: false,
});
/**
 * The Iterable In-App Provider is a provider component that interfaces with
 * [the Iterable Web SDK.](https://github.com/Iterable/iterable-web-sdk) for
 * [In-App messages](https://support.iterable.com/hc/en-us/articles/360035538391-In-App-Messages-Overview).
 * It handles querying Iterable for In-App messages for the current user and saving them to
 * its context provider, where it is used in conjunction with the `IterableInAppSlot` or
 * `IterableInAppModalSlot` component to render an In-App message intended for its slot.
 */
const IterableInAppProvider = ({ apiKey, packageName, userId, children, disabled = false, onJwtRequest, onError, retrievalCount = 10, }) => {
    const [messages, setMessages] = useState([]);
    const [called, setCalled] = useState(false);
    const [loading, setLoading] = useState(false);
    /** Retrieves In-App messages from Iterable. */
    const getMessages = useCallback(() => {
        setLoading(true);
        const { setUserID } = IterableInAppProvider_initialize(apiKey, onJwtRequest);
        setUserID(userId)
            .then(() => {
            getInAppMessages({
                count: retrievalCount,
                packageName,
            }, { display: DisplayOptions.Deferred })
                .request()
                .then(({ data }) => {
                const { inAppMessages } = data;
                if (Array.isArray(inAppMessages)) {
                    setMessages(inAppMessages.map((message) => {
                        var _a, _b, _c, _d;
                        return (Object.assign(Object.assign({}, message), { id: message.messageId, html: (_b = (_a = message.content) === null || _a === void 0 ? void 0 : _a.html) !== null && _b !== void 0 ? _b : '', slotName: (_d = (_c = message.customPayload) === null || _c === void 0 ? void 0 : _c.slot) !== null && _d !== void 0 ? _d : '' }));
                    }));
                }
            })
                .catch((error) => {
                onError === null || onError === void 0 ? void 0 : onError(error);
            })
                .finally(() => {
                setCalled(true);
                setLoading(false);
            });
        })
            .catch((error) => {
            setCalled(true);
            setLoading(false);
            onError === null || onError === void 0 ? void 0 : onError(error);
        });
    }, [apiKey, onJwtRequest, onError, userId, packageName, retrievalCount]);
    useEffect(() => {
        if (!disabled && messages.length === 0 && !loading && !called) {
            getMessages();
        }
    }, [getMessages, messages, disabled, loading, called]);
    return useMemo(() => (React.createElement(IterableInAppProvider_IterableInAppContext.Provider, { value: { packageName, loading, messages } }, children)), [children, loading, packageName, messages]);
};
/* harmony default export */ var InApp_IterableInAppProvider = ((/* unused pure expression or super */ null && (IterableInAppProvider)));
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/InApp/slots/enums.js
var enums_IterableInAppSlotName;
(function (IterableInAppSlotName) {
    IterableInAppSlotName["Modal"] = "modal";
})(enums_IterableInAppSlotName || (enums_IterableInAppSlotName = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvSW5BcHAvc2xvdHMvZW51bXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVkscUJBRVg7QUFGRCxXQUFZLHFCQUFxQjtJQUMvQix3Q0FBZSxDQUFBO0FBQ2pCLENBQUMsRUFGVyxxQkFBcUIsS0FBckIscUJBQXFCLFFBRWhDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGVudW0gSXRlcmFibGVJbkFwcFNsb3ROYW1lIHtcbiAgTW9kYWwgPSAnbW9kYWwnLFxufVxuIl19
// EXTERNAL MODULE: ./node_modules/@iterable/web-sdk/dist/events/inapp/events.js
var inapp_events = __webpack_require__(88133);
var inapp_events_namespaceObject = /*#__PURE__*/__webpack_require__.t(inapp_events, 2);
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/InApp/slots/SlotInAppOutput.js




// Work around iterable import issue.
const { trackInAppClick, trackInAppOpen, trackInAppConsume } = inapp_events_namespaceObject;
/**
 * Renders the Iterable In-App Slot either within a container or
 * as an iframe depending on type. If the slot is not a string
 * or an iframe, this will return as null.
 */
const SlotInAppOutput_SlotInAppOutput = ({ packageName, message, onRender, onCTAClick, onError, }) => {
    const iFrameRef = useRef(null);
    const divRef = useRef(null);
    const messageRef = typeof message.html === 'string' ? iFrameRef : divRef;
    const getTrackPayload = useCallback(() => {
        var _a;
        return ({
            messageId: (_a = message.id) !== null && _a !== void 0 ? _a : '',
            createdAt: new Date().getTime(),
            deviceInfo: {
                appPackageName: packageName !== null && packageName !== void 0 ? packageName : '',
            },
        });
    }, [packageName, message.id]);
    const errorHandler = useCallback((error) => {
        var _a, _b;
        /* istanbul ignore next */
        onError === null || onError === void 0 ? void 0 : onError(Object.assign(Object.assign({}, (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data), { statusCode: (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status }));
    }, [onError]);
    /** Triggers on CTA click handler. */
    /* istanbul ignore next */
    const triggerOnCTAClick = useCallback((event) => {
        // We can't test this because the iframe is sandboxed, can't target buttons/links in jest.
        /* istanbul ignore next */
        onCTAClick === null || onCTAClick === void 0 ? void 0 : onCTAClick(message, event);
        return trackInAppClick(getTrackPayload()).catch(errorHandler);
    }, [message, onCTAClick, errorHandler, getTrackPayload]);
    /** Triggers on render handler. */
    const triggerOnRender = useCallback(() => {
        /* istanbul ignore next */
        onRender === null || onRender === void 0 ? void 0 : onRender(message);
        return trackInAppOpen(getTrackPayload()).catch(errorHandler);
    }, [errorHandler, getTrackPayload, message, onRender]);
    /** Triggers on Consume handler. */
    const triggerOnConsume = useCallback(() => trackInAppConsume(getTrackPayload()).catch(errorHandler), [errorHandler, getTrackPayload]);
    /** Adds event listeners to buttons and anchors in message. */
    // We can't test this because the iframe is sandboxed, can't target buttons/links in jest.
    /* istanbul ignore next */
    const handleLoad = useCallback(() => {
        var _a, _b, _c;
        // The message is a string, it will be put in an iframe, and we'll request the buttons and anchors.
        if (messageRef.current instanceof HTMLIFrameElement) {
            (_a = messageRef.current.contentWindow) === null || _a === void 0 ? void 0 : _a.document.body.querySelectorAll('a, button').forEach((el) => {
                // We can't test this because the iframe is sandboxed.
                /* istanbul ignore next */
                el.addEventListener('click', triggerOnCTAClick);
            });
        }
        // The message is an iframe, we'll request the buttons and anchors after finding the iframe element.
        if (messageRef.current instanceof HTMLDivElement) {
            (_c = (_b = messageRef.current
                .querySelector('iframe')) === null || _b === void 0 ? void 0 : _b.contentWindow) === null || _c === void 0 ? void 0 : _c.document.body.querySelectorAll('a, button').forEach((el) => {
                // We can't test this because the iframe is sandboxed.
                /* istanbul ignore next */
                el.addEventListener('click', triggerOnCTAClick);
            });
        }
        return Promise.all([triggerOnRender(), triggerOnConsume()]);
    }, [messageRef, triggerOnCTAClick, triggerOnRender, triggerOnConsume]);
    useEffect(() => {
        if (messageRef.current instanceof HTMLDivElement) {
            handleLoad();
        }
    }, [handleLoad, messageRef]);
    if (typeof (message === null || message === void 0 ? void 0 : message.html) === 'string') {
        return (React.createElement(Box, { component: "iframe", sx: {
                border: '0 none',
                width: '100%',
                height: '100%',
            }, ref: iFrameRef, onLoad: handleLoad, srcDoc: message.html, title: message.slotName }));
    }
    if (typeof (message === null || message === void 0 ? void 0 : message.html) === 'object') {
        return (React.createElement(Box, { ref: divRef, sx: rootSx, 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: { __html: message === null || message === void 0 ? void 0 : message.html.outerHTML } }));
    }
    /* istanbul ignore next (unreachable) */
    return null;
};
/* harmony default export */ var slots_SlotInAppOutput = ((/* unused pure expression or super */ null && (SlotInAppOutput_SlotInAppOutput)));
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/InApp/slots/IterableInAppSlot.js
var IterableInAppSlot_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





/**
 * Slot component for displaying Iterable In-App message.
 * Renders a fallback if no message is found for the slot and the fallback is provided.
 */
const IterableInAppSlot = (_a) => {
    var { slotName, loader, children, onRender, onCTAClick, onError, sx } = _a, restProps = IterableInAppSlot_rest(_a, ["slotName", "loader", "children", "onRender", "onCTAClick", "onError", "sx"]);
    const { packageName, messages, loading } = useContext(IterableInAppContext);
    const message = messages.find((item) => item.slotName === slotName);
    const loaderElement = typeof loader !== 'undefined' ? (loader) : (React.createElement(Skeleton, { variant: "rectangular", width: "100%", height: "100%", animation: "wave" }));
    return (React.createElement(Box, Object.assign({ sx: [rootSx, ...(Array.isArray(sx) ? sx : [sx])] }, restProps),
        loading && loaderElement,
        !loading &&
            (message ? (React.createElement(SlotInAppOutput, { message: message, packageName: packageName !== null && packageName !== void 0 ? packageName : '', onCTAClick: onCTAClick, onRender: onRender, onError: onError })) : (children))));
};
/* harmony default export */ var slots_IterableInAppSlot = ((/* unused pure expression or super */ null && (IterableInAppSlot)));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSXRlcmFibGVJbkFwcFNsb3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvSW5BcHAvc2xvdHMvSXRlcmFibGVJbkFwcFNsb3QudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxLQUFLLEVBQUUsRUFBRSxVQUFVLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFDMUMsT0FBTyxFQUFFLFFBQVEsRUFBRSxHQUFHLEVBQWlCLE1BQU0sZUFBZSxDQUFDO0FBQzdELE9BQU8sRUFBRSxvQkFBb0IsRUFBa0MsTUFBTSw2QkFBNkIsQ0FBQztBQUNuRyxPQUFPLGVBQWUsTUFBTSxzQkFBc0IsQ0FBQztBQUNuRCxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFhekM7OztHQUdHO0FBQ0gsTUFBTSxpQkFBaUIsR0FBRyxDQUFDLEVBU0YsRUFBRSxFQUFFO1FBVEYsRUFDekIsUUFBUSxFQUNSLE1BQU0sRUFDTixRQUFRLEVBQ1IsUUFBUSxFQUNSLFVBQVUsRUFDVixPQUFPLEVBQ1AsRUFBRSxPQUVxQixFQURwQixTQUFTLGNBUmEsNkVBUzFCLENBRGE7SUFFWixNQUFNLEVBQUUsV0FBVyxFQUFFLFFBQVEsRUFBRSxPQUFPLEVBQUUsR0FBRyxVQUFVLENBQUMsb0JBQW9CLENBQUMsQ0FBQztJQUU1RSxNQUFNLE9BQU8sR0FBRyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxJQUFJLENBQUMsUUFBUSxLQUFLLFFBQVEsQ0FBQyxDQUFDO0lBQ3BFLE1BQU0sYUFBYSxHQUNqQixPQUFPLE1BQU0sS0FBSyxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQzlCLE1BQU0sQ0FDUCxDQUFDLENBQUMsQ0FBQyxDQUNGLG9CQUFDLFFBQVEsSUFBQyxPQUFPLEVBQUMsYUFBYSxFQUFDLEtBQUssRUFBQyxNQUFNLEVBQUMsTUFBTSxFQUFDLE1BQU0sRUFBQyxTQUFTLEVBQUMsTUFBTSxHQUFHLENBQy9FLENBQUM7SUFFSixPQUFPLENBQ0wsb0JBQUMsR0FBRyxrQkFBQyxFQUFFLEVBQUUsQ0FBQyxNQUFNLEVBQUUsR0FBRyxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQU0sU0FBUztRQUNqRSxPQUFPLElBQUksYUFBYTtRQUN4QixDQUFDLE9BQU87WUFDUCxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FDVCxvQkFBQyxlQUFlLElBQ2QsT0FBTyxFQUFFLE9BQU8sRUFDaEIsV0FBVyxFQUFFLFdBQVcsYUFBWCxXQUFXLGNBQVgsV0FBVyxHQUErQyxFQUFFLEVBQ3pFLFVBQVUsRUFBRSxVQUFVLEVBQ3RCLFFBQVEsRUFBRSxRQUFRLEVBQ2xCLE9BQU8sRUFBRSxPQUFPLEdBQ2hCLENBQ0gsQ0FBQyxDQUFDLENBQUMsQ0FDRixRQUFRLENBQ1QsQ0FBQyxDQUNBLENBQ1AsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGVBQWUsaUJBQWlCLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IFNrZWxldG9uLCBCb3gsIHR5cGUgQm94UHJvcHMgfSBmcm9tICdAbXVpL21hdGVyaWFsJztcbmltcG9ydCB7IEl0ZXJhYmxlSW5BcHBDb250ZXh0LCB0eXBlIEl0ZXJhYmxlSW5BcHBNZXNzYWdlUHJvcHMgfSBmcm9tICcuLi9JdGVyYWJsZUluQXBwUHJvdmlkZXIuanMnO1xuaW1wb3J0IFNsb3RJbkFwcE91dHB1dCBmcm9tICcuL1Nsb3RJbkFwcE91dHB1dC5qcyc7XG5pbXBvcnQgeyByb290U3ggfSBmcm9tICcuLi8uLi9zdHlsZXMuanMnO1xuaW1wb3J0IHsgSXRlcmFibGVTbG90QmFzZSB9IGZyb20gJy4uLy4uL3R5cGVzLmpzJztcblxuLyoqXG4gKiBUaGUgcHJvcHMgdGhhdCB3aWxsIGJlIHBhc3NlZCB0byB0aGUgSW4tQXBwIHNsb3QuXG4gKi9cbmV4cG9ydCBpbnRlcmZhY2UgSXRlcmFibGVJbkFwcFNsb3RQcm9wc1xuICBleHRlbmRzIEl0ZXJhYmxlU2xvdEJhc2U8SXRlcmFibGVJbkFwcE1lc3NhZ2VQcm9wcz4sXG4gICAgT21pdDxCb3hQcm9wcywgJ29uRXJyb3InPiB7XG4gIC8qKiBUaGUgbmFtZSBvZiB0aGUgc2xvdCwgd2hpY2ggd2lsbCBiZSB1c2VkIHRvIHBhaXIgbWVzc2FnZXMgdG8gaXQncyBpbnRlbmRlZCBvdXRwdXQuICovXG4gIHNsb3ROYW1lOiBzdHJpbmc7XG59XG5cbi8qKlxuICogU2xvdCBjb21wb25lbnQgZm9yIGRpc3BsYXlpbmcgSXRlcmFibGUgSW4tQXBwIG1lc3NhZ2UuXG4gKiBSZW5kZXJzIGEgZmFsbGJhY2sgaWYgbm8gbWVzc2FnZSBpcyBmb3VuZCBmb3IgdGhlIHNsb3QgYW5kIHRoZSBmYWxsYmFjayBpcyBwcm92aWRlZC5cbiAqL1xuY29uc3QgSXRlcmFibGVJbkFwcFNsb3QgPSAoe1xuICBzbG90TmFtZSxcbiAgbG9hZGVyLFxuICBjaGlsZHJlbixcbiAgb25SZW5kZXIsXG4gIG9uQ1RBQ2xpY2ssXG4gIG9uRXJyb3IsXG4gIHN4LFxuICAuLi5yZXN0UHJvcHNcbn06IEl0ZXJhYmxlSW5BcHBTbG90UHJvcHMpID0+IHtcbiAgY29uc3QgeyBwYWNrYWdlTmFtZSwgbWVzc2FnZXMsIGxvYWRpbmcgfSA9IHVzZUNvbnRleHQoSXRlcmFibGVJbkFwcENvbnRleHQpO1xuXG4gIGNvbnN0IG1lc3NhZ2UgPSBtZXNzYWdlcy5maW5kKChpdGVtKSA9PiBpdGVtLnNsb3ROYW1lID09PSBzbG90TmFtZSk7XG4gIGNvbnN0IGxvYWRlckVsZW1lbnQgPVxuICAgIHR5cGVvZiBsb2FkZXIgIT09ICd1bmRlZmluZWQnID8gKFxuICAgICAgbG9hZGVyXG4gICAgKSA6IChcbiAgICAgIDxTa2VsZXRvbiB2YXJpYW50PVwicmVjdGFuZ3VsYXJcIiB3aWR0aD1cIjEwMCVcIiBoZWlnaHQ9XCIxMDAlXCIgYW5pbWF0aW9uPVwid2F2ZVwiIC8+XG4gICAgKTtcblxuICByZXR1cm4gKFxuICAgIDxCb3ggc3g9e1tyb290U3gsIC4uLihBcnJheS5pc0FycmF5KHN4KSA/IHN4IDogW3N4XSldfSB7Li4ucmVzdFByb3BzfT5cbiAgICAgIHtsb2FkaW5nICYmIGxvYWRlckVsZW1lbnR9XG4gICAgICB7IWxvYWRpbmcgJiZcbiAgICAgICAgKG1lc3NhZ2UgPyAoXG4gICAgICAgICAgPFNsb3RJbkFwcE91dHB1dFxuICAgICAgICAgICAgbWVzc2FnZT17bWVzc2FnZX1cbiAgICAgICAgICAgIHBhY2thZ2VOYW1lPXtwYWNrYWdlTmFtZSA/PyAvKiBpc3RhbmJ1bCBpZ25vcmUgbmV4dCAoZGVmYXVsdCB2YWx1ZSkgKi8gJyd9XG4gICAgICAgICAgICBvbkNUQUNsaWNrPXtvbkNUQUNsaWNrfVxuICAgICAgICAgICAgb25SZW5kZXI9e29uUmVuZGVyfVxuICAgICAgICAgICAgb25FcnJvcj17b25FcnJvcn1cbiAgICAgICAgICAvPlxuICAgICAgICApIDogKFxuICAgICAgICAgIGNoaWxkcmVuXG4gICAgICAgICkpfVxuICAgIDwvQm94PlxuICApO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgSXRlcmFibGVJbkFwcFNsb3Q7XG4iXX0=
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/InApp/slots/IterableInAppModalSlot.js
var IterableInAppModalSlot_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






/**
 * Slot component for displaying Iterable In-App message in a modal.
 */
const IterableInAppModalSlot = (_a) => {
    var _b, _c, _d, _e;
    var { slotName = IterableInAppSlotName.Modal, onRender, onCTAClick, onError, sx } = _a, restProps = IterableInAppModalSlot_rest(_a, ["slotName", "onRender", "onCTAClick", "onError", "sx"]);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState();
    const { packageName, messages, loading } = useContext(IterableInAppContext);
    useEffect(() => {
        setMessage(messages.find((item) => item.slotName === slotName));
    }, [messages, slotName]);
    useEffect(() => {
        if (message)
            setOpen(true);
    }, [message]);
    return !loading && message ? (React.createElement(Modal, Object.assign({ open: open, onClose: () => setOpen(false), sx: [
            { '.MuiDialogContentText-root': { display: 'flex' } },
            ...(Array.isArray(sx) ? sx : [sx]),
        ] }, restProps),
        React.createElement(Box, { className: "iterable-in-app-modal-content", sx: {
                flex: 1,
                minHeight: (_c = (_b = message.customPayload) === null || _b === void 0 ? void 0 : _b.minHeight) !== null && _c !== void 0 ? _c : '300px',
                minWidth: (_e = (_d = message.customPayload) === null || _d === void 0 ? void 0 : _d.minWidth) !== null && _e !== void 0 ? _e : '325px',
                position: 'relative',
                overflow: 'hidden',
            } },
            React.createElement(SlotInAppOutput, { message: message, packageName: packageName !== null && packageName !== void 0 ? packageName : '', onCTAClick: onCTAClick, onRender: onRender, onError: onError })))) : null;
};
/* harmony default export */ var slots_IterableInAppModalSlot = ((/* unused pure expression or super */ null && (IterableInAppModalSlot)));
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/InApp/slots/index.js



//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvSW5BcHAvc2xvdHMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLHFCQUFxQixFQUFFLE1BQU0sWUFBWSxDQUFDO0FBQ25ELE9BQU8sRUFBRSxPQUFPLElBQUksaUJBQWlCLEVBQStCLE1BQU0sd0JBQXdCLENBQUM7QUFDbkcsT0FBTyxFQUNMLE9BQU8sSUFBSSxzQkFBc0IsR0FFbEMsTUFBTSw2QkFBNkIsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IEl0ZXJhYmxlSW5BcHBTbG90TmFtZSB9IGZyb20gJy4vZW51bXMuanMnO1xuZXhwb3J0IHsgZGVmYXVsdCBhcyBJdGVyYWJsZUluQXBwU2xvdCwgdHlwZSBJdGVyYWJsZUluQXBwU2xvdFByb3BzIH0gZnJvbSAnLi9JdGVyYWJsZUluQXBwU2xvdC5qcyc7XG5leHBvcnQge1xuICBkZWZhdWx0IGFzIEl0ZXJhYmxlSW5BcHBNb2RhbFNsb3QsXG4gIHR5cGUgSXRlcmFibGVJbkFwcE1vZGFsU2xvdFByb3BzLFxufSBmcm9tICcuL0l0ZXJhYmxlSW5BcHBNb2RhbFNsb3QuanMnO1xuIl19
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/InApp/index.js


//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvSW5BcHAvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUNMLE9BQU8sSUFBSSxxQkFBcUIsRUFDaEMsb0JBQW9CLEdBR3JCLE1BQU0sNEJBQTRCLENBQUM7QUFDcEMsT0FBTyxFQUNMLGlCQUFpQixFQUVqQixzQkFBc0IsRUFFdEIscUJBQXFCLEdBQ3RCLE1BQU0sa0JBQWtCLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQge1xuICBkZWZhdWx0IGFzIEl0ZXJhYmxlSW5BcHBQcm92aWRlcixcbiAgSXRlcmFibGVJbkFwcENvbnRleHQsXG4gIHR5cGUgSXRlcmFibGVJbkFwcE1lc3NhZ2VQcm9wcyxcbiAgdHlwZSBJdGVyYWJsZUluQXBwUHJvdmlkZXJQcm9wcyxcbn0gZnJvbSAnLi9JdGVyYWJsZUluQXBwUHJvdmlkZXIuanMnO1xuZXhwb3J0IHtcbiAgSXRlcmFibGVJbkFwcFNsb3QsXG4gIHR5cGUgSXRlcmFibGVJbkFwcFNsb3RQcm9wcyxcbiAgSXRlcmFibGVJbkFwcE1vZGFsU2xvdCxcbiAgdHlwZSBJdGVyYWJsZUluQXBwTW9kYWxTbG90UHJvcHMsXG4gIEl0ZXJhYmxlSW5BcHBTbG90TmFtZSxcbn0gZnJvbSAnLi9zbG90cy9pbmRleC5qcyc7XG4iXX0=
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(63357);
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/graphql/mutations.js

const GET_ITERABLE_TOKEN = lib/* gql */.Ps `
  mutation CreateIterableToken($userUuid: ID!) {
    createIterableToken(userUUID: $userUuid) {
      ... on CreateIterableTokenSuccess {
        encodedJwt
      }
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibXV0YXRpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dyYXBocWwvbXV0YXRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSw4QkFBOEIsQ0FBQztBQUVuRCxNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRyxHQUFHLENBQUE7Ozs7Ozs7O0NBUXBDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBncWwgfSBmcm9tICdAYXBvbGxvL2NsaWVudC9jb3JlL2luZGV4LmpzJztcblxuZXhwb3J0IGNvbnN0IEdFVF9JVEVSQUJMRV9UT0tFTiA9IGdxbGBcbiAgbXV0YXRpb24gQ3JlYXRlSXRlcmFibGVUb2tlbigkdXNlclV1aWQ6IElEISkge1xuICAgIGNyZWF0ZUl0ZXJhYmxlVG9rZW4odXNlclVVSUQ6ICR1c2VyVXVpZCkge1xuICAgICAgLi4uIG9uIENyZWF0ZUl0ZXJhYmxlVG9rZW5TdWNjZXNzIHtcbiAgICAgICAgZW5jb2RlZEp3dFxuICAgICAgfVxuICAgIH1cbiAgfVxuYDtcbiJdfQ==
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/hooks/useOnJwtRequest.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



/**
 * A hook that returns a function that fetches a JWT from the server.
 *
 * @param userId The user's ID or UUID.
 */
const useOnJwtRequest = (userId) => {
    const [fetchJWT] = (0,useMutation/* useMutation */.D)(GET_ITERABLE_TOKEN);
    return (0,react.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const results = yield fetchJWT({ variables: { userUuid: userId.toString() } });
        return ((_c = (_b = (_a = results.data) === null || _a === void 0 ? void 0 : _a.createIterableToken) === null || _b === void 0 ? void 0 : _b.encodedJwt) !== null && _c !== void 0 ? _c : '');
    }), [fetchJWT, userId]);
};
/* harmony default export */ var hooks_useOnJwtRequest = (useOnJwtRequest);
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/hooks/index.js

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sSUFBSSxlQUFlLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgYXMgdXNlT25Kd3RSZXF1ZXN0IH0gZnJvbSAnLi91c2VPbkp3dFJlcXVlc3QuanMnO1xuIl19
;// CONCATENATED MODULE: ./node_modules/@care/iterable-display/dist/index.js



//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxxQkFBcUIsQ0FBQztBQUNwQyxjQUFjLGtCQUFrQixDQUFDO0FBQ2pDLGNBQWMsa0JBQWtCLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgKiBmcm9tICcuL0VtYmVkZGVkL2luZGV4LmpzJztcbmV4cG9ydCAqIGZyb20gJy4vSW5BcHAvaW5kZXguanMnO1xuZXhwb3J0ICogZnJvbSAnLi9ob29rcy9pbmRleC5qcyc7XG4iXX0=

/***/ }),

/***/ 24678:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "clear": function() { return /* binding */ clear; },
/* harmony export */   "createStore": function() { return /* binding */ createStore; },
/* harmony export */   "del": function() { return /* binding */ del; },
/* harmony export */   "delMany": function() { return /* binding */ delMany; },
/* harmony export */   "entries": function() { return /* binding */ entries; },
/* harmony export */   "get": function() { return /* binding */ get; },
/* harmony export */   "getMany": function() { return /* binding */ getMany; },
/* harmony export */   "keys": function() { return /* binding */ keys; },
/* harmony export */   "promisifyRequest": function() { return /* binding */ promisifyRequest; },
/* harmony export */   "set": function() { return /* binding */ set; },
/* harmony export */   "setMany": function() { return /* binding */ setMany; },
/* harmony export */   "update": function() { return /* binding */ update; },
/* harmony export */   "values": function() { return /* binding */ values; }
/* harmony export */ });
function promisifyRequest(request) {
    return new Promise((resolve, reject) => {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = () => resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = () => reject(request.error);
    });
}
function createStore(dbName, storeName) {
    let dbp;
    const getDB = () => {
        if (dbp)
            return dbp;
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = () => request.result.createObjectStore(storeName);
        dbp = promisifyRequest(request);
        dbp.then((db) => {
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = () => (dbp = undefined);
        }, () => { });
        return dbp;
    };
    return (txMode, callback) => getDB().then((db) => callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let defaultGetStoreFunc;
function defaultGetStore() {
    if (!defaultGetStoreFunc) {
        defaultGetStoreFunc = createStore('keyval-store', 'keyval');
    }
    return defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function get(key, customStore = defaultGetStore()) {
    return customStore('readonly', (store) => promisifyRequest(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function set(key, value, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        store.put(value, key);
        return promisifyRequest(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function setMany(entries, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        entries.forEach((entry) => store.put(entry[1], entry[0]));
        return promisifyRequest(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function getMany(keys, customStore = defaultGetStore()) {
    return customStore('readonly', (store) => Promise.all(keys.map((key) => promisifyRequest(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function update(key, updater, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => 
    // Need to create the promise manually.
    // If I try to chain promises, the transaction closes in browsers
    // that use a promise polyfill (IE10/11).
    new Promise((resolve, reject) => {
        store.get(key).onsuccess = function () {
            try {
                store.put(updater(this.result), key);
                resolve(promisifyRequest(store.transaction));
            }
            catch (err) {
                reject(err);
            }
        };
    }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function del(key, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        store.delete(key);
        return promisifyRequest(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function delMany(keys, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        keys.forEach((key) => store.delete(key));
        return promisifyRequest(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function clear(customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        store.clear();
        return promisifyRequest(store.transaction);
    });
}
function eachCursor(store, callback) {
    store.openCursor().onsuccess = function () {
        if (!this.result)
            return;
        callback(this.result);
        this.result.continue();
    };
    return promisifyRequest(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function keys(customStore = defaultGetStore()) {
    return customStore('readonly', (store) => {
        // Fast path for modern browsers
        if (store.getAllKeys) {
            return promisifyRequest(store.getAllKeys());
        }
        const items = [];
        return eachCursor(store, (cursor) => items.push(cursor.key)).then(() => items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function values(customStore = defaultGetStore()) {
    return customStore('readonly', (store) => {
        // Fast path for modern browsers
        if (store.getAll) {
            return promisifyRequest(store.getAll());
        }
        const items = [];
        return eachCursor(store, (cursor) => items.push(cursor.value)).then(() => items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function entries(customStore = defaultGetStore()) {
    return customStore('readonly', (store) => {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) {
            return Promise.all([
                promisifyRequest(store.getAllKeys()),
                promisifyRequest(store.getAll()),
            ]).then(([keys, values]) => keys.map((key, i) => [key, values[i]]));
        }
        const items = [];
        return customStore('readonly', (store) => eachCursor(store, (cursor) => items.push([cursor.key, cursor.value])).then(() => items));
    });
}




/***/ })

}]);